<template>
  <div class="user-programmi-page">
        <transition-group name="toast" tag="div" class="toast-stack">
          <div
            v-for="toast in toasts"
            :key="toast.id"
            class="toast"
            :class="`toast--${toast.type}`"
          >
            <span class="toast-message">{{ toast.message }}</span>
            <button type="button" class="toast-close" @click="dismissToast(toast.id)">×</button>
          </div>
        </transition-group>

        <div class="titolo-card">
          <h1>Gestione Percorsi</h1>
          <h3>Qui trovi tutti i programmi dell’utente con i relativi step.</h3>
        </div>

        <div class="flex-gap">
          <!--<button @click="showModal = true" class="create-user-button">
            Crea Programma
          </button>-->

      <button @click="openAddStepModal" class="create-user-button staff-button-positive">
        Aggiungi Step Manuale
      </button>

      <button @click="openConsulenzeModal" class="create-user-button staff-button-positive">
        Crea consulenze
      </button>

      <button v-if="canCreatePercorso" @click="openCreatePercorsoModal" class="create-user-button staff-button-positive">
        Crea percorso
      </button>

      <button
        @click="refreshProgramData()"
        class="create-user-button staff-button-neutral"
        :disabled="loading"
      >
        {{ loading ? 'Aggiorno...' : 'Aggiorna dati' }}
      </button>

    </div>

        <!-- Prossime notifiche 10/24/40 giorni -->
        <section class="reminders card">
          <div
            class="card-head"
            role="button"
            tabindex="0"
            @click="upcomingRemindersOpen = !upcomingRemindersOpen"
            @keydown.enter="upcomingRemindersOpen = !upcomingRemindersOpen"
            @keydown.space.prevent="upcomingRemindersOpen = !upcomingRemindersOpen"
          >
            <div class="head-left">
              <div class="title">Prossime notifiche</div>
              <div class="sub muted" v-if="hasUpcomingReminders">
                {{ pendingRemindersCount }} {{ reminderCountLabel }}
              </div>
              <div class="sub muted" v-else>{{ reminderEmptyLabel }}</div>
            </div>
            <div class="head-right">
              <div class="reminders-toggle" @click.stop @mousedown.stop>
                <span class="reminders-toggle__label">Mostra storiche</span>
                <label class="toggle-switch toggle-switch--small">
                  <input type="checkbox" v-model="showHistoricalReminders" />
                  <span class="toggle-slider"></span>
                </label>
              </div>
              <span class="material-icons">
                {{ upcomingRemindersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </div>
          </div>

          <div v-if="upcomingRemindersOpen" class="card-body reminders-body">
            <div v-if="!hasUpcomingReminders" class="muted">Nessuna notifica prevista.</div>

            <div v-else class="reminders-inner">
              <table class="reminders-table">
                <thead>
                  <tr>
                    <th>Data invio</th>
                    <th>Programma</th>
                    <th>Reminder</th>
                    <th>Stato</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in visibleReminders" :key="item.key">
                    <td>
                      <div class="mono" style="font-weight:700">{{ formatDateOnly(item.dueAt) || '—' }}</div>
                      <small class="muted">{{ reminderTimingLabel(item) }}</small>
                    </td>
                    <td>
                      <div class="mono" style="font-weight:700">{{ item.programTitle || 'Programma' }}</div>
                      <small class="muted">
                        {{ item.stepName || 'consegna programmi' }}
                        <span v-if="item.sequenceLabel"> · #{{ item.sequenceLabel }}</span>
                      </small>
                    </td>
                    <td class="reminder-type">{{ item.typeLabel }}</td>
                    <td>
                      <span class="reminder-badge" :class="reminderBadgeClass(item)">
                        {{ reminderStatusLabel(item) }}
                      </span>
                    </td>
                    <td>
                      <div class="reminder-actions">
                        <template v-if="item.status === 'sent'">
                          <span class="reminder-tag-sent">Inviata</span>
                        </template>
                        <template v-else-if="item.blockedByCheck">
                          <span class="muted">Check completato</span>
                        </template>
                        <template v-else-if="!item.notificationsOn">
                          <span class="muted">Attiva notifiche percorso</span>
                        </template>
                        <template v-else>
                          <button
                            type="button"
                            class="reminder-btn primary staff-button-positive"
                            @click="scheduleReminderNextRun(item)"
                            :disabled="!!suppressingReminder[item.key + '_schedule']"
                            v-if="item.daysDiff < 0 && !item.sentAt && !item.blocked && !item.resumeAt"
                          >
                            {{ suppressingReminder[item.key + '_schedule'] ? 'Programmo…' : 'Programma prossimo ciclo' }}
                          </button>
                          <button
                            type="button"
                            class="reminder-btn"
                            @click="toggleReminderBlock(item)"
                            :disabled="!!suppressingReminder[item.key]"
                          >
                            {{
                              suppressingReminder[item.key]
                                ? (item.blocked ? 'Sblocco…' : 'Blocco…')
                                : (item.blocked ? 'Sblocca e invia' : 'Blocca invio')
                            }}
                          </button>
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <!-- Consulenze (ora derivate dagli step "consulenza" dei percorsi) -->
        <section class="consulenze-box card">
          <button class="card-head" @click="toggleConsulenze">
            <div class="head-left">
              <div class="title">Consulenze {{ consulenzeDone }}/{{ consulenzeTotal }}</div>
              <div class="sub muted">
                {{ consulenzeRows.length }} step consulenza totali
              </div>
            </div>
            <div class="head-right">
              <span class="material-icons">
                {{ consulenzeOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </div>
          </button>

          <div v-if="consulenzeOpen" class="card-body">
            <div class="consulenze-table-wrap">
              <table class="consulenze-table">
                <thead>
                  <tr>
                    <th>Programma</th>
                    <th>Tipo</th>
                    <th>Status</th>
                    <th>Scadenza</th>
                    <th class="consulenze-actions-col">Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in consulenzeRows"
                    :key="row.rowId"
                    :class="{ 'consulenze-row--locked': isPercorsoLocked(row.percorso) }"
                  >
                    <td class="consulenze-summary-cell consulenze-summary-cell--program">
                      <div class="mono" style="font-weight:600">{{ row.percorsoTitle || 'Programma' }}</div>
                      <small class="muted">
                        {{ row.productName || '—' }}
                        <span v-if="row.sequenceIndex"> · #{{ row.sequenceIndex }}/{{ row.sequenceTotal || 1 }}</span>
                      </small>
                    </td>

                    <td class="consulenze-summary-cell">
                      <span class="consulenza-pill" :class="consulenzaTypeClass(row.consulenzaType)">
                        {{ row.consulenzaType || '—' }}
                      </span>
                    </td>

                    <td class="consulenze-summary-cell">
                      <div class="consulenze-status-stack">
                        <span class="consulenza-pill" :class="consulenzaStatusClass(row.consulenzaStatus)">
                          {{ normalizeConsulenzaStatus(row.consulenzaStatus) }}
                        </span>
                        <small class="muted">
                          <template v-if="row.doneAt">Effettuata {{ formatDateOnly(row.doneAt) }}</template>
                          <template v-else-if="normalizeConsulenzaStatus(row.consulenzaStatus) === 'Scalata' && row.scalataAt">Scalata {{ formatDateOnly(row.scalataAt) }}</template>
                          <template v-else-if="row.plannedAt">Prevista {{ formatDateOnly(row.plannedAt) }}</template>
                          <template v-else>Nessuna data impostata</template>
                        </small>
                      </div>
                    </td>

                    <td class="consulenze-summary-cell">
                      <div v-if="row.expireAt" class="date-cell">
                        <span class="date-cell__date">{{ formatDateOnly(row.expireAt) }}</span>
                      </div>
                      <span v-else>—</span>
                    </td>

                    <td class="consulenze-summary-cell consulenze-summary-cell--actions">
                      <button
                        type="button"
                        class="btn ghost consulenze-detail-btn"
                        @click="openConsulenzaDetail(row)"
                      >
                        Dettagli
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <div
          v-if="activeConsulenzaRow"
          class="modal"
          @click.self="closeConsulenzaDetail"
        >
          <div class="modal-content modal-content--consulenza-detail">
            <div class="modal-header">
              <div class="modal-title-area">
                <h2 class="modal-title">Dettagli consulenza</h2>
                <p class="consulenza-detail-subtitle">
                  {{ activeConsulenzaRow.percorsoTitle || 'Programma' }}
                  <span v-if="activeConsulenzaRow.sequenceIndex">
                    · #{{ activeConsulenzaRow.sequenceIndex }}/{{ activeConsulenzaRow.sequenceTotal || 1 }}
                  </span>
                </p>
              </div>
              <div class="modal-header-actions">
                <span class="consulenza-pill" :class="consulenzaStatusClass(activeConsulenzaRow.consulenzaStatus)">
                  {{ normalizeConsulenzaStatus(activeConsulenzaRow.consulenzaStatus) }}
                </span>
                <button type="button" class="icon-btn grey" @click="closeConsulenzaDetail" aria-label="Chiudi">
                  <span class="material-icons">close</span>
                </button>
              </div>
            </div>

            <div class="consulenza-detail-body">
              <div class="consulenza-detail-top">
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Programma</span>
                  <strong>{{ activeConsulenzaRow.percorsoTitle || 'Programma' }}</strong>
                  <small>{{ activeConsulenzaRow.productName || '—' }}</small>
                </div>
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Scadenza</span>
                  <strong>{{ activeConsulenzaRow.expireAt ? formatDateOnly(activeConsulenzaRow.expireAt) : '—' }}</strong>
                </div>
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Professionista</span>
                  <strong>{{ activeConsulenzaRow.TrainerNome || 'Non assegnato' }}</strong>
                </div>
              </div>

              <div class="consulenza-detail-grid">
                <label class="q-field">
                  <span class="q-label">Tipo</span>
                  <select
                    :value="activeConsulenzaRow.consulenzaType || ''"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'consulenzaType', $event.target.value)"
                  >
                    <option value="" disabled>— Seleziona —</option>
                    <option value="Nutrizionale">Nutrizionale</option>
                    <option value="Tecnica">Tecnica</option>
                  </select>
                </label>

                <label class="q-field">
                  <span class="q-label">Status</span>
                  <select
                    :value="activeConsulenzaRow.consulenzaStatus || 'Da fare'"
                    @change="onConsulenzaStatusChangeByKey(activeConsulenzaRow.percorso, 'consulenza', $event.target.value, activeConsulenzaRow.realIndex)"
                  >
                    <option>Da fare</option>
                    <option>Contattata</option>
                    <option>Prenotata</option>
                    <option>Rifiutata</option>
                    <option>Fatta</option>
                    <option>Scalata</option>
                  </select>
                </label>

                <label class="q-field">
                  <span class="q-label">Data prevista</span>
                  <input
                    type="date"
                    :value="formatInputDate(activeConsulenzaRow.plannedAt)"
                    @change="updateConsulenzaPlannedAt(activeConsulenzaRow, $event.target.value)"
                  />
                  <button
                    type="button"
                    class="link-btn staff-button-danger"
                    @click="updateConsulenzaPlannedAt(activeConsulenzaRow, '')"
                    :disabled="!activeConsulenzaRow.plannedAt"
                  >
                    Rimuovi data
                  </button>
                </label>

                <label class="q-field">
                  <span class="q-label">Data effettuata</span>
                  <input
                    type="date"
                    :value="formatInputDate(activeConsulenzaRow.doneAt)"
                    @change="updateConsulenzaDate(activeConsulenzaRow, 'doneAt', $event.target.value)"
                  />
                </label>

                <label class="q-field">
                  <span class="q-label">Professionista</span>
                  <input
                    type="text"
                    :value="activeConsulenzaRow.TrainerNome || ''"
                    placeholder="Professionista"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'TrainerNome', $event.target.value)"
                  />
                </label>

                <label class="q-field q-field--wide">
                  <span class="q-label">Note</span>
                  <textarea
                    class="consulenza-detail-note"
                    :value="activeConsulenzaRow.staffNote || ''"
                    placeholder="Note interne"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'staffNote', $event.target.value)"
                  />
                </label>

                <div class="q-field q-field--wide">
                  <span class="q-label">Sposta consulenza</span>
                  <div class="consulenza-detail-move">
                    <select
                      class="select"
                      v-model="consulenzaMoveTarget[activeConsulenzaRow.rowId]"
                      :disabled="!!movingConsulenza[activeConsulenzaRow.rowId]"
                    >
                      <option value="" disabled>— Seleziona programma —</option>
                      <option
                        v-for="opt in consulenzaMoveOptions"
                        :key="opt.id"
                        :value="opt.id"
                      >
                        {{ opt.label }}
                      </option>
                    </select>
                    <button
                      type="button"
                      class="btn move-btn"
                      @click="moveConsulenza(activeConsulenzaRow)"
                      :disabled="
                        !!movingConsulenza[activeConsulenzaRow.rowId] ||
                        !consulenzaMoveTarget[activeConsulenzaRow.rowId] ||
                        consulenzaMoveTarget[activeConsulenzaRow.rowId] === activeConsulenzaRow.percorsoId
                      "
                    >
                      {{ movingConsulenza[activeConsulenzaRow.rowId] ? 'Spostamento…' : 'Sposta' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="action-button2 consulenza-detail-footer-btn" @click="closeConsulenzaDetail">Chiudi</button>
              <button
                v-if="canDeleteConsulenza"
                type="button"
                class="create-user-button consulenza-detail-delete consulenza-detail-footer-btn staff-button-danger"
                @click="deleteConsulenza(activeConsulenzaRow)"
                :disabled="!!deletingConsulenza[activeConsulenzaRow.rowId]"
              >
                {{ deletingConsulenza[activeConsulenzaRow.rowId] ? 'Eliminazione…' : 'Elimina consulenza' }}
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="hasDetachedConsulenze"
          class="detached-consulenze-alert"
          role="alert"
        >
          <span class="material-icons" aria-hidden="true">info</span>
          <div>
            <strong>Consulenze senza percorso.</strong>
            Questo utente ha {{ detachedConsulenzeCount }} consulenze slegate dai programmi principali.
            Puoi gestirle dalla tabella qui sopra.
        </div>
      </div>

      <!-- Modale posticipo gruppo -->
      <div
        v-for="group in groupedPostponeModal"
        :key="'postpone-modal-' + group.id"
        class="modal"
      >
        <div class="modal-content modal-postpone">
          <div class="modal-postpone__head">
            <h2 style="color:#111;">Posticipa percorso</h2>
            <button class="icon-btn grey" @click="closeGroupPostponeModal(group.id)" aria-label="Chiudi">
              <span class="material-icons">close</span>
            </button>
          </div>
          <p class="muted modal-postpone__subtitle">
            Scegli di quanti giorni anticipare o posticipare i programmi non completati di questo percorso.
          </p>

          <div class="modal-postpone__field">
            <label class="modal-postpone__label">Delta giorni</label>
            <select
              class="select modal-postpone__select"
              v-model.number="groupPostponeSelection[group.id]"
            >
              <option :value="-90">-3 mesi</option>
              <option :value="-60">-2 mesi</option>
              <option :value="-30">-1 mese</option>
              <option :value="-14">-2 settimane</option>
              <option :value="-7">-1 settimana</option>
              <option :value="7">+1 settimana</option>
              <option :value="14">+2 settimane</option>
              <option :value="30">+1 mese</option>
              <option :value="60">+2 mesi</option>
              <option :value="90">+3 mesi</option>
              <option :value="180">+6 mesi</option>
              <option :value="365">12 mesi</option>
            </select>
          </div>

          <div class="modal-postpone__actions">
            <button
              class="btn primary wide btn-green staff-button-positive"
              :disabled="!!postponingGroup[group.id]"
              @click="posticipaGruppo(group)"
            >
              {{ postponingGroup[group.id] ? 'Posticipo…' : 'Posticipa percorso' }}
            </button>
            <button
              class="btn outline danger wide"
              :disabled="!!resettingGroup[group.id]"
              @click="resetPosticipoGruppo(group)"
            >
              {{ resettingGroup[group.id] ? 'Reset…' : 'Reset posticipo' }}
            </button>
            <button class="btn ghost wide" @click="closeGroupPostponeModal(group.id)">Chiudi</button>
          </div>
        </div>
      </div>

        <!-- Documenti manuali -->
        <section class="manual-docs card">
          <div class="card-head manual-docs__head">
            <div class="head-left">
              <div class="title">Documenti manuali</div>
              <div class="sub muted">Questionari e check generati senza percorso</div>
            </div>
          </div>
          <div class="card-body manual-docs__body">
            <div v-if="!hasManualDocsSection" class="manual-docs__empty muted">
              Nessun documento manuale creato.
            </div>
            <table v-else class="manual-docs-table">
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Tipo</th>
                  <th>Aggiornato</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doc in manualDocsOrdered" :key="doc.id">
                  <td>
                    <div class="mono" style="font-weight:600">{{ doc.stepName || manualDocTypeLabel(doc) }}</div>
                    <small class="muted">ID {{ doc.id }}</small>
                  </td>
                  <td>{{ manualDocTypeLabel(doc) }}</td>
                  <td>
                    <div v-if="doc.updatedAt || doc.createdAt" class="date-cell">
                      <span class="date-cell__date">{{ formatDateOnly(doc.updatedAt || doc.createdAt) }}</span>
                    </div>
                    <span v-else>—</span>
                  </td>
                  <td class="manual-actions">
                    <button class="manual-btn" @click="openManualDocument(doc)">
                      Apri
                    </button>
                    <button
                      class="manual-btn manual-btn--danger staff-button-danger"
                      @click="deleteManualDocument(doc)"
                      :disabled="deletingManualDocs[doc.id]"
                    >
                      {{ deletingManualDocs[doc.id] ? 'Eliminazione…' : 'Elimina' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- Lista programmi -->
        <div class="percorsi">
          <h1>Percorsi</h1>

          <div v-if="loading" class="muted">Caricamento…</div>
          <div v-else-if="percorsiVisibili.length === 0" class="muted">Nessun programma presente.</div>

          <div v-else class="accordion">
            <div
              v-for="group in groupedPercorsi"
              :key="group.id"
              class="percorso-group"
              :class="{
                'percorso-group--active': isActiveGroup(group.id),
                'percorso-group--blocked-closed': !openGroups[group.id] && groupHasPreviousBlocked(group)
              }"
            >
              <button
                type="button"
                class="percorso-group-summary"
                @click="toggleGroupOpen(group.id)"
                :aria-expanded="openGroups[group.id] ? 'true' : 'false'"
              >
                <div class="percorso-group-summary__top">
                  <div class="percorso-group-summary__meta">
                    <span class="percorso-group-summary__label">
                      {{ group.productLabel }}
                    </span>
                    <span
                      v-if="isActiveGroup(group.id)"
                      class="percorso-group-summary__chip percorso-group-summary__chip--active"
                    >
                      Percorso attivo
                    </span>
                    <span class="percorso-group-summary__chip">
                      {{ group.totalPrograms }} programmi
                    </span>
                    <span
                      v-if="group.durationLabel"
                      class="percorso-group-summary__chip"
                    >
                      Durata max {{ group.durationLabel }}
                    </span>
                    <span
                      v-if="groupHasPreviousBlocked(group)"
                      class="percorso-group-summary__chip chip-locked-previous"
                    >
                      Bloccato (precedente)
                    </span>
                  </div>
                  <div class="percorso-group-summary__top-right">
                    <div
                      class="percorso-group-note percorso-group-note--accordion"
                      @click.stop
                      @mousedown.stop
                    >
                      <textarea
                        :id="`group-note-${group.id}`"
                        class="percorso-group-note__textarea"
                        :value="getGroupNoteValue(group)"
                        @input="onGroupNoteInput(group.id, $event.target.value)"
                        @blur="saveGroupNote(group)"
                        @keydown.enter.exact.prevent="saveGroupNote(group)"
                        @click.stop
                        @mousedown.stop
                        placeholder="Note percorso"
                        :disabled="!!updatingGroupNote[group.id]"
                      />
                    </div>
                    <div
                      class="percorso-group-notifications notification-switch"
                      @click.stop
                      @mousedown.stop
                    >
                      <div class="notification-switch__label">Notifiche percorso</div>
                      <div class="notification-switch__controls">
                        <label class="toggle-switch toggle-switch--small">
                          <input
                            type="checkbox"
                            :checked="areGroupNotificationsEnabled(group.id)"
                            @change.stop="toggleNotificationsForGroup(group)"
                            :disabled="!!togglingGroupNotifications[group.id]"
                          />
                          <span class="toggle-slider"></span>
                        </label>
                        <span
                          class="notification-switch__state"
                          :class="{
                            off: !areGroupNotificationsEnabled(group.id),
                            partial: isGroupNotificationsPartial(group.id)
                          }"
                        >
                          {{
                            isGroupNotificationsPartial(group.id)
                              ? 'Parziale'
                              : (areGroupNotificationsEnabled(group.id) ? 'On' : 'Off')
                          }}
                        </span>
                      </div>
                    </div>
                    <span class="chevron percorso-group-summary__chevron" :class="{ open: openGroups[group.id] }">▾</span>
                  </div>
                </div>
                <div class="percorso-group-summary__dates">
                  <span>
                    Inizio:
                    <strong>
                      {{ group.startAt ? formatDate(group.startAt) : '—' }}
                    </strong>
                  </span>
                  <span>
                    Scadenza:
                    <strong>
                      {{ group.expireAt ? formatDate(group.expireAt) : '—' }}
                    </strong>
                  </span>
                    <button
                      type="button"
                      class="icon-btn grey"
                      @click.stop="openGroupPostponeModal(group.id)"
                      title="Posticipa/anticipa percorso"
                    >
                      <span class="material-icons">schedule</span>
                    </button>
                    <select
                      v-if="canAddProgram"
                      class="select group-duration-select"
                      :value="group.durationMonths || ''"
                      @change="onGroupDurationChange(group, $event.target.value)"
                      @click.stop
                      @mousedown.stop
                      :disabled="!!updatingGroupDuration[group.id]"
                      title="Durata percorso (mesi)"
                    >
                      <option value="" disabled>Durata</option>
                      <option
                        v-for="opt in durationMonthOptions"
                        :key="opt"
                        :value="opt"
                      >
                        {{ opt === 1 ? '1 mese' : `${opt} mesi` }}
                      </option>
                    </select>
                    <button
                      type="button"
                      class="icon-btn grey"
                      @click.stop="addProgramToGroup(group)"
                      :disabled="!!addingProgramToGroup[group.id]"
                    title="Aggiungi programma"
                    v-if="canAddProgram"
                  >
                    <span class="material-icons">
                      {{ addingProgramToGroup[group.id] ? 'hourglass_top' : 'add' }}
                    </span>
                  </button>
                </div>
              </button>

              <div v-if="openGroups[group.id]" class="percorso-group-body">
               <!-- <div class="percorso-group-actions">
                  <button
                    type="button"
                    class="btn danger outline"
                    @click.stop="deletePercorsoGroup(group)"
                    :disabled="!!deletingGroupPercorsi[group.id]"
                  >
                    {{ deletingGroupPercorsi[group.id] ? 'Eliminazione…' : 'Cancella percorso' }}
                  </button>
                </div>-->

                <div
                  v-for="p in group.percorsi"
                  :key="p.id"
                  class="item"
                  :class="{
                    'percorso-locked': isPercorsoLocked(p),
                    'percorso-locked-previous': isPercorsoBlockedByPreviousGroup(p),
                    'percorso-completed': isPercorsoCompleted(p) && !isPercorsoPast(group.id, p),
                    'percorso-past': isPercorsoPast(group.id, p),
                    'item--active': isActiveProgram(group.id, p.id)
                  }"
                >
                  <div class="item-header-row">
                    <button class="item-header" @click="toggleOpen(p.id)">
                      <div class="title">
                        <strong>{{ renderProgramTitle(p.title) }}</strong>
                        <!--<span class="muted">• creato {{ formatDate(p.createdAt) }}</span>
                        <span v-if="p.productName" class="muted">• {{ p.productName }}</span>
                        <span v-if="p.sequenceTotal" class="muted">• {{ p.sequenceIndex }}/{{ p.sequenceTotal }}</span>-->
                        <span v-if="p.plannedStartAt" class="muted">• inizio previsto {{ formatDate(p.plannedStartAt) }}</span>
                        <span v-if="p.expireAt" class="muted">• scadenza prevista {{ formatDate(p.expireAt) }}</span>
                      </div>
                    <div class="meta">
                      <span
                        v-if="isPercorsoLocked(p)"
                        class="chip"
                        :class="isPercorsoBlockedByPreviousGroup(p) ? 'chip-locked-previous' : 'chip-locked'"
                        >
                          {{ lockChipLabel(p) }}
                        </span>
                        <span v-else-if="p.sequenceUnlockOverride" class="chip chip-unlocked">Sbloccato a mano</span>
                        <span
                          v-if="isActiveProgram(group.id, p.id)"
                          class="chip chip-active"
                        >
                          Programma attivo
                        </span>
                        <span class="chip" :class="progressClass(p)">{{ progressLabel(p) }}</span>
                        <span class="chevron" :class="{ open: openIds[p.id] }">▾</span>
                      </div>
                    </button>
                  </div>

                  <div class="item-body" v-show="openIds[p.id]">
                  <div v-if="isPercorsoLocked(p)" class="percorso-locked-banner">
                    <div class="percorso-locked-banner__text">
                      <strong>{{ lockBannerTitle(p) }}</strong>
                      <span>{{ lockBannerSubtitle(p) }}</span>
                    </div>
                    <div class="percorso-locked-banner__actions">
                      <button
                        v-if="canReactivatePercorso(p)"
                        type="button"
                        class="percorso-locked-banner__btn"
                        @click.stop="reactivatePercorso(p)"
                        :disabled="reactivatingPercorso[p.id]"
                      >
                        {{ reactivatingPercorso[p.id] ? 'Riattivazione…' : 'Riattiva programma' }}
                      </button>
                      <button
                        v-else-if="canManuallyUnlockSequence(p)"
                        type="button"
                        class="percorso-locked-banner__btn"
                        @click.stop="unlockSequenceManually(p)"
                        :disabled="overridingSequenceLock[p.id]"
                      >
                        {{ overridingSequenceLock[p.id] ? 'Sblocco…' : 'Sblocca manualmente' }}
                      </button>
                    </div>
                  </div>
                  <div v-else class="percorso-unlocked-banner">
                    <div class="percorso-unlocked-banner__text">
                      <strong>Programma attivo</strong>
                      <span>Bloccalo se vuoi mantenerlo come storico senza modifiche.</span>
                      <span v-if="p.sequenceUnlockOverride" class="manual-unlock-note">
                        Sblocco manuale attivo: il blocco legato ai programmi precedenti è stato bypassato.
                      </span>
                    </div>
                    <div class="percorso-unlocked-banner__actions">
                      <button
                        type="button"
                        class="percorso-unlocked-banner__btn"
                        @click.stop="lockPercorso(p)"
                        :disabled="lockingPercorso[p.id]"
                      >
                        {{ lockingPercorso[p.id] ? 'Blocco…' : 'Blocca programma' }}
                      </button>
                      <button
                        v-if="p.sequenceUnlockOverride"
                        type="button"
                        class="percorso-unlocked-banner__btn percorso-unlocked-banner__btn--ghost"
                        @click.stop="restoreSequenceLock(p)"
                        :disabled="overridingSequenceLock[p.id]"
                      >
                        {{ overridingSequenceLock[p.id] ? 'Ripristino…' : 'Ripristina blocco sequenza' }}
                      </button>
                    </div>
                  </div>
                  <table class="steps-table">
                  <thead>
                    <tr>
                      <th>Step</th>
                      <th>Status</th>
                      <th>Data prevista</th>
                      <th>Data completamento</th>
                      <th>Status admin</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
  <tr
    v-for="row in stepsToRender(p)"
    :key="row.key + '_' + row.realIndex"
    :class="[
      { 'row-divider': row.sectionBreak },
      'step-body-row',
      isPercorsoLocked(p) ? 'step-row--locked' : ''
    ]"
  >
    <!-- NOME STEP -->
    <td class="step-name" data-label="Step">
      <span class="bullet" :class="{ done: row.isDone }"></span>

      <div class="step-name-main">
        <div class="step-name-header">
          <div class="step-link">
            <template v-if="row.key === 'questionario' || row.key === 'check_finale'">
              <span
                class="step-initial"
                :class="[stepInitialClass(row), { done: row.isDone }]"
                :title="stepInitialTitle(row)"
              >
                {{ row.key === 'questionario' ? 'Q' : 'C' }}
              </span>
            </template>
            <template v-else>
              <div class="step-text-block">
                <span class="step-link__label" :class="{ done: row.isDone }">
                  {{ row.step?.name }}
                </span>

                <!-- chip TIPO CONSULENZA, solo per step consulenza -->
                <small
                  v-if="row.key === 'consulenza' && row.step?.consulenzaType"
                  class="muted step-subtype"
                >
                  {{ row.step.consulenzaType }}
                </small>
              </div>
            </template>
          </div>

          <button
            v-if="row.key === 'questionario'"
            type="button"
            class="icon-btn icon-btn--small"
            @click.stop="openQuestionario(p, row)"
            title="Apri questionario iniziale"
            :disabled="isQuestionarioDisabled(p, row)"
          >
            <span class="material-icons">assignment</span>
          </button>
          <button
            v-else-if="row.key === 'check_finale'"
            type="button"
            class="icon-btn icon-btn--small"
            @click.stop="openCheckFinale(p, row)"
            title="Apri check finale"
            :disabled="isRowActionDisabled(p, row) && !canViewPastCheck(row)"
          >
            <span class="material-icons">fact_check</span>
          </button>
          <button
            v-if="row.key === 'questionario' || row.key === 'check_finale'"
            type="button"
            class="icon-btn icon-btn--small danger"
            @click.stop="resetQuestionarioStep(p, row)"
            :title="resettingStep[stepIndexKey(p.id, row.realIndex)] ? 'Ripristino…' : 'Elimina e reimposta a Da fare'"
            :disabled="!!resettingStep[stepIndexKey(p.id, row.realIndex)]"
          >
            <span class="material-icons">
              {{ resettingStep[stepIndexKey(p.id, row.realIndex)] ? 'hourglass_top' : 'delete' }}
            </span>
          </button>
          <button
            v-if="canConvertQuestionarioStep(p, row)"
            type="button"
            class="icon-btn icon-btn--small grey"
            @click.stop="requestToggleQuestionarioCheck(p, row)"
            :title="convertButtonTitle(row)"
            :disabled="isPercorsoLocked(p) || !!switchingStepType[stepIndexKey(p.id, row.realIndex)]"
          >
            <span class="material-icons">
              {{ switchingStepType[stepIndexKey(p.id, row.realIndex)] ? 'hourglass_top' : 'swap_horiz' }}
            </span>
          </button>
          <button
            v-if="row.key === 'check_finale' && row.isLockedByConsegna"
            type="button"
            class="icon-btn icon-btn--small grey"
            @click.stop="unlockCheckFinale(p, row)"
            :title="unlockingCheckFinale[stepIndexKey(p.id, row.realIndex)] ? 'Sblocco…' : 'Sblocca check finale'"
            :disabled="isPercorsoLocked(p) || !!unlockingCheckFinale[stepIndexKey(p.id, row.realIndex)]"
          >
            <span class="material-icons">
              {{ unlockingCheckFinale[stepIndexKey(p.id, row.realIndex)] ? 'lock_open' : 'lock' }}
            </span>
          </button>
        </div>

        <div v-if="row.step?.manual" class="step-tag mono">Manuale</div>

      </div>
    </td>

    <!-- STATUS -->
    <td data-label="Status">
      <!-- STATUS DEDICATO PER CONSULENZA -->
      <select
        v-if="row.key === 'consulenza'"
        :value="row.step?.consulenzaStatus || 'Da fare'"
        @change="onConsulenzaStatusChangeByKey(p, row.key, $event.target.value, row.realIndex)"
        class="select"
        :disabled="isPercorsoLocked(p)"
      >
        <option>Da fare</option>
        <option>Contattata</option>
        <option>Prenotata</option>
        <option>Rifiutata</option>
        <option>Fatta</option>
        <option>Scalata</option>
      </select>

      <div v-else-if="row.key === 'consegna'" class="status-flags">
        <label
          class="status-flag"
          :class="{
            'is-active': !!row.step?.progCustomizzato,
            'is-disabled': isPercorsoLocked(p) || isProgCustomFlagSaving(p, row)
          }"
        >
          <input
            type="checkbox"
            :checked="!!row.step?.progCustomizzato"
            :disabled="isPercorsoLocked(p) || isProgCustomFlagSaving(p, row)"
            @change="onProgCustomFlagToggle(p, row, $event.target.checked)"
          />
          <span>Prog. customizzato</span>
        </label>
        <label
          class="status-flag"
          :class="{
            'is-active': !!row.step?.done,
            'is-disabled': isPercorsoLocked(p) || isConsegnaFlagSaving(p, row)
          }"
        >
          <input
            type="checkbox"
            :checked="!!row.step?.done"
            :disabled="isPercorsoLocked(p) || isConsegnaFlagSaving(p, row)"
            @change="onConsegnaFlagToggle(p, row, $event.target.checked)"
          />
          <span>{{ row.step?.done ? 'Consegnato' : 'Consegna' }}</span>
        </label>
      </div>

      <!-- STATUS GENERICO (done/da fare) PER ALTRI STEP -->
      <select
      v-else
        :value="row.step?.done ? 'Fatto' : 'Da fare'"
        @change="onSelectChangeByKey($event, p, row.key, row.realIndex)"
        class="select"
        :disabled="isPercorsoLocked(p)"
      >
        <option value="Da fare">Da fare</option>
        <option value="Fatto">Fatto</option>
      </select>
    </td>

    <!-- DATA PREVISTA -->
    <td data-label="Data prevista">
      <div v-if="row.step?.plannedAt" class="date-cell">
        <span class="date-cell__date">{{ formatDateOnly(row.step.plannedAt) }}</span>
      </div>
      <span v-else>—</span>
    </td>

    <!-- DATA COMPLETAMENTO -->
    <td data-label=" completamento">
      <template v-if="row.key === 'consegna' && row.step?.done">
        <div class="date-edit">
          <input
            type="date"
            :value="formatInputDate(row.step?.doneAt || row.step?.plannedAt)"
            @change="onConsegnaDoneDateChange(p, row, $event.target.value)"
            class="select"
            :disabled="isPercorsoLocked(p) || !!updatingConsegnaDone[stepIndexKey(p.id, row.realIndex)]"
          />
        </div>
      </template>
      <template v-else>
        <div v-if="row.step?.doneAt" class="date-cell">
          <span class="date-cell__date">{{ formatDateOnly(row.step.doneAt) }}</span>
        </div>
        <span v-else>—</span>
      </template>
    </td>

    

    <!-- ======= COLONNA STATUS ADMIN ======= -->
<td class="admin-col" data-label="Status admin">
  <!-- nascondi i bottoni admin per Consegna e Consulenza -->
  <template v-if="row.key !== 'consegna' && row.key !== 'consulenza'">
    <div class="admin-row">
      <div class="chips-line">
        <span class="admin-chip" :class="adminChipClass(row.step)">
          {{ adminLabel(row.step) }}
        </span>

        <!-- Chip "Invio di giornata" SOLO per questionario e check_finale -->
        <template v-if="isStepDailyMarked(row.step)">
          <span class="admin-chip" :class="dailyStepChipClass(row.step)">
            {{ dailyStepChipLabel(row.step) }}
          </span>
        </template>

        <template v-if="isStepRenewal(row.step)">
          <span class="admin-chip chip-purple">Da rinnovare</span>
        </template>

        <template v-if="isStepStopped(row.step)">
          <span class="admin-chip chip-red">Stop</span>
        </template>

        <!-- Chip lavorato per check finale -->
        <template v-if="row.key === 'check_finale' && row.step?.adminWorked">
          <span class="admin-chip chip-purple">Lavorato</span>
        </template>
      </div>

<div class="buttons-container">
  <!-- Notifica -->
  <button
    type="button"
    class="icon-btn grey"
    @click="sendAdminNotification(p, row.key, row.realIndex)"
    :title="sendingNotification[stepIndexKey(p.id, row.realIndex)] ? 'Invio…' : 'Invia notifica'"
    :disabled="isPercorsoLocked(p) || !areNotificationsEnabled(p) || !!sendingNotification[stepIndexKey(p.id, row.realIndex)]"
  >
    <span class="material-icons">
      {{ sendingNotification[stepIndexKey(p.id, row.realIndex)] ? 'hourglass_top' : 'notifications_active' }}
    </span>
  </button>

  <!-- Approvato -->
  <button
    type="button"
    class="icon-btn green"
    @click="toggleAdminApprovedByKey(p, row.key, row.realIndex)"
    :title="row.step?.adminStatus === 'approved' ? 'Disapprova' : 'Approva'"
    :class="{ active: row.step?.adminStatus === 'approved' }"
    :disabled="isPercorsoLocked(p)"
  >
    <span class="material-icons">check_circle</span>
  </button>

  <!-- Richiesto aggiornamento -->
  <button
    type="button"
    class="icon-btn orange"
    @click="toggleNeedsUpdateUIByKey(p, row.key, row.realIndex)"
    title="Richiedi aggiornamento"
    :disabled="isPercorsoLocked(p) || !areNotificationsEnabled(p)"
  >
    <span class="material-icons">edit_note</span>
  </button>

  <!-- Lavorato (solo check finale) 
  <button
    v-if="row.key === 'check_finale'"
    type="button"
    class="icon-btn purple"
    @click="toggleCheckFinalWorkedByKey(p, row.key, row.realIndex)"
    :title="row.step?.adminWorked ? 'Segna da lavorare' : 'Segna come lavorato'"
    :disabled="isPercorsoLocked(p) || !!togglingWorked[keyFor(p.id, row.key)]"
    :class="{ active: row.step?.adminWorked }"
  >
    <span class="material-icons">
      {{ row.step?.adminWorked ? 'task_alt' : 'pending_actions' }}
    </span>
  </button>-->

  <!-- Invio di giornata (solo se approvato + step valido) -->
  <template v-if="canShowDailySendForStep(p, row)">
    <button
      type="button"
      class="icon-btn blue"
      @click="markDailySendByKey(p, row.key, row.realIndex)"
      :disabled="isDailySendButtonDisabled(p, row)"
      :title="dailySendButtonTitle(p, row)"
    >
      <span class="material-icons">send</span>
    </button>
  </template>
  <button
    v-if="row.step?.adminStatus === 'approved'"
    type="button"
    class="icon-btn purple"
    @click="toggleRenewalByKey(p, row.key, row.realIndex)"
    :title="isStepRenewal(row.step) ? 'Rimuovi rinnovo' : 'Da rinnovare'"
    :aria-label="isStepRenewal(row.step) ? 'Rimuovi rinnovo' : 'Da rinnovare'"
    :disabled="isPercorsoLocked(p) || !!togglingRenewal[stepIndexKey(p.id, row.realIndex)]"
    :class="{ active: isStepRenewal(row.step) }"
  >
    <span class="material-icons">
      {{ togglingRenewal[stepIndexKey(p.id, row.realIndex)] ? 'hourglass_top' : isStepRenewal(row.step) ? 'restart_alt' : 'autorenew' }}
    </span>
  </button>

  <button
    v-if="canShowDailyHideForStep(row)"
    type="button"
    class="icon-btn grey"
    @click="markDailyFlagOnlyByKey(p, row.key, row.realIndex)"
    :disabled="isPercorsoLocked(p) || savingDaily[keyFor(p.id, row.key)]"
    :title="savingDaily[keyFor(p.id, row.key)] ? 'Nascondo…' : 'Nascondi'"
    :aria-label="savingDaily[keyFor(p.id, row.key)] ? 'Nascondo…' : 'Nascondi'"
  >
    <span class="material-icons">
      {{ savingDaily[keyFor(p.id, row.key)] ? 'hourglass_top' : 'visibility_off' }}
    </span>
  </button>
</div>

    </div>

    <div v-if="needsUpdateOpen[keyFor(p.id,row.key)]" class="needs-box">
      <input
        type="text"
        class="user-input"
        v-model.trim="needsUpdateNotes[keyFor(p.id,row.key)]"
        placeholder="Scrivi la nota per l'utente…"
        :disabled="isPercorsoLocked(p) || !areNotificationsEnabled(p)"
      />
<div class="buttons-container">
  <!-- Salva richiesta -->
  <button
    type="button"
    class="icon-btn green"
    @click="saveNeedsUpdateByKey(p, row.key, row.realIndex)"
    title="Salva richiesta"
    :disabled="isPercorsoLocked(p) || !areNotificationsEnabled(p)"
  >
    <span class="material-icons">save</span>
  </button>

  <!-- Chiudi -->
  <button
    type="button"
    class="icon-btn grey"
    @click="toggleNeedsUpdateUIByKey(p, row.key, row.realIndex)"
    title="Chiudi"
    :disabled="isPercorsoLocked(p)"
  >
    <span class="material-icons">close</span>
  </button>
</div>
      <small v-if="row.step?.adminNote?.length" class="muted">
        Nota corrente: “{{ row.step.adminNote }}”
      </small>
    </div>
    <small v-else-if="row.step?.adminNote?.length" class="muted">
      Nota: “{{ row.step.adminNote }}”
    </small>
  </template>

  <!-- per Consegna/Consulenza mostra solo il chip riassuntivo -->
  <template v-else>
    <span class="admin-chip chip-neutral">—</span>
  </template>
</td>


    <!-- NOTE INTERNE STAFF -->
    <td data-label="Note interne">
      <div class="note-cell">
        <input
          class="note-input"
          :placeholder="'—'"
          v-model="staffNoteEdits[stepIndexKey(p.id, row.realIndex)]"
          @blur="saveStaffNoteByKey(p, row.key, row.realIndex)"
          @keyup.enter="saveStaffNoteByKey(p, row.key, row.realIndex)"
          :disabled="isPercorsoLocked(p) || !!savingNote[stepIndexKey(p.id, row.realIndex)]"
        />
        <small v-if="savingNote[stepIndexKey(p.id, row.realIndex)]" class="muted note-message">salvo…</small>
        <small
          v-else-if="saveStatus[stepIndexKey(p.id, row.realIndex)]==='ok'"
          class="muted note-message"
        >salvato ✓</small>
        <small
          v-else-if="saveStatus[stepIndexKey(p.id, row.realIndex)]==='err'"
          class="muted note-message"
        >errore ✗</small>
      </div>
    </td>
  </tr>
                  </tbody>
                  </table>

                  <div class="footer">
                    <button class="btn danger outline staff-button-danger" @click="deletePercorsoCascade(p)">
                      Elimina programma
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        </div>

        <p v-if="error" class="error">Errore: {{ error }}</p>
    <!-- Modale: aggiungi programma con step manuale -->
    <div v-if="showAddStep" class="modal">
      <div class="modal-content modal-postpone">
        <div class="modal-postpone__head">
          <h2 style="color:#111;">Aggiungi Step Manuale</h2>
          <button class="icon-btn grey" @click="closeAddStep" aria-label="Chiudi">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="modal-postpone__field" style="margin-top:10px;">
          <label class="modal-postpone__label" style="color:#111;">Tipo di step</label>
          <select v-model="addStepType" class="select modal-postpone__select">
            <option value="questionario">Questionario iniziale</option>
            <option value="check_finale">Check finale</option>
          </select>
        </div>

        <div class="modal-postpone__actions">
          <button
            class="btn primary wide btn-green staff-button-positive"
            :disabled="addingStep"
            @click="createStandaloneManualDocument"
          >
            {{ addingStep ? 'Creazione…' : 'Crea documento manuale' }}
          </button>
          <button class="btn ghost wide" @click="closeAddStep">Chiudi</button>
        </div>
      </div>
    </div>

    <!-- Modale: crea consulenze standalone -->
    <div v-if="showConsulenzeModal" class="modal">
      <div class="modal-content modal-content--simple">
        <span class="close" @click="closeConsulenzeModal">&times;</span>
        <h2>Crea consulenze</h2>
        <p class="muted" style="margin:0 0 12px;">
          Genera consulenze svincolate dai programmi e assegnale in seguito dalla tabella Consulenze.
        </p>

        <label class="q-field" style="margin-top:10px;">
          <span style="display:block; font-weight:600; margin-bottom:6px;">Tipo</span>
          <select v-model="consulenzeForm.type" class="select">
            <option value="Nutrizionale">Nutrizionale</option>
            <option value="Tecnica">Tecnica</option>
          </select>
        </label>

        <label class="q-field" style="margin-top:10px;">
          <span style="display:block; font-weight:600; margin-bottom:6px;">Quantità</span>
          <input
            v-model.number="consulenzeForm.quantity"
            type="number"
            min="1"
            step="1"
            class="select"
            placeholder="Es. 1"
          />
        </label>

        <div class="button-container" style="margin-top:12px;">
          <button
            class="create-user-button staff-button-positive"
            :disabled="creatingConsulenze"
            @click="createConsulenzeManuali"
          >
            {{ creatingConsulenze ? 'Creazione…' : 'Crea consulenze' }}
          </button>
          <button class="action-button2" @click="closeConsulenzeModal">Chiudi</button>
        </div>
      </div>
    </div>

    <!-- Modal creazione programmi -->
    <div v-if="showModal" class="modal">
      <div class="modal-content modal-content--simple">
        <span class="close" @click="closeModal">&times;</span>
        <h2>Crea Programma</h2>

        <form @submit.prevent="addPercorso">
          <label for="product">Seleziona programma</label>
          <select id="product" v-model="form.productId" class="select-mobile">
            <option value="">-- Nessun prodotto --</option>
<option v-for="p in products" :key="p.id" :value="p.id">
  {{ p.name }}
  (coaching: {{ Number(p.coaching_quantity ?? 0) }},
   cons. tecniche: {{ Number(p.cons_tecniche ?? 0) }},
   nutriz.: {{ Number(p.cons_nutrizionali ?? 0) }})
</option>
          </select>

          <label for="program-index" style="margin-top:8px;">
            Seleziona a che programma sei?
            <span v-if="selectedProductTotal > 1" class="muted">({{ selectedProductTotal }} totali)</span>
          </label>
          <select
            id="program-index"
            v-model.number="form.currentIndex"
            class="select-mobile"
            :disabled="!selectedProduct"
          >
            <option v-if="!selectedProduct" value="1" disabled>Seleziona prima il programma</option>
            <option
              v-for="opt in currentIndexOptions"
              :key="opt"
              :value="opt"
            >
              Programma {{ opt }}
            </option>
          </select>

          <label for="titolo" style="margin-top:8px;">Titolo Programma (opz.)</label>
          <input id="titolo" v-model.trim="form.title" type="text" class="user-input" placeholder="Es. Programma dimagrimento" />

          <button type="submit" :disabled="creating" class="create-user-button staff-button-positive">
            {{ creating ? 'Creazione…' : 'Salva Programma/i' }}
          </button>
        </form>
      </div>
    </div>

    <!-- Modal creazione percorso custom -->
    <div v-if="createPercorsoModalOpen" class="modal">
      <div class="modal-content modal-content--simple">
        <span class="close" @click="closeCreatePercorsoModal">&times;</span>
        <h2>Crea percorso</h2>
        <p class="muted" style="margin:0 0 12px;">
          Scegli il prodotto, quante tranche creare e la data di inizio del percorso.
        </p>

        <label class="q-field" style="margin-top:10px;">
          <span style="display:block; font-weight:600; margin-bottom:6px;">Prodotto</span>
          <select v-model="createPercorsoForm.productId" class="select">
            <option value="">-- Seleziona prodotto --</option>
            <option v-for="p in products" :key="p.id" :value="p.id">
              {{ p.name }} ({{ Number(p.coaching_quantity ?? 0) }} programmi)
            </option>
          </select>
        </label>

        <label class="q-field" style="margin-top:10px;">
          <span style="display:block; font-weight:600; margin-bottom:6px;">Numero programmi</span>
          <input
            v-model.number="createPercorsoForm.quantity"
            type="number"
            min="1"
            :max="createSelectedProductTotal"
            class="select"
            placeholder="Es. 2"
          />
          <small class="muted" v-if="createSelectedProduct">
            Max consentito per il prodotto: {{ createSelectedProductTotal }}
          </small>
        </label>

        <label class="q-field" style="margin-top:10px;">
          <span style="display:block; font-weight:600; margin-bottom:6px;">Data inizio percorso</span>
          <input
            v-model="createPercorsoForm.startDate"
            type="date"
            class="select"
          />
        </label>

        <div class="button-container" style="margin-top:12px;">
          <button
            class="create-user-button staff-button-positive"
            :disabled="creatingPercorso"
            @click="createPercorsoFromModal"
          >
            {{ creatingPercorso ? 'Creazione…' : 'Crea percorso' }}
          </button>
          <button class="action-button2" @click="closeCreatePercorsoModal">Chiudi</button>
        </div>
      </div>
    </div>

</div>
</template>

<script>
import { ref, watch, computed, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  getFirestore,
  collection,
  query,
  updateDoc,
  deleteDoc,
  doc,
  where,
  getDoc,
  getDocs,
  writeBatch,
  serverTimestamp,
  setDoc,
  onSnapshot,
} from 'firebase/firestore';
import {
  createPercorsiForProduct,
  createConsulenzeOnlyPercorso,
  buildStepsWithPlan,
  setStepDone,
  setProgCustomFlag,
  postponePercorso,
  resetPostpone,
  updateConsegnaDoneAt,
} from '@/lib/percorsi';
import { normalizeProgramTitle, dispatchStepNotification, dispatchNeedsUpdateNotification } from '@/lib/percorsoStepNotifications';
import { normalizeConsultationType } from '../../../functions/shared/consultationReminder';
import { saveDailySend } from '@/lib/dailySend';
import { computeProgrammeLocks, isProgrammeComplete } from '@/lib/programmeLocks';

const QUESTIONARI_COLLECTION = 'questionari';
const DAY_MS = 24 * 60 * 60 * 1000;
const REMINDER_CONFIG = [
  { days: 10, field: 'ticketAfter10DaysSentAt', label: 'Promemoria 10 giorni' },
  { days: 24, field: 'ticketAfter24DaysSentAt', label: 'Promemoria 24 giorni' },
  { days: 40, field: 'ticketAfter40DaysSentAt', label: 'Promemoria 40 giorni' },
];
const ADD_PROGRAM_PRIV_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const ADD_PROGRAM_PRIV_EMAIL = 'valeriobianconi@gmail.com';
const MANUAL_FORM_TYPES = {
  questionario: {
    stepKey: 'questionario',
    label: 'Questionario iniziale',
    type: 'user_programmi_questionario',
    routeName: 'UserProgrammiQuestionario',
    templateId: 'user_programmi_questionario_v1',
    templateKey: 'user_programmi_questionario',
    templateLabel: 'Questionario Programmi',
    templateVersion: 1,
    stepName: 'Questionario iniziale manuale',
  },
  check_finale: {
    stepKey: 'check_finale',
    label: 'Check finale',
    type: 'user_programmi_check_finale',
    routeName: 'UserProgrammiCheckFinale',
    templateId: 'user_programmi_check_finale_v1',
    templateKey: 'user_programmi_check_finale',
    templateLabel: 'Check Finale Programmi',
    templateVersion: 1,
    stepName: 'Check finale manuale',
  },
};
const QUESTIONARIO_LOCATION_META = {
  questionari: { label: 'Presente in Questionari' },
  scaduti: { label: 'Presente in Questionari scaduti' },
};
const manualDocsSortByUpdated = (a, b, toMillisFn) => {
  const aTime = toMillisFn(a?.updatedAt || a?.createdAt);
  const bTime = toMillisFn(b?.updatedAt || b?.createdAt);
  if (Number.isNaN(aTime) && Number.isNaN(bTime)) return 0;
  if (Number.isNaN(aTime)) return 1;
  if (Number.isNaN(bTime)) return -1;
  return bTime - aTime;
};

/* ======= CONFIG STEPS (chiavi stabili) ======= */

export default {
  name: 'PercorsiUtente',
  props: { userId: { type: String, required: true } },
  setup(props) {
    const db = getFirestore();
    const router = useRouter();

    const showModal = ref(false);
    const loading = ref(true);
    const creating = ref(false);
    const error = ref('');
    const canAddProgram = ref(false);
    const canCreatePercorso = ref(false);

    const percorsi = ref([]);
    const percorsiVisibili = computed(() => (percorsi.value || []).filter(p => !p.consulenzeOnly));
    const openIds = ref({});
    const openGroups = ref({});
    const products = ref([]);
    const savingDaily = ref({});
    const togglingWorked = ref({});
    const togglingRenewal = ref({});
    const sendingNotification = ref({});
    const reactivatingPercorso = ref({});
    const lockingPercorso = ref({});
    const overridingSequenceLock = ref({});
    const switchingStepType = ref({});
    const resettingStep = ref({});
    const suppressingReminder = ref({});
    const updatingConsegnaFlag = ref({});
    const updatingProgCustomFlag = ref({});

    const form = ref({ productId: '', currentIndex: 1, title: '' });
    const createPercorsoForm = ref({ productId: '', quantity: 1, startDate: '' });
    const createPercorsoModalOpen = ref(false);
    const creatingPercorso = ref(false);

    const toasts = ref([]);
    const toastTimers = new Map();
    let authUnsub = null;

    const updateAddProgramPermission = (user) => {
      if (!user) {
        canAddProgram.value = false;
        canCreatePercorso.value = false;
        return;
      }
      const email = (user.email || '').toLowerCase();
      canAddProgram.value =
        user.uid === ADD_PROGRAM_PRIV_UID || email === ADD_PROGRAM_PRIV_EMAIL.toLowerCase();
      canCreatePercorso.value = user.uid === ADD_PROGRAM_PRIV_UID;
    };

    const initAuthWatcher = () => {
      const auth = getAuth();
      updateAddProgramPermission(auth.currentUser);
      authUnsub = onAuthStateChanged(auth, updateAddProgramPermission);
    };

    const canDeleteConsulenza = computed(() => canAddProgram.value);
    const canRepeatDailySendPrivileged = computed(
      () => canAddProgram.value || canCreatePercorso.value
    );

    const pushToast = (message, type = 'info') => {
      const id = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      toasts.value.push({ id, message, type });
      const timer = setTimeout(() => dismissToast(id), 4200);
      toastTimers.set(id, timer);
    };

    const dismissToast = (id) => {
      toasts.value = toasts.value.filter(t => t.id !== id);
      const timer = toastTimers.get(id);
      if (timer) {
        clearTimeout(timer);
        toastTimers.delete(id);
      }
    };

    const notify = (message, type = 'info') => pushToast(message, type);

    // --- stato UI locale per “Richiesto aggiornamento” ---
    const needsUpdateOpen = ref({});
    const needsUpdateNotes = ref({});
    const consulenzaMoveTarget = ref({});
    const movingConsulenza = ref({});
    const deletingConsulenza = ref({});

    // NOTE INTERNE staff (per step)
    const staffNoteEdits = ref({});
    const savingNote     = ref({});
    const saveStatus     = ref({});
    const upcomingRemindersOpen = ref(false);
    const showHistoricalReminders = ref(false);

    // ---- Consulenze (documenti separati) ----
const consulenzeOpen = ref(false);
const toggleConsulenze = () => { consulenzeOpen.value = !consulenzeOpen.value; };
    const groupPostponeSelection = ref({});
    const postponingGroup = ref({});
    const resettingGroup = ref({});
    const deletingGroupPercorsi = ref({});
    const addingProgramToGroup = ref({});
    const updatingGroupDuration = ref({});
    const groupNoteEdits = ref({});
    const updatingGroupNote = ref({});
    const groupPostponeModalOpen = ref({});
    const groupedPostponeModal = computed(() =>
      (groupedPercorsi.value || []).filter(g => groupPostponeModalOpen.value[g.id])
    );

    const toComparableString = (value) => {
      if (!value) return '';
      if (typeof value === 'string') return value;
      if (value instanceof Date) return value.toISOString();
      if (typeof value?.toDate === 'function') {
        try { return value.toDate().toISOString(); }
        catch { return ''; }
      }
      return String(value);
    };

    const durationMonthOptions = Array.from({ length: 24 }, (_, i) => i + 1);

    const selectedProduct = computed(() =>
      products.value.find(p => p.id === form.value.productId) || null
    );
    const createSelectedProduct = computed(() =>
      products.value.find(p => p.id === createPercorsoForm.value.productId) || null
    );
    const createSelectedProductTotal = computed(() => {
      const viaProduct = Number(createSelectedProduct.value?.coaching_quantity);
      return Number.isFinite(viaProduct) && viaProduct > 0 ? viaProduct : 1;
    });
    const selectedProductTotal = computed(() => {
      const viaProduct = Number(selectedProduct.value?.coaching_quantity);
      return Number.isFinite(viaProduct) && viaProduct > 0 ? viaProduct : 1;
    });
    const currentIndexOptions = computed(() => {
      const total = selectedProductTotal.value;
      const size = Math.min(Math.max(total, 1), 200); // evita liste troppo lunghe
      return Array.from({ length: size }, (_, i) => i + 1);
    });
const isConsulenzaStatusDone = (status) => {
  const normalized = normalizeConsulenzaStatus(status);
  return normalized === 'Fatta' || normalized === 'Rifiutata' || normalized === 'Scalata';
};
    const isBlockingStepForSequence = (step) => {
      const name = (step?.name || '').toLowerCase();
      if (!name) return true;
      if (name.includes('feedback')) return false;
      return true;
    };
    const isStepEffectivelyDone = (step) => {
      if (!step) return false;
      const name = (step?.name || '').toLowerCase();
      if (name.includes('consulenza') && isConsulenzaStatusDone(step?.consulenzaStatus)) {
        return true;
      }
      return !!step?.done;
    };
    const isRealCheckFinaleStep = (step = {}) => {
      const name = (step?.name || '').toLowerCase();
      const isCheck = name.includes('check') || name.includes('scadenza');
      if (!isCheck) return false;
      // Ignora i check finali ottenuti convertendo il questionario iniziale: non devono sbloccare il programma.
      return !step?.convertedFromQuestionario;
    };
    const hasCheckFinaleCompleted = (steps = []) =>
      (Array.isArray(steps) ? steps : []).some(
        (step) => isRealCheckFinaleStep(step) && isStepEffectivelyDone(step)
      );
    const blockingStepsOnly = (steps = []) =>
      (Array.isArray(steps) ? steps : []).filter(isBlockingStepForSequence);
    const countBlockingSteps = (steps = []) => blockingStepsOnly(steps).length;
    const countBlockingDoneSteps = (steps = []) =>
      blockingStepsOnly(steps).filter(isStepEffectivelyDone).length;
    const countEffectiveDoneSteps = (steps = []) =>
      (Array.isArray(steps) ? steps : []).filter(isStepEffectivelyDone).length;
    const isPercorsoFullyCompleted = (percorso) => isProgrammeComplete(percorso);
    const isPercorsoHistoryLocked = (percorso) => !!(percorso?.historyLocked);
    const hasCompletedUnlockOverride = (percorso) => percorso?.completedUnlockOverride === true;
    const isPercorsoCompleted = (percorso) =>
      !!percorso &&
      !isPercorsoLocked(percorso) &&
      (isPercorsoFullyCompleted(percorso) || isPercorsoHistoryLocked(percorso));
    const isPercorsoPast = (groupId, percorso) => {
      if (!percorso || isPercorsoLocked(percorso)) return false;
      if (!isPercorsoCompleted(percorso)) return false;
      const activeId = activeProgramByGroup.value[groupId];
      if (!activeId) return false;
      return activeId !== percorso.id;
    };
    const programmeLocks = computed(() => computeProgrammeLocks(percorsiVisibili.value));
    const sequentialLocks = computed(() => programmeLocks.value.sequentialLocks);
    // Blocca i programmi di acquisti successivi finché i precedenti non sono conclusi.
    const previousGroupLocks = computed(() => programmeLocks.value.previousLocks);
    const isPercorsoSequentiallyLocked = (percorso) =>
      !!(percorso && sequentialLocks.value[percorso.id]);
    const isPercorsoBlockedByPreviousGroup = (percorso) =>
      !!(percorso && previousGroupLocks.value[percorso.id]);
    const percorsoLockReason = (percorso) => {
      if (isPercorsoHistoryLocked(percorso)) return 'history';
      if (isPercorsoFullyCompleted(percorso) && !hasCompletedUnlockOverride(percorso)) return 'completed';
      if (isPercorsoBlockedByPreviousGroup(percorso)) return 'previous_group';
      if (isPercorsoSequentiallyLocked(percorso)) return 'sequence';
      return null;
    };
    const isPercorsoLocked = (percorso) => percorsoLockReason(percorso) !== null;
    const areNotificationsEnabled = (percorso) => {
      if (percorso?.notificationsEnabled === true) return true;
      if (percorso?.notificationsEnabled === false) return false;
      if ((percorso?.importSource || '').toLowerCase() === 'legacy-program-history') return false;
      return true;
    };
    const notificationChipLabel = (percorso) =>
      areNotificationsEnabled(percorso) ? 'Notifiche attive' : 'Notifiche disabilitate';
    const lockChipLabel = (percorso) => {
      const reason = percorsoLockReason(percorso);
      if (reason === 'history') return 'Storico';
      if (reason === 'completed') return 'Completato';
      if (reason === 'previous_group') return 'Bloccato (precedente)';
      if (reason === 'sequence') return 'Bloccato';
      return '';
    };
    const lockBannerTitle = (percorso) => {
      const reason = percorsoLockReason(percorso);
      if (reason === 'sequence') return 'In attesa del programma precedente';
      if (reason === 'previous_group') return 'In attesa di concludere il percorso precedente';
      if (reason === 'completed') return 'Programma completato';
      return 'Programma importato come storico';
    };
    const lockBannerSubtitle = (percorso) => {
      const reason = percorsoLockReason(percorso);
      if (reason === 'sequence') {
        const seqIndex = Number(percorso?.sequenceIndex) || null;
        const seqTotal = Number(percorso?.sequenceTotal) || null;
        if (seqIndex && seqTotal && seqIndex > 1) {
          return `Completa il programma ${seqIndex - 1}/${seqTotal} per sbloccare questo programma.`;
        }
        return 'Completa il programma precedente della sequenza per procedere.';
      }
      if (reason === 'previous_group') {
        return 'Questo programma è stato acquistato dopo un percorso non ancora concluso. Completa il precedente o sbloccalo manualmente.';
      }
      if (reason === 'completed') {
        return 'Tutti gli step sono completati. Il programma è bloccato automaticamente.';
      }
      return 'Riattivalo per permettere la compilazione degli step.';
    };
    const canReactivatePercorso = (percorso) => {
      const reason = percorsoLockReason(percorso);
      return reason === 'history' || reason === 'completed';
    };
    const canManuallyUnlockSequence = (percorso) => {
      const reason = percorsoLockReason(percorso);
      return reason === 'sequence' || reason === 'previous_group';
    };

    const canViewPastCheck = (row) =>
      row?.key === 'check_finale' && !!row?.isDone;
    const isRowActionDisabled = (percorso, row) => {
      if (isPercorsoLocked(percorso)) return true;
      if (row?.key === 'check_finale' && row.isLockedByConsegna) return true;
      return false;
    };
    const isImportedPercorso = (percorso) =>
      !!(percorso?.importSource || percorso?.importBatchId || percorso?.importedAt);
    const isFinalCheckDailyBlocked = (percorso, stepKey, explicitIndex = null) => {
      if (!percorso || stepKey !== 'check_finale') return false;
      if (isImportedPercorso(percorso)) return false;
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return false;
      const step = Array.isArray(percorso?.steps) ? percorso.steps[idx] : null;
      if (step?.convertedFromQuestionario) return false;
      const currentIndex = toSequenceIndex(percorso?.sequenceIndex);
      const total = toSequenceIndex(percorso?.sequenceTotal);
      if (currentIndex == null || total == null) return false;
      return currentIndex >= total;
    };
    const canShowDailySendForStep = (percorso, row) => {
      if (!row || row.step?.adminStatus !== 'approved') return false;
      if (row.key !== 'questionario' && row.key !== 'check_finale') return false;
      return !isFinalCheckDailyBlocked(percorso, row.key, row.realIndex);
    };
    const canBypassDailySendNotificationGate = (percorso, row) =>
      !!(row && canRepeatDailySendForContext(row.step));
    const isDailySendButtonDisabled = (percorso, row) => {
      if (!percorso || !row) return true;
      if (isPercorsoLocked(percorso)) return true;
      if (!areNotificationsEnabled(percorso) && !canBypassDailySendNotificationGate(percorso, row)) return true;
      if (savingDaily.value[keyFor(percorso.id, row.key)]) return true;
      if (isStepDailySent(row.step) && !canRepeatDailySendForContext(row.step)) return true;
      return false;
    };
    const dailySendButtonTitle = (percorso, row) => {
      if (!percorso || !row) return 'Invio di giornata';
      if (savingDaily.value[keyFor(percorso.id, row.key)]) return 'Salvataggio…';
      if (isStepDailySent(row.step)) {
        if (!areNotificationsEnabled(percorso) && canRepeatDailySendForContext(row.step)) {
          return 'Invia di nuovo e aggiorna la data di invio';
        }
        return canRepeatDailySendForContext(row.step)
          ? 'Invia di nuovo e aggiorna la data di invio'
          : 'Invio già registrato';
      }
      return 'Invio di giornata';
    };
    const canMarkDailyManual = computed(() => canAddProgram.value);
    const canShowDailyHideForStep = (row) => {
      if (!canMarkDailyManual.value || !row) return false;
      return row.key === 'questionario' || row.key === 'check_finale';
    };
    const productsById = computed(() => {
      const map = {};
      for (const prod of products.value) {
        map[prod.id] = prod;
      }
      return map;
    });

    const findProductForPercorso = (percorso) => {
      if (!percorso) return null;
      if (percorso.productId && productsById.value[percorso.productId]) {
        return productsById.value[percorso.productId];
      }
      const name = (percorso.productName || '').trim().toLowerCase();
      if (!name) return null;
      return products.value.find(
        (prod) => (prod.name || '').trim().toLowerCase() === name
      ) || null;
    };

    const monthsLabel = (months) => {
      if (!Number.isFinite(months) || months <= 0) return '';
      return months === 1 ? '1 mese' : `${months} mesi`;
    };

    const toDateSafe = (value) => {
      if (value === undefined || value === null) return null;
      if (typeof value?.toDate === 'function') {
        try {
          const converted = value.toDate();
          return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
        } catch {
          return null;
        }
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
      }
      if (typeof value === 'string' || typeof value === 'number') {
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      return null;
    };

    const addMonthsToDate = (date, months) => {
      if (!Number.isFinite(months) || months <= 0) return null;
      const base = toDateSafe(date);
      if (!base) return null;
      const result = new Date(base);
      result.setMonth(result.getMonth() + months);
      return result;
    };

    const normalizeExpireSteps = (steps) => {
      if (Array.isArray(steps)) return steps;
      if (steps && typeof steps === 'object') {
        return Object.keys(steps)
          .sort((a, b) => Number(a) - Number(b))
          .map((key) => steps[key]);
      }
      return [];
    };

    const resolvePercorsoExpireDate = (percorso = {}) => {
      if (!percorso?.consulenzeOnly) {
        const steps = normalizeExpireSteps(percorso?.steps);
        const consegnaStep = steps.find((step) =>
          String(step?.name || '').toLowerCase().includes('consegna')
        );
        const anchor = toDateSafe(consegnaStep?.doneAt || consegnaStep?.plannedAt);
        if (anchor) {
          return new Date(anchor.getTime() + 30 * DAY_MS);
        }
      }

      const stored = toDateSafe(percorso?.expireAt);
      if (stored) return stored;

      return addMonthsToDate(
        percorso?.plannedStartAt || percorso?.createdAt,
        Number(percorso?.duration_months)
      );
    };

    const resolveGroupSequenceNote = (percorsi = []) => {
      if (!Array.isArray(percorsi) || !percorsi.length) return '';
      const notes = percorsi.map((p) => (p?.sequenceNote ?? '').toString().trim());
      const firstNonEmpty = notes.find((value) => value);
      return firstNonEmpty ?? notes[0] ?? '';
    };

    const groupedPercorsi = computed(() => {
      const list = percorsiVisibili.value || [];
      const groups = [];
      const seen = new Map();

      for (const percorso of list) {
        const gid = percorso.sequenceGroupId || percorso.id;
        let group = seen.get(gid);
        if (!group) {
          group = { id: gid, percorsi: [] };
          seen.set(gid, group);
          groups.push(group);
        }
        group.percorsi.push(percorso);
      }

      return groups.map((group) => {
        const first = group.percorsi[0] || {};
        const product = findProductForPercorso(first);
        const totalPrograms = Number(first.sequenceTotal) || group.percorsi.length;
        const overrideDuration = Number(first.sequenceDurationMonths);
        const baseDuration = Number(product?.duration_months);
        const durationMonths = (Number.isFinite(overrideDuration) && overrideDuration > 0)
          ? overrideDuration
          : (Number.isFinite(baseDuration) && baseDuration > 0 ? baseDuration : null);

        const productLabel =
          first.productName ||
          product?.name ||
          renderProgramTitle(first.title);

        const earliestStartDate = group.percorsi.reduce((min, p) => {
          const val = toDateSafe(p.plannedStartAt || p.createdAt);
          if (!val) return min;
          if (!min || val < min) return val;
          return min;
        }, null);

        const fallbackExpireDate = group.percorsi.reduce((max, p) => {
          const val = toDateSafe(p.expireAt);
          if (!val) return max;
          if (!max || val > max) return val;
          return max;
        }, null);

        return {
          id: group.id,
          productLabel,
          totalPrograms,
          durationMonths,
          durationLabel: monthsLabel(durationMonths),
          startAt: earliestStartDate,
          expireAt: fallbackExpireDate,
          fallbackExpireAt: fallbackExpireDate,
          sequenceNote: resolveGroupSequenceNote(group.percorsi),
          percorsi: group.percorsi,
        };
      });
    });

    const activeProgramByGroup = computed(() => {
      const map = {};
      for (const group of groupedPercorsi.value || []) {
        const active = (group.percorsi || []).find(
          (percorso) => !isPercorsoLocked(percorso) && !isPercorsoFullyCompleted(percorso)
        );
        if (active?.id) {
          map[group.id] = active.id;
        }
      }
      return map;
    });

    const setUpdatingGroupDuration = (groupId, active) => {
      const next = { ...updatingGroupDuration.value };
      if (active) next[groupId] = true;
      else delete next[groupId];
      updatingGroupDuration.value = next;
    };

    const updateGroupDuration = async (group, months) => {
      if (!group?.id) return;
      if (!canAddProgram.value) {
        notify('Non hai i permessi per modificare la durata.', 'error');
        return;
      }
      const nextMonths = Number(months);
      if (!Number.isFinite(nextMonths) || nextMonths <= 0) {
        notify('Seleziona una durata valida.', 'error');
        return;
      }
      if (updatingGroupDuration.value[group.id]) return;

      const programs = (group.percorsi || []).filter(p => p?.id);
      if (!programs.length) return;

      setUpdatingGroupDuration(group.id, true);
      try {
        const batch = writeBatch(db);
        const idSet = new Set();
        programs.forEach((p) => {
          idSet.add(p.id);
          batch.update(doc(db, 'percorsi', p.id), { sequenceDurationMonths: nextMonths });
        });
        await batch.commit();
        percorsi.value = percorsi.value.map((p) =>
          idSet.has(p.id) ? { ...p, sequenceDurationMonths: nextMonths } : p
        );
        notify('Durata percorso aggiornata.', 'success');
      } catch (error) {
        console.error('updateGroupDuration error', error);
        notify('Errore durante l\'aggiornamento della durata.', 'error');
      } finally {
        setUpdatingGroupDuration(group.id, false);
      }
    };

    const onGroupDurationChange = (group, value) => updateGroupDuration(group, value);

    const getGroupNoteValue = (group) => {
      if (!group?.id) return '';
      const draft = groupNoteEdits.value[group.id];
      if (draft !== undefined) return draft;
      return group.sequenceNote || '';
    };

    const onGroupNoteInput = (groupId, value) => {
      if (!groupId) return;
      groupNoteEdits.value = { ...groupNoteEdits.value, [groupId]: value };
    };

    const saveGroupNote = async (group) => {
      if (!group?.id) return;
      if (updatingGroupNote.value[group.id]) return;
      const programs = (group.percorsi || []).filter(p => p?.id);
      if (!programs.length) return;

      const rawValue = getGroupNoteValue(group);
      const nextValue = (rawValue || '').trim();
      const currentValue = (group.sequenceNote || '').trim();
      if (nextValue === currentValue) return;

      updatingGroupNote.value = { ...updatingGroupNote.value, [group.id]: true };
      try {
        const batch = writeBatch(db);
        const idSet = new Set();
        programs.forEach((p) => {
          idSet.add(p.id);
          batch.update(doc(db, 'percorsi', p.id), { sequenceNote: nextValue || null });
        });
        await batch.commit();
        percorsi.value = percorsi.value.map((p) =>
          idSet.has(p.id) ? { ...p, sequenceNote: nextValue || null } : p
        );
        groupNoteEdits.value = { ...groupNoteEdits.value, [group.id]: nextValue };
        notify('Note percorso aggiornate.', 'success');
      } catch (error) {
        console.error('saveGroupNote error', error);
        notify('Errore durante il salvataggio delle note percorso.', 'error');
      } finally {
        const next = { ...updatingGroupNote.value };
        delete next[group.id];
        updatingGroupNote.value = next;
      }
    };

    // helper: restituisce mappa groupId -> percorso attivo (sbloccato e non concluso)
    const buildActiveProgramMap = (list = []) => {
      const map = {};
      const groups = new Map();
      for (const percorso of list) {
        if (!percorso?.id || percorso.consulenzeOnly) continue;
        const gid = percorso.sequenceGroupId || percorso.id;
        const arr = groups.get(gid) || [];
        arr.push(percorso);
        groups.set(gid, arr);
      }
      for (const [gid, arr] of groups.entries()) {
        const active = (arr || []).find(
          (p) => !isPercorsoLocked(p) && !isPercorsoFullyCompleted(p)
        );
        if (active?.id) map[gid] = active.id;
      }
      return map;
    };
    const isActiveGroup = (groupId) => !!activeProgramByGroup.value[groupId];
    const isActiveProgram = (groupId, percorsoId) =>
      activeProgramByGroup.value[groupId] === percorsoId;

    const groupHasPreviousBlocked = (group) => {
      if (!group) return false;
      return (group.percorsi || []).some((p) => isPercorsoBlockedByPreviousGroup(p));
    };

    watch(() => form.value.productId, () => {
      // reset index quando cambia prodotto
      const total = selectedProductTotal.value;
      if (!Number.isFinite(form.value.currentIndex) || form.value.currentIndex < 1) {
        form.value.currentIndex = 1;
      } else if (form.value.currentIndex > total) {
        form.value.currentIndex = total;
      }
    });
    watch(() => createPercorsoForm.value.productId, () => {
      const total = createSelectedProductTotal.value;
      if (!Number.isFinite(createPercorsoForm.value.quantity) || createPercorsoForm.value.quantity < 1) {
        createPercorsoForm.value.quantity = 1;
      } else if (createPercorsoForm.value.quantity > total) {
        createPercorsoForm.value.quantity = total;
      }
    });

    const renderProgramTitle = (rawTitle) => normalizeProgramTitle(rawTitle);

    const toSequenceIndex = (value) => {
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    };

    const findNextPercorsoInSequence = (percorso) => {
      if (!percorso) return null;
      const currentIndex = toSequenceIndex(percorso.sequenceIndex);
      if (currentIndex == null) return null;
      const nextIndex = currentIndex + 1;
      const groupId = percorso.sequenceGroupId || percorso.id;
      if (!groupId) return null;
      const list = percorsi.value || [];
      return list.find((p) => {
        if (p.consulenzeOnly) return false;
        const candidateGroup = p.sequenceGroupId || p.id;
        const candidateIndex = toSequenceIndex(p.sequenceIndex);
        return candidateGroup === groupId && candidateIndex === nextIndex;
      }) || null;
    };




    // Costruiamo le righe "consulenza" direttamente dagli step dei percorsi
const consulenzeRows = computed(() => {
  const rows = [];
  for (const p of (percorsi.value || [])) {
    const steps = Array.isArray(p.steps) ? p.steps : [];
    steps.forEach((s, idx) => {
      // usiamo la tua normalizzazione già presente
      const key =
        (s?.name || '').toLowerCase().includes('questionario') ? 'questionario' :
        (s?.name || '').toLowerCase().includes('consegna') ? 'consegna' :
        ((s?.name || '').toLowerCase().includes('check') || (s?.name || '').toLowerCase().includes('scadenza')) ? 'check_finale' :
        (s?.name || '').toLowerCase().includes('consulenza') ? 'consulenza' : null;

      if (key !== 'consulenza') return;

      rows.push({
        rowId: `${p.id}__${idx}`,
        percorsoId: p.id,
        percorso: p,
        realIndex: idx,

        // comodo per rendering
        percorsoTitle: renderProgramTitle(p.title),
        productName: p.productName || null,
        sequenceIndex: p.sequenceIndex || 1,
        sequenceTotal: p.sequenceTotal || 1,
        expireAt: p.expireAt || null,

        // campi step
        plannedAt: s.plannedAt || null,
        doneAt: s.doneAt || null,
        scalataAt: s.scalataAt || null,
        staffNote: s.staffNote || '',
        consulenzaStatus: s.consulenzaStatus || 'Da fare',
consulenzaType: s.consulenzaType || '',
        TrainerNome: s.TrainerNome || '',
      });
    });
  }
  return rows;
});

const activeConsulenzaRowId = ref('');
const activeConsulenzaRow = computed(() =>
  consulenzeRows.value.find((row) => row.rowId === activeConsulenzaRowId.value) || null
);
const openConsulenzaDetail = (row) => {
  activeConsulenzaRowId.value = row?.rowId || '';
};
const closeConsulenzaDetail = () => {
  activeConsulenzaRowId.value = '';
};
const consulenzaStatusClass = (status) => {
  const normalized = normalizeConsulenzaStatus(status);
  if (normalized === 'Fatta') return 'consulenza-pill--done';
  if (normalized === 'Rifiutata') return 'consulenza-pill--rejected';
  if (normalized === 'Contattata') return 'consulenza-pill--contacted';
  if (normalized === 'Prenotata') return 'consulenza-pill--scheduled';
  if (normalized === 'Scalata') return 'consulenza-pill--escalated';
  return 'consulenza-pill--todo';
};
const consulenzaTypeClass = (type) => {
  const normalized = String(type || '').trim().toLowerCase();
  if (normalized === 'tecnica') return 'consulenza-pill--technical';
  if (normalized === 'nutrizionale') return 'consulenza-pill--nutritional';
  return 'consulenza-pill--neutral';
};

const consulenzaMoveOptions = computed(() =>
  (percorsiVisibili.value || []).map(p => ({
    id: p.id,
    label: `${renderProgramTitle(p.title)}${p.sequenceTotal ? ` · Prog. ${p.sequenceIndex}/${p.sequenceTotal}` : ''}`
  }))
);

    const buildDaysDiff = (dueMs, nowMs) => {
      if (!Number.isFinite(dueMs) || !Number.isFinite(nowMs)) return null;
      if (dueMs >= nowMs) return Math.ceil((dueMs - nowMs) / DAY_MS);
      return -Math.ceil((nowMs - dueMs) / DAY_MS);
    };

    const parseReminderField = (value) => {
      const isBlocked =
        value === 'blocked' ||
        (value && typeof value === 'object' && value.blocked === true);
      const sentAt = toDateSafe(value?.sentAt || value);
      const blockedAt = toDateSafe(value?.blockedAt);
      const paused = value?.paused === true;
      const resumeAt = toDateSafe(value?.resumeAt);
      return { isBlocked, sentAt, blockedAt, paused, resumeAt };
    };

    const upcomingReminders = computed(() => {
      const nowMs = Date.now();
      const rows = [];

      for (const p of percorsiVisibili.value || []) {
        const notificationsOn = areNotificationsEnabled(p);
        const steps = Array.isArray(p.steps) ? p.steps : [];
        const checkDone = hasCheckFinaleCompleted(steps);

        steps.forEach((step, idx) => {
          if (stepKeyFromName(step?.name) !== 'consegna') return;
          if (!step?.done || !step?.doneAt) return;
          const doneDate = toDateSafe(step.doneAt);
          if (!doneDate) return;

          REMINDER_CONFIG.forEach(({ days, field, label }) => {
            if (!days || !field || !label) return;
            const { isBlocked, sentAt, blockedAt, paused, resumeAt } = parseReminderField(step[field]);
            const dueAt = new Date(doneDate.getTime() + days * DAY_MS);
            if (Number.isNaN(dueAt.getTime())) return;
            const dueMs = dueAt.getTime();
            const daysDiff = buildDaysDiff(dueMs, nowMs);
            const blockedByCheck = checkDone && !sentAt;
            let status = 'upcoming';
            if (sentAt) status = 'sent';
            else if (blockedByCheck || isBlocked) status = 'blocked';
            else if (!notificationsOn) status = 'disabled';
            else if (resumeAt) status = 'upcoming';
            else if (daysDiff < 0) status = 'overdue';
            rows.push({
              key: `${p.id}_${idx}_${field}`,
              percorsoId: p.id,
              stepIndex: idx,
              stepName: step.name || 'Consegna programmi',
              programTitle: renderProgramTitle(p.title),
              sequenceLabel: p.sequenceTotal ? `${p.sequenceIndex}/${p.sequenceTotal}` : '',
              typeLabel: label,
              dueAt,
              dueMs,
              daysDiff,
              status,
              blocked: isBlocked,
              blockedByCheck,
              sentAt,
              blockedAt,
              paused,
              resumeAt,
              followUpDays: days,
              sentField: field,
              notificationsOn,
            });
          });
        });
      }

      return rows.sort((a, b) => a.dueMs - b.dueMs);
    });

    const visibleReminders = computed(() => {
      const list = upcomingReminders.value || [];
      if (showHistoricalReminders.value) return list;
      return list.filter(item => item.status === 'upcoming' || item.status === 'overdue');
    });
    const hasUpcomingReminders = computed(() => (visibleReminders.value || []).length > 0);
    const pendingRemindersCount = computed(() => (visibleReminders.value || []).length);
    const reminderCountLabel = computed(() =>
      showHistoricalReminders.value ? 'promemoria visibili' : 'promemoria da gestire'
    );
    const reminderEmptyLabel = computed(() =>
      showHistoricalReminders.value ? 'Nessun promemoria disponibile' : 'Nessun promemoria in coda'
    );

    const reminderStatusLabel = (item) => {
      if (!item) return '';
      if (item.status === 'sent') return 'Inviata';
      if (item.status === 'blocked') return 'Bloccato';
      if (item.status === 'disabled') return 'Notifiche disattivate';
      if (item.resumeAt) return 'In arrivo';
      if (item.daysDiff === 0) return 'Oggi';
      if (item.daysDiff < 0) return 'In ritardo';
      return 'In arrivo';
    };

    const reminderBadgeClass = (item) => {
      if (!item) return '';
      if (item.status === 'blocked') return 'badge-blocked';
      if (item.status === 'sent') return 'badge-sent';
      if (item.status === 'disabled') return 'badge-muted';
      if (item.daysDiff < 0) return 'badge-danger';
      if (item.daysDiff === 0) return 'badge-warning';
      return 'badge-success';
    };

    const reminderTimingLabel = (item) => {
      if (!item || item.daysDiff == null) return '—';
      if (item.status === 'sent') {
        return item.sentAt ? `Inviata il ${formatDateOnly(item.sentAt)}` : 'Inviata';
      }
      if (item.blockedByCheck) {
        return 'Bloccato (check completato)';
      }
      if (item.status === 'blocked') {
        return item.blockedAt ? `Bloccato il ${formatDateOnly(item.blockedAt)}` : 'Bloccato';
      }
      if (item.status === 'disabled') return 'Invio sospeso (notifiche off)';
      if (item.resumeAt) {
        return 'Programmato per il prossimo ciclo';
      }
      const abs = Math.abs(item.daysDiff);
      if (item.daysDiff > 0) return abs === 1 ? 'Tra 1 giorno' : `Tra ${abs} giorni`;
      if (item.daysDiff === 0) return 'Oggi';
      return abs === 1 ? 'In ritardo di 1 giorno' : `In ritardo di ${abs} giorni`;
    };

    const detachedConsulenzeCount = computed(() =>
      consulenzeRows.value.filter(row => row.percorso?.consulenzeOnly).length
    );
    const hasDetachedConsulenze = computed(() => detachedConsulenzeCount.value > 0);

    /* ===== utils base ===== */
    const parseSequenceIndex = (value) => {
      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
      }
      if (typeof value === 'string') {
        const match = value.match(/\d+/);
        return match ? Number(match[0]) : null;
      }
      return null;
    };
    const getSequenceIndex = (percorso) => parseSequenceIndex(percorso?.sequenceIndex);
    const stepKeyFromName = (name = '') => {
      const n = (name || '').toLowerCase();
      if (n.includes('check') || n.includes('scadenza')) return 'check_finale';
      if (n.includes('questionario')) return 'questionario';
      if (n.includes('consegna')) return 'consegna';
      if (n.includes('consulenza')) return 'consulenza';   // <-- necessario
      return null;
    };
    const isConsulenzaKey = (key) => key === 'consulenza';

    const sortPercorsiBySequence = (a, b) => {
      const ix = Number(a?.sequenceIndex) || 0;
      const iy = Number(b?.sequenceIndex) || 0;
      if (ix !== iy) return ix - iy;
      const ax = toComparableString(a?.plannedStartAt || a?.createdAt);
      const ay = toComparableString(b?.plannedStartAt || b?.createdAt);
      return ax.localeCompare(ay);
    };

    const buildSequenceTitle = (title, sequenceIndex, sequenceTotal) => {
      if (!title) return null;
      const match = String(title).match(/^(.*?)(?:\s*-\s*(Percorso|Programma)\s*\d+\s*\/\s*\d+)\s*$/i);
      if (!match) return null;
      const base = match[1].trim();
      const label = match[2] || 'Percorso';
      if (!base) return `${label} ${sequenceIndex}/${sequenceTotal}`;
      return `${base} - ${label} ${sequenceIndex}/${sequenceTotal}`;
    };

    const resolveDurationMonths = (percorso) => {
      const viaPercorso = Number(percorso?.duration_months);
      if (Number.isFinite(viaPercorso) && viaPercorso > 0) return viaPercorso;
      const product = findProductForPercorso(percorso);
      const viaProduct = Number(product?.duration_months);
      if (Number.isFinite(viaProduct) && viaProduct > 0) return viaProduct;
      return 1;
    };

    const resolveNextPlannedStartIso = (percorso, durationMonths) => {
      const expire = resolvePercorsoExpireDate(percorso);
      if (expire) return expire.toISOString();
      const base = percorso?.plannedStartAt || percorso?.createdAt || new Date().toISOString();
      const next = addMonthsToDate(base, durationMonths);
      return next ? next.toISOString() : new Date().toISOString();
    };

    const resolveExpireIso = (percorso) => {
      const next = resolvePercorsoExpireDate(percorso);
      return next ? next.toISOString() : null;
    };

    const buildStepsForClone = (percorso, plannedStartIso) => {
      const steps = Array.isArray(percorso?.steps) ? percorso.steps : [];
      const hasQuestionario = steps.some((step) => stepKeyFromName(step?.name) === 'questionario');
      const counts = { tecnica: 0, nutrizionale: 0 };
      steps.forEach((step) => {
        if (stepKeyFromName(step?.name) !== 'consulenza') return;
        const type = (step?.consulenzaType || '').toLowerCase();
        if (type === 'nutrizionale') counts.nutrizionale += 1;
        else counts.tecnica += 1;
      });
      const options = { includeQuestionario: hasQuestionario };
      if (counts.tecnica || counts.nutrizionale) {
        options.consulenze = counts;
      }
      return buildStepsWithPlan(plannedStartIso, options);
    };

    const setAddingProgramToGroup = (groupId, active) => {
      const next = { ...addingProgramToGroup.value };
      if (active) next[groupId] = true;
      else delete next[groupId];
      addingProgramToGroup.value = next;
    };

    const addProgramToGroup = async (group) => {
      if (!group?.id) return;
      if (!canAddProgram.value) {
        notify('Non hai i permessi per aggiungere programmi.', 'error');
        return;
      }
      if (addingProgramToGroup.value[group.id]) return;
      const programs = (group.percorsi || []).filter(p => p?.id && !p.consulenzeOnly);
      if (!programs.length) {
        notify('Nessun programma disponibile per questo percorso.', 'error');
        return;
      }

      const sorted = [...programs].sort(sortPercorsiBySequence);
      const last = sorted[sorted.length - 1];
      if (!last) return;

      setAddingProgramToGroup(group.id, true);
      try {
        const total = sorted.length + 1;
        const durationMonths = resolveDurationMonths(last);
        const plannedStartAt = resolveNextPlannedStartIso(last, durationMonths);
        const steps = buildStepsForClone(last, plannedStartAt);
        const nowIso = new Date().toISOString();
        const expireAt = resolveExpireIso({
          plannedStartAt,
          createdAt: nowIso,
          duration_months: durationMonths,
          steps,
        });
        const newDocRef = doc(collection(db, 'percorsi'));
        const batch = writeBatch(db);

        sorted.forEach((p, idx) => {
          const sequenceIndex = idx + 1;
          const payload = {
            sequenceGroupId: group.id,
            sequenceIndex,
            sequenceTotal: total,
          };
          const nextTitle = buildSequenceTitle(p.title, sequenceIndex, total);
          if (nextTitle && nextTitle !== p.title) payload.title = nextTitle;
          batch.update(doc(db, 'percorsi', p.id), payload);
        });

        let newTitle = buildSequenceTitle(last.title, total, total);
        if (!newTitle) {
          const fallback = last.title || last.productName || 'Programma';
          newTitle = last.title ? fallback : `${fallback} - Percorso ${total}/${total}`;
        }

        const payload = {
          uid: last.uid || null,
          userEmail: last.userEmail || null,
          title: newTitle,
          productId: last.productId || null,
          productName: last.productName || null,
          productSku: last.productSku || null,
          sequenceGroupId: group.id,
          sequenceIndex: total,
          sequenceTotal: total,
          createdAt: nowIso,
          plannedStartAt,
          duration_months: durationMonths,
          expireAt: expireAt || null,
          orderRef: last.orderRef ? String(last.orderRef) : null,
          orderSource: last.orderSource || null,
          postponeDays: 0,
          historyLocked: false,
          historyLockedAt: null,
          steps,
        };
        const durationOverride = Number(last.sequenceDurationMonths);
        if (Number.isFinite(durationOverride) && durationOverride > 0) {
          payload.sequenceDurationMonths = durationOverride;
        }
        if (group.sequenceNote || last.sequenceNote) {
          payload.sequenceNote = (group.sequenceNote || last.sequenceNote || '').trim() || null;
        }
        if (last.notificationsEnabled === true || last.notificationsEnabled === false) {
          payload.notificationsEnabled = last.notificationsEnabled;
        }
        if (last.importSource) payload.importSource = last.importSource;
        if (last.manualOrder) payload.manualOrder = true;

        batch.set(newDocRef, payload);
        await batch.commit();
        notify('Programma aggiunto al percorso.', 'success');
      } catch (err) {
        console.error('addProgramToGroup error', err);
        notify('Errore durante l\'aggiunta del programma.', 'error');
      } finally {
        setAddingProgramToGroup(group.id, false);
      }
    };

    const dateFormatter = new Intl.DateTimeFormat('it-IT', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    const formatDate = (value) => {
      const date = toDateSafe(value);
      return date ? dateFormatter.format(date) : '';
    };

    const formatDateOnly = (value) => {
      const date = toDateSafe(value);
      return date ? dateFormatter.format(date) : '';
    };


    const toMillis = (value) => {
      if (value == null) return NaN;
      if (typeof value?.toMillis === 'function') {
        try { return value.toMillis(); } catch { return NaN; }
      }
      const date = toDateSafe(value);
      return date ? date.getTime() : NaN;
    };


    const isToday = (value) => {
      const date = toDateSafe(value);
      if (!date) return false;
      const now = new Date();
      return date.getFullYear() === now.getFullYear()
        && date.getMonth() === now.getMonth()
        && date.getDate() === now.getDate();
    };
    const normalizeAdminDailyState = (rawState, sentFlag = false) => {
      const state = String(rawState || '').trim().toLowerCase();
      if (state === 'inviato' || state === 'nascosto') return state;
      return sentFlag ? 'inviato' : '';
    };
    const resolveStepAdminDailyState = (step) =>
      normalizeAdminDailyState(step?.adminDailyState, step?.adminDailySent);
    const isStepDailyMarked = (step) => {
      const state = resolveStepAdminDailyState(step);
      return state === 'inviato' || state === 'nascosto';
    };
    const isStepDailySent = (step) => resolveStepAdminDailyState(step) === 'inviato';
    const normalizeUidValue = (value) => String(value || '').trim();
    const resolveTargetUserUid = (percorso = null) => {
      const candidates = [
        props.userId,
        percorso?.uid,
      ];
      return candidates.map(normalizeUidValue).find(Boolean) || null;
    };
    const canRepeatDailySendForContext = (step) =>
      canRepeatDailySendPrivileged.value && isStepDailySent(step);
    const dailyStepChipClass = (step) => {
      const state = resolveStepAdminDailyState(step);
      return state === 'nascosto' ? 'chip-neutral' : 'chip-blue';
    };
    const dailyStepChipLabel = (step) => {
      const state = resolveStepAdminDailyState(step);
      if (state === 'nascosto') return 'Nascosto';
      const stamp = step?.adminDailySentAt || step?.adminDailyStateAt;
      return isToday(stamp) ? 'Inviato oggi' : 'Inviato';
    };


    let fetchProductsRequestId = 0;
    let fetchPercorsiRequestId = 0;
    let percorsiRealtimeUnsub = null;

    const normalizeStepsArray = (steps) => {
      if (Array.isArray(steps)) {
        return steps.map((step) => (step && typeof step === 'object' ? { ...step } : step));
      }

      if (steps && typeof steps === 'object') {
        return Object.keys(steps)
          .sort((a, b) => Number(a) - Number(b))
          .map((key) => {
            const step = steps[key];
            return step && typeof step === 'object' ? { ...step } : step;
          });
      }

      return [];
    };

    const normalizePercorsoRecord = (percorso = {}) => {
      const steps = normalizeStepsArray(percorso?.steps);
      const normalized = {
        ...percorso,
        steps,
      };
      const expireAt = resolvePercorsoExpireDate(normalized);
      return {
        ...normalized,
        expireAt: expireAt ? expireAt.toISOString() : null,
      };
    };

    const applyFetchedPercorsi = (rows = []) => {
      const normalizedRows = rows.map((row) => normalizePercorsoRecord(row));

      // gruppi per sequenceGroupId
      const groups = new Map();
      const groupMeta = new Map();
      for (const p of normalizedRows) {
        const gid = p.sequenceGroupId || p.id;
        const arr = groups.get(gid) || [];
        arr.push(p);
        groups.set(gid, arr);

        const anchorThis = toComparableString(p.plannedStartAt || p.createdAt);
        const meta = groupMeta.get(gid) || { anchor: anchorThis || '', productName: p.productName || null };
        if (!meta.anchor || (anchorThis && anchorThis < meta.anchor)) meta.anchor = anchorThis;
        if (!meta.productName && p.productName) meta.productName = p.productName;
        groupMeta.set(gid, meta);
      }

      // ordina gruppi recenti in alto
      const groupOrder = Array.from(groups.keys()).sort((a, b) => {
        const aa = toComparableString(groupMeta.get(a)?.anchor);
        const bb = toComparableString(groupMeta.get(b)?.anchor);
        return bb.localeCompare(aa);
      });

      // ricostruisci lista ordinata per sequenceIndex
      const sorted = [];
      for (const gid of groupOrder) {
        const list = groups.get(gid) || [];
        list.sort((x, y) => {
          const ix = Number(x.sequenceIndex) || 0;
          const iy = Number(y.sequenceIndex) || 0;
          if (ix !== iy) return ix - iy;
          const dx = toComparableString(x.plannedStartAt || x.createdAt);
          const dy = toComparableString(y.plannedStartAt || y.createdAt);
          return dx.localeCompare(dy);
        });
        sorted.push(...list);
      }

      percorsi.value = sorted;

      // apri di default solo i percorsi attivi (uno per gruppo)
      const activeMap = buildActiveProgramMap(sorted);

      // nessun programma aperto di default: si aprono solo su click
      const hasExistingOpen = Object.keys(openIds.value || {}).some((k) => !!openIds.value[k]);
      const nextOpen = {};
      const nextOpenGroups = {};
      const visible = sorted.filter((p) => !p.consulenzeOnly);

      // preserva solo gli aperti manualmente
      if (hasExistingOpen) {
        for (const p of sorted) {
          if (openIds.value[p.id]) nextOpen[p.id] = true;
        }
      }

      for (const p of visible) {
        const gid = p.sequenceGroupId || p.id;
        if (!gid || nextOpenGroups[gid] !== undefined) continue;
        const hasExistingGroupState = openGroups.value[gid] !== undefined;
        nextOpenGroups[gid] = hasExistingGroupState ? openGroups.value[gid] : !!activeMap[gid];
      }
      openIds.value = nextOpen;
      openGroups.value = nextOpenGroups;

      // inizializza editor note per ogni step (chiave unica per indice reale)
      for (const p of sorted) {
        p.steps.forEach((s, idx) => {
          const key = stepKeyFromName(s?.name);
          if (!key) return;
          const noteKey = stepIndexKey(p.id, idx);
          if (staffNoteEdits.value[noteKey] == null) {
            staffNoteEdits.value[noteKey] = s?.staffNote ?? '';
          }
        });
      }
    };

    const realtimeAdminStepFields = Object.freeze([
      'adminStatus',
      'adminNote',
      'adminUpdatedAt',
      'adminWorked',
      'adminWorkedAt',
      'adminDailySent',
      'adminDailySentAt',
      'adminDailyState',
      'adminDailyStateAt',
      'allowCheckOverride',
      'allowCheckOverrideAt',
      'staffNote',
      'scalataAt',
    ]);

    const stopPercorsiRealtimeAdminNotes = () => {
      if (typeof percorsiRealtimeUnsub === 'function') {
        percorsiRealtimeUnsub();
        percorsiRealtimeUnsub = null;
      }
    };

    /* ===== prodotti ===== */
    const fetchProducts = async () => {
      const requestId = ++fetchProductsRequestId;
      try {
        const qProd = query(collection(db, 'products'));
        const qs = await getDocs(qProd);
        if (requestId !== fetchProductsRequestId) return;
        const list = qs.docs.map((d) => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        products.value = list;
      } catch (e) {
        console.error('Errore caricamento products:', e);
      }
    };

    /* ===== percorsi utente ===== */
    const fetchPercorsi = async (uid = props.userId) => {
      const requestId = ++fetchPercorsiRequestId;
      if (!uid) {
        percorsi.value = [];
        loading.value = false;
        error.value = '';
        return;
      }

      loading.value = true;
      error.value = '';

      try {
        const qPerc = query(collection(db, 'percorsi'), where('uid', '==', uid));
        const qs = await getDocs(qPerc);
        if (requestId !== fetchPercorsiRequestId) return;
        const rows = qs.docs.map((d) => ({ id: d.id, ...d.data() }));
        applyFetchedPercorsi(rows);
      } catch (e) {
        if (requestId !== fetchPercorsiRequestId) return;
        error.value = e.message || String(e);
      } finally {
        if (requestId === fetchPercorsiRequestId) {
          loading.value = false;
        }
      }
    };

    /* ===== crea percorsi manuali ===== */
    const addPercorso = async () => {
      try {
        creating.value = true;
        const now = new Date().toISOString();

        let qty = 1, productName = null, productId = form.value.productId || null;
        const prod = productId ? products.value.find(p => p.id === productId) : null;
        if (prod) {
          const cq = Number(prod.coaching_quantity);
          qty = Number.isFinite(cq) && cq > 0 ? cq : 1;
          productName = prod.name || null;
        }

        const historyCount = Math.max(0, Number(form.value.currentIndex || 1) - 1);

        await createPercorsiForProduct({
          uid: props.userId,
          userEmail: null,
          product: prod,
          coachingQty: qty,
          quantityMultiplier: 1,
          orderRef: null,
          orderSource: null,
          nowIso: now,
          titleBase: form.value.title || productName || 'Programma',
          historyLockCount: historyCount,
        });
        await fetchPercorsi(props.userId);



        // non aprire automaticamente il nuovo programma: resta gestito dall'utente
        closeModal();
      } catch (e) {
        console.error('Errore nel salvataggio dei percorsi:', e);
        notify('Errore nel salvataggio dei percorsi.', 'error');
      } finally {
        creating.value = false;
      }
    };

    const closeModal = () => {
      showModal.value = false;
      form.value = { productId: '', currentIndex: 1, title: '' };
    };

    const todayInput = () => {
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const openCreatePercorsoModal = () => {
      if (!canCreatePercorso.value) return;
      if (!createPercorsoForm.value.startDate) {
        createPercorsoForm.value.startDate = todayInput();
      }
      createPercorsoModalOpen.value = true;
    };

    const closeCreatePercorsoModal = () => {
      createPercorsoModalOpen.value = false;
      createPercorsoForm.value = { productId: '', quantity: 1, startDate: '' };
      creatingPercorso.value = false;
    };

    const createPercorsoFromModal = async () => {
      if (!canCreatePercorso.value) {
        notify('Non hai i permessi per creare percorsi.', 'error');
        return;
      }
      if (creatingPercorso.value) return;
      const prod = createSelectedProduct.value;
      if (!prod) {
        notify('Seleziona un prodotto valido.', 'error');
        return;
      }
      const maxQty = createSelectedProductTotal.value;
      let qty = Number(createPercorsoForm.value.quantity) || 1;
      if (qty < 1) qty = 1;
      if (qty > maxQty) qty = maxQty;

      const startStr = (createPercorsoForm.value.startDate || '').trim();
      const parsed = startStr ? new Date(`${startStr}T00:00:00.000Z`) : new Date();
      const startIso = Number.isNaN(parsed.getTime()) ? new Date().toISOString() : parsed.toISOString();

      try {
        creatingPercorso.value = true;
        await createPercorsiForProduct({
          uid: props.userId,
          userEmail: null,
          product: prod,
          coachingQty: qty,
          quantityMultiplier: 1,
          orderRef: null,
          orderSource: null,
          nowIso: startIso,
          titleBase: prod.name || 'Programma',
          historyLockCount: 0,
          fixedMonthsPerProgram: 1,
        });
        await fetchPercorsi(props.userId);
        notify('Percorso creato.', 'success');
        closeCreatePercorsoModal();
      } catch (e) {
        console.error('Errore nel salvataggio del percorso:', e);
        notify('Errore nel salvataggio del percorso.', 'error');
      } finally {
        creatingPercorso.value = false;
      }
    };
    const toggleOpen = (id) => {
      if (!id) return;
      const isOpen = !!openIds.value[id];
      openIds.value = isOpen ? {} : { [id]: true };
    };

    const toggleGroupOpen = (groupId) => {
      if (!groupId) return;
      const current = !!openGroups.value[groupId];
      openGroups.value = { ...openGroups.value, [groupId]: !current };
    };

    /* ===== indice step per key ===== */
    const getRealIndexByKey = (percorso, stepKey) =>
      (percorso?.steps || []).findIndex(s => stepKeyFromName(s?.name) === stepKey);
    const resolveStepIndex = (percorso, stepKey, explicitIndex) => {
      if (Number.isInteger(explicitIndex) && explicitIndex >= 0) return explicitIndex;
      return getRealIndexByKey(percorso, stepKey);
    };

    const isQuestionarioDisabled = (percorso, row) => {
      if (!percorso || row?.key !== 'questionario') return true;
      const idx = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      // il questionario iniziale resta apribile anche se il programma è bloccato
      return idx < 0;
    };

    /* ===== selettore stato “generico” (Da fare/Fatto) ===== */
    const onSelectChange = async (event, percorso, stepIndex) => {
      if (isPercorsoLocked(percorso)) return;
      const wantDone = event.target.value === 'Fatto';
      const currentDone = !!(Array.isArray(percorso?.steps) && percorso.steps[stepIndex]?.done);
      if (currentDone === wantDone) return;
      try {
        await setStepDone(percorso.id, stepIndex, wantDone);
        await fetchPercorsi(props.userId);
      } catch (err) {
        console.error('Errore aggiornando lo step:', err);
        notify("Errore nell'aggiornamento dello step.", 'error');
      }
    };

    // Wrapper per key — intercetta CONSULENZA e delega allo specifico handler
    const onSelectChangeByKey = (event, percorso, stepKey, explicitIndex = null) => {
      if (isPercorsoLocked(percorso)) return;
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;

      if (isConsulenzaKey(stepKey)) {
        // mappa eventuali “Fatto/Da fare” del template base
        const raw = String(event?.target?.value || '').trim();
        const normalized =
          raw === 'Fatto'     ? 'Fatta' :
          raw === 'Da fare'   ? 'Da fare' :
          raw; // Contattata / Prenotata / Rifiutata / Fatta / Da fare
        return onConsulenzaStatusChangeByKey(percorso, stepKey, normalized, idx);
      }

      return onSelectChange(event, percorso, idx);
    };

    const isConsegnaFlagSaving = (percorso, row) => {
      const idx = resolveStepIndex(percorso, 'consegna', row?.realIndex ?? null);
      if (idx < 0) return false;
      const mapKey = stepIndexKey(percorso.id, idx);
      return !!updatingConsegnaFlag.value[mapKey];
    };

    const isProgCustomFlagSaving = (percorso, row) => {
      const idx = resolveStepIndex(percorso, 'consegna', row?.realIndex ?? null);
      if (idx < 0) return false;
      const mapKey = stepIndexKey(percorso.id, idx);
      return !!updatingProgCustomFlag.value[mapKey];
    };

    const applyProgCustomStateLocal = (stateByPercorsoId = {}) => {
      if (!stateByPercorsoId || typeof stateByPercorsoId !== 'object') return;
      const ids = Object.keys(stateByPercorsoId);
      if (!ids.length) return;

      const nowIso = new Date().toISOString();
      const toIsoOrNull = (value) => {
        if (!value) return null;
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d.toISOString();
      };

      percorsi.value = (percorsi.value || []).map((item) => {
        const nextState = stateByPercorsoId[item.id];
        if (!nextState) return item;

        const steps = Array.isArray(item.steps) ? item.steps.map((s) => ({ ...s })) : [];
        const consegnaIdx = steps.findIndex((step) => stepKeyFromName(step?.name) === 'consegna');
        if (consegnaIdx < 0) return item;

        const prev = steps[consegnaIdx] || {};
        const nextCustom = !!nextState.progCustomizzato;
        const nextCustomAt = nextCustom
          ? (toIsoOrNull(nextState.progCustomizzatoAt) || toIsoOrNull(prev.progCustomizzatoAt) || nowIso)
          : null;

        if (
          !!prev.progCustomizzato === nextCustom &&
          (toIsoOrNull(prev.progCustomizzatoAt) || null) === nextCustomAt
        ) {
          return item;
        }

        steps[consegnaIdx] = {
          ...prev,
          progCustomizzato: nextCustom,
          progCustomizzatoAt: nextCustomAt,
        };
        return { ...item, steps };
      });
    };

    const applyConsegnaStateLocal = (percorsoId, stepIndex, done) => {
      if (!percorsoId || !Number.isInteger(stepIndex) || stepIndex < 0) return;
      const nextDone = !!done;
      const nowIso = new Date().toISOString();
      percorsi.value = (percorsi.value || []).map((item) => {
        if (item.id !== percorsoId) return item;
        const steps = Array.isArray(item.steps) ? item.steps.map((s) => ({ ...s })) : [];
        const prev = steps[stepIndex];
        if (!prev) return item;

        const nextDoneAt = nextDone ? (prev.doneAt || nowIso) : null;
        if (
          !!prev.done === nextDone &&
          toComparableString(prev.doneAt) === toComparableString(nextDoneAt)
        ) {
          return item;
        }

        steps[stepIndex] = {
          ...prev,
          done: nextDone,
          doneAt: nextDoneAt,
        };
        return { ...item, steps };
      });
    };

    const onConsegnaFlagToggle = async (percorso, row, wantDone) => {
      if (isPercorsoLocked(percorso)) return;
      const stepIndex = resolveStepIndex(percorso, 'consegna', row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step consegna non trovato per questo programma.', 'error');
        return;
      }
      const currentDone = !!(Array.isArray(percorso?.steps) && percorso.steps[stepIndex]?.done);
      const nextDone = !!wantDone;
      if (currentDone === nextDone) return;

      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (updatingConsegnaFlag.value[mapKey]) return;

      updatingConsegnaFlag.value = { ...updatingConsegnaFlag.value, [mapKey]: true };
      try {
        await setStepDone(percorso.id, stepIndex, nextDone);
        applyConsegnaStateLocal(percorso.id, stepIndex, nextDone);
      } catch (err) {
        console.error('onConsegnaFlagToggle error', err);
        notify("Errore nell'aggiornamento del flag consegnato.", 'error');
      } finally {
        const next = { ...updatingConsegnaFlag.value };
        delete next[mapKey];
        updatingConsegnaFlag.value = next;
      }
    };

    const onProgCustomFlagToggle = async (percorso, row, wantCustom) => {
      if (isPercorsoLocked(percorso)) return;
      const stepIndex = resolveStepIndex(percorso, 'consegna', row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step consegna non trovato per questo programma.', 'error');
        return;
      }

      const currentCustom = !!(Array.isArray(percorso?.steps) && percorso.steps[stepIndex]?.progCustomizzato);
      const nextCustom = !!wantCustom;
      if (currentCustom === nextCustom) return;

      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (updatingProgCustomFlag.value[mapKey]) return;

      updatingProgCustomFlag.value = { ...updatingProgCustomFlag.value, [mapKey]: true };
      try {
        const result = await setProgCustomFlag(percorso.id, nextCustom);
        const stateByPercorsoId = result?.stateByPercorsoId || null;
        if (stateByPercorsoId) {
          applyProgCustomStateLocal(stateByPercorsoId);
        } else {
          applyProgCustomStateLocal({
            [percorso.id]: {
              progCustomizzato: nextCustom,
              progCustomizzatoAt: nextCustom ? new Date().toISOString() : null,
            },
          });
        }
      } catch (err) {
        console.error('onProgCustomFlagToggle error', err);
        notify("Errore nell'aggiornamento del flag programma customizzato.", 'error');
      } finally {
        const next = { ...updatingProgCustomFlag.value };
        delete next[mapKey];
        updatingProgCustomFlag.value = next;
      }
    };

    const openQuestionario = (percorso, row) => {
      if (!percorso || row?.key !== 'questionario') return;
      const stepIndex = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      if (!props.userId) {
        notify('Utente non valido per aprire il questionario.', 'error');
        return;
      }
      router.push({
        name: 'UserProgrammiQuestionario',
        params: { userId: props.userId },
        query: (() => {
          const q = {
            percorsoId: percorso.id,
            stepIndex: String(stepIndex),
            stepKey: row.key
          };

          const assignIfPresent = (key, value) => {
            if (value === undefined || value === null) return;
            const normalized = typeof value === 'string' ? value : String(value);
            if (normalized !== '') q[key] = normalized;
          };

          assignIfPresent('sequenceGroupId', percorso.sequenceGroupId || percorso.id);
          assignIfPresent('sequenceIndex', percorso.sequenceIndex);
          assignIfPresent('sequenceTotal', percorso.sequenceTotal);
          assignIfPresent('productId', percorso.productId);
          assignIfPresent('productName', percorso.productName);
          assignIfPresent('programTitle', percorso.title);
          assignIfPresent('programLabel', renderProgramTitle(percorso.title));
          assignIfPresent('plannedStartAt', percorso.plannedStartAt);
          assignIfPresent('expireAt', percorso.expireAt);
          assignIfPresent('stepName', row.step?.name);
          assignIfPresent('orderRef', percorso.orderRef);

          const docIdCandidates = [
            row.step?.questionnaire?.id,
            row.step?.questionnaire?.questionarioUid,
            row.step?.questionnaire?.questionarioDocId,
            row.step?.questionnaire?.questionnaireDocId,
            row.step?.questionnaireDocId,
            row.step?.questionarioDocId,
          ];
          const docId =
            docIdCandidates
              .map((value) => {
                if (value === undefined || value === null) return '';
                const str = typeof value === 'string' ? value : String(value);
                return str.trim();
              })
              .find(Boolean) || '';
          if (docId) assignIfPresent('questionarioDocId', docId);

          return q;
        })()
      });
    };

    const extractQuestionarioDocId = (step = {}) => {
      const q = step.questionnaire || {};
      const candidates = [
        step.questionarioDocId,
        step.questionnaireDocId,
        q.id,
        q.questionarioUid,
        q.questionarioDocId,
        q.questionnaireDocId,
      ];
      return candidates
        .map((value) => {
          if (value === undefined || value === null) return '';
          const str = typeof value === 'string' ? value : String(value);
          return str.trim();
        })
        .find(Boolean) || '';
    };

    const resetQuestionarioStep = async (percorso, row) => {
      if (!percorso || !row || (row.key !== 'questionario' && row.key !== 'check_finale')) return;
      const stepIndex = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      if (typeof window !== 'undefined') {
        const ok = window.confirm('Eliminare questionario/check e reimpostare lo step a "Da fare"?');
        if (!ok) return;
      }
      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (resettingStep.value[mapKey]) return;
      resettingStep.value = { ...resettingStep.value, [mapKey]: true };
      try {
        const percRef = doc(db, 'percorsi', percorso.id);
        const snap = await getDoc(percRef);
        if (!snap.exists()) throw new Error('Percorso non trovato');
        const data = snap.data() || {};
        const steps = Array.isArray(data.steps) ? [...data.steps] : [];
        const prev = steps[stepIndex] || {};
        const docId = extractQuestionarioDocId(prev);
        steps[stepIndex] = {
          ...prev,
          done: false,
          doneAt: null,
          adminStatus: null,
          questionarioDocId: null,
          questionnaire: null,
        };
        await updateDoc(percRef, { steps });
        if (docId) {
          try {
            await deleteDoc(doc(db, QUESTIONARI_COLLECTION, docId));
          } catch (err) {
            console.warn('Impossibile eliminare il questionario/check finale:', err);
          }
        }
        percorsi.value = percorsi.value.map((p) =>
          p.id === percorso.id ? { ...p, steps } : p
        );
        notify('Step reimpostato a "Da fare" e questionario/check eliminato.', 'success');
      } catch (err) {
        console.error('resetQuestionarioStep error', err);
        notify('Errore durante il reset dello step.', 'error');
      } finally {
        const next = { ...resettingStep.value };
        delete next[mapKey];
        resettingStep.value = next;
      }
    };

    const openCheckFinale = (percorso, row) => {
      if (!percorso || row?.key !== 'check_finale') return;
      if (isRowActionDisabled(percorso, row) && !canViewPastCheck(row)) return;
      const stepIndex = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      if (!props.userId) {
        notify('Utente non valido per aprire il check finale.', 'error');
        return;
      }
      router.push({
        name: 'UserProgrammiCheckFinale',
        params: { userId: props.userId },
        query: (() => {
          const q = {
            percorsoId: percorso.id,
            stepIndex: String(stepIndex),
            stepKey: row.key
          };

          const assignIfPresent = (key, value) => {
            if (value === undefined || value === null) return;
            const normalized = typeof value === 'string' ? value : String(value);
            if (normalized !== '') q[key] = normalized;
          };

          assignIfPresent('sequenceGroupId', percorso.sequenceGroupId || percorso.id);
          assignIfPresent('sequenceIndex', percorso.sequenceIndex);
          assignIfPresent('sequenceTotal', percorso.sequenceTotal);
          assignIfPresent('productId', percorso.productId);
          assignIfPresent('productName', percorso.productName);
          assignIfPresent('programTitle', percorso.title);
          assignIfPresent('programLabel', renderProgramTitle(percorso.title));
          assignIfPresent('plannedStartAt', percorso.plannedStartAt);
          assignIfPresent('expireAt', percorso.expireAt);
          assignIfPresent('stepName', row.step?.name);
          assignIfPresent('orderRef', percorso.orderRef);

          return q;
        })()
      });
    };


// Update helper: scrive nell’array steps del relativo percorso
    const scheduleReminderNextRun = async (reminder) => {
      if (!reminder?.percorsoId || reminder.stepIndex == null || !reminder.sentField) return;
      if (reminder.blockedByCheck) {
        notify('Check finale gia completato: promemoria bloccato.', 'info');
        return;
      }
      const mapKey = reminder.key || `${reminder.percorsoId}_${reminder.stepIndex}_${reminder.sentField}_schedule`;
      if (suppressingReminder.value[mapKey]) return;
      suppressingReminder.value = { ...suppressingReminder.value, [mapKey]: true };

      try {
        const percRef = doc(db, 'percorsi', reminder.percorsoId);
        const snap = await getDoc(percRef);
        if (!snap.exists()) {
          notify('Percorso non trovato.', 'error');
          return;
        }
        const data = snap.data() || {};
        const steps = Array.isArray(data.steps) ? [...data.steps] : [];
        if (!steps[reminder.stepIndex]) {
          notify('Step non trovato per questo programma.', 'error');
          return;
        }
        if (hasCheckFinaleCompleted(steps)) {
          notify('Check finale gia completato: promemoria bloccato.', 'info');
          return;
        }

        const prev = steps[reminder.stepIndex];
        const currentReminder = parseReminderField(prev[reminder.sentField]);
        if (currentReminder.sentAt) {
          notify('Promemoria già inviato.', 'info');
          return;
        }

        const nextSteps = [...steps];
        nextSteps[reminder.stepIndex] = {
          ...prev,
          [reminder.sentField]: { resumeAt: new Date().toISOString() },
        };

        await updateDoc(percRef, { steps: nextSteps });
        percorsi.value = percorsi.value.map((p) =>
          p.id === reminder.percorsoId ? { ...p, steps: nextSteps } : p
        );

        notify('Programmato per il prossimo ciclo.', 'success');
      } catch (err) {
        console.error('scheduleReminderNextRun error', err);
        notify('Errore nel programmare il promemoria.', 'error');
      } finally {
        const next = { ...suppressingReminder.value };
        delete next[mapKey];
        suppressingReminder.value = next;
      }
    };

    const toggleReminderBlock = async (reminder) => {
      if (!reminder?.percorsoId || reminder.stepIndex == null || !reminder.sentField) return;
      if (reminder.blockedByCheck) {
        notify('Check finale gia completato: promemoria bloccato.', 'info');
        return;
      }
      const mapKey = reminder.key || `${reminder.percorsoId}_${reminder.stepIndex}_${reminder.sentField}`;
      if (suppressingReminder.value[mapKey]) return;
      suppressingReminder.value = { ...suppressingReminder.value, [mapKey]: true };

      try {
        const percRef = doc(db, 'percorsi', reminder.percorsoId);
        const snap = await getDoc(percRef);
        if (!snap.exists()) {
          notify('Percorso non trovato.', 'error');
          return;
        }
        const data = snap.data() || {};
        const steps = Array.isArray(data.steps) ? [...data.steps] : [];
        if (!steps[reminder.stepIndex]) {
          notify('Step non trovato per questo programma.', 'error');
          return;
        }
        if (hasCheckFinaleCompleted(steps)) {
          notify('Check finale gia completato: promemoria bloccato.', 'info');
          return;
        }

        const prev = steps[reminder.stepIndex];
        const currentReminder = parseReminderField(prev[reminder.sentField]);
        if (currentReminder.sentAt) {
          notify('Promemoria già inviato.', 'info');
          return;
        }

        const nowIso = new Date().toISOString();
        let nextFieldValue;
        if (reminder.blocked) {
          // sblocco: se la data è passata, programmo per il prossimo ciclo; altrimenti rimuovo il flag
          const dueMs = reminder.dueMs || 0;
          const overdue = Number.isFinite(dueMs) && dueMs < Date.now();
          nextFieldValue = overdue ? { resumeAt: nowIso } : null;
        } else {
          nextFieldValue = { blocked: true, blockedAt: nowIso };
        }

        const nextSteps = [...steps];
        nextSteps[reminder.stepIndex] = { ...prev, [reminder.sentField]: nextFieldValue };

        await updateDoc(percRef, { steps: nextSteps });
        percorsi.value = percorsi.value.map((p) =>
          p.id === reminder.percorsoId ? { ...p, steps: nextSteps } : p
        );

        notify(reminder.blocked ? 'Promemoria sbloccato e programmato per il prossimo ciclo.' : 'Promemoria bloccato.', 'success');
      } catch (err) {
        console.error('toggleReminderBlock error', err);
        notify('Errore nel bloccare/sbloccare il promemoria.', 'error');
      } finally {
        const next = { ...suppressingReminder.value };
        delete next[mapKey];
        suppressingReminder.value = next;
      }
    };

async function updateConsulenzaField(row, field, value) {
  // campi supportati
  const patch = {};
if (field === 'consulenzaType') {
  const v = String(value || '').trim();
  patch.consulenzaType = (v === 'Tecnica' || v === 'Nutrizionale') ? v : null;
}  else if (field === 'staffNote') patch.staffNote = (value || '').trim();
  else if (field === 'TrainerNome') patch.TrainerNome = (value || '').trim();
  else if (field === 'consulenzaStatus') patch.consulenzaStatus = value || 'Da fare';
  else return;

  const localUpdate = patchPercorsoStepLocal(
    row.percorsoId,
    row.realIndex,
    (prev) => ({ ...prev, ...patch })
  );
  if (!localUpdate) return;

  try {
    await updateDoc(doc(getFirestore(), 'percorsi', row.percorsoId), { steps: localUpdate.steps });
  } catch (error) {
    updatePercorsoLocal(localUpdate.previousPercorso);
    console.error('updateConsulenzaField error:', error);
    notify('Errore nell\'aggiornamento della consulenza.', 'error');
  }
}

async function updateConsulenzaDate(row, field, dateStr) {
  if (field !== 'doneAt') return;
  const localUpdate = patchPercorsoStepLocal(row.percorsoId, row.realIndex, (prev) => {
    const next = { ...prev };
    if (dateStr) {
      // Imposta doneAt e mette lo status a "Fatta" + done=true
      const iso = new Date(`${dateStr}T00:00:00.000Z`).toISOString();
      next.doneAt = iso;
      next.done = true;
      next.consulenzaStatus = 'Fatta';
    } else {
      // Rimuove la data e riporta lo stato a "Da fare" (se non già prenotata/rifiutata)
      next.doneAt = null;
      next.done = false;
      if (next.consulenzaStatus === 'Fatta') next.consulenzaStatus = 'Da fare';
    }
    return next;
  });
  if (!localUpdate) return;

  try {
    await updateDoc(doc(getFirestore(), 'percorsi', row.percorsoId), { steps: localUpdate.steps });
  } catch (error) {
    updatePercorsoLocal(localUpdate.previousPercorso);
    console.error('updateConsulenzaDate error:', error);
    notify('Errore nell\'aggiornamento della consulenza.', 'error');
  }
}

async function updateConsulenzaPlannedAt(row, dateStr) {
  let plannedAt = null;
  if (dateStr) {
    const parsed = new Date(`${dateStr}T00:00:00.000Z`);
    if (Number.isNaN(parsed.getTime())) return;
    plannedAt = parsed.toISOString();
  }

  const localUpdate = patchPercorsoStepLocal(
    row.percorsoId,
    row.realIndex,
    (prev) => ({ ...prev, plannedAt })
  );
  if (!localUpdate) return;

  try {
    await updateDoc(doc(getFirestore(), 'percorsi', row.percorsoId), { steps: localUpdate.steps });
  } catch (error) {
    updatePercorsoLocal(localUpdate.previousPercorso);
    console.error('updateConsulenzaPlannedAt error:', error);
    notify('Errore nell\'aggiornamento della consulenza.', 'error');
  }
}

async function moveConsulenza(row) {
  if (!row?.percorsoId) return;
  const targetId = consulenzaMoveTarget.value[row.rowId];
  if (!targetId) { notify('Seleziona il programma di destinazione.', 'error'); return; }
  if (targetId === row.percorsoId) { notify('Scegli un programma diverso da quello corrente.', 'error'); return; }

  const targetPercorso = (percorsi.value || []).find(p => p.id === targetId);
  if (!targetPercorso) { notify('Programma di destinazione non trovato.', 'error'); return; }

  movingConsulenza.value = { ...movingConsulenza.value, [row.rowId]: true };
  try {
    const sourceRef = doc(db, 'percorsi', row.percorsoId);
    const targetRef = doc(db, 'percorsi', targetId);
    const [sourceSnap, targetSnap] = await Promise.all([getDoc(sourceRef), getDoc(targetRef)]);
    if (!sourceSnap.exists() || !targetSnap.exists()) {
      notify('Impossibile recuperare i programmi selezionati.', 'error');
      return;
    }

    const sourceData = sourceSnap.data() || {};
    const targetData = targetSnap.data() || {};
    const sourceSteps = Array.isArray(sourceData.steps) ? [...sourceData.steps] : [];
    const targetSteps = Array.isArray(targetData.steps) ? [...targetData.steps] : [];

    let sourceIndex = Number.isInteger(row.realIndex) ? row.realIndex : -1;
    if (
      sourceIndex < 0 ||
      sourceIndex >= sourceSteps.length ||
      stepKeyFromName(sourceSteps[sourceIndex]?.name) !== 'consulenza'
    ) {
      sourceIndex = sourceSteps.findIndex((s) =>
        stepKeyFromName(s?.name) === 'consulenza'
        && toComparableString(s?.plannedAt) === toComparableString(row.plannedAt)
        && (s?.consulenzaType || '') === (row.consulenzaType || '')
      );
    }
    if (sourceIndex < 0 || sourceIndex >= sourceSteps.length) {
      notify('Step consulenza non trovato (riprova).', 'error');
      return;
    }

    const step = sourceSteps[sourceIndex];
    const stepKey = stepKeyFromName(step?.name);
    if (stepKey !== 'consulenza') {
      notify('Solo le consulenze possono essere spostate.', 'error');
      return;
    }

    const movedStep = { ...step, plannedAt: null };
    sourceSteps.splice(sourceIndex, 1);

    const targetPercorsoWithId = { id: targetSnap.id, ...targetData };
    const orderToInsert = stepOrderForPercorso(targetPercorsoWithId, stepKey, movedStep.consulenzaType, movedStep);
    let insertIndex = targetSteps.length;
    for (let i = 0; i < targetSteps.length; i += 1) {
      const tk = stepKeyFromName(targetSteps[i]?.name);
      const o = stepOrderForPercorso(targetPercorsoWithId, tk, targetSteps[i]?.consulenzaType, targetSteps[i]);
      if (o > orderToInsert) { insertIndex = i; break; }
    }
    targetSteps.splice(insertIndex, 0, movedStep);

    const batch = writeBatch(db);
    batch.update(sourceRef, { steps: sourceSteps });
    batch.update(targetRef, { steps: targetSteps });
    await batch.commit();

    consulenzaMoveTarget.value = { ...consulenzaMoveTarget.value, [row.rowId]: '' };
    closeConsulenzaDetail();
    notify('Consulenza spostata nel programma selezionato.', 'success');
  } catch (error) {
    console.error('moveConsulenza error', error);
    notify('Errore nello spostamento della consulenza.', 'error');
  } finally {
    const next = { ...movingConsulenza.value };
    delete next[row.rowId];
    movingConsulenza.value = next;
  }
}

const setDeletingConsulenza = (rowId, active) => {
  const next = { ...deletingConsulenza.value };
  if (active) next[rowId] = true;
  else delete next[rowId];
  deletingConsulenza.value = next;
};

const deleteConsulenza = async (row) => {
  if (!row?.percorsoId || !row?.rowId) return;
  if (!canDeleteConsulenza.value) {
    notify('Non hai i permessi per eliminare consulenze.', 'error');
    return;
  }
  if (deletingConsulenza.value[row.rowId]) return;
  if (typeof window !== 'undefined' && !window.confirm('Eliminare questa consulenza?')) return;

  setDeletingConsulenza(row.rowId, true);
  try {
    const percRef = doc(db, 'percorsi', row.percorsoId);
    const snap = await getDoc(percRef);
    if (!snap.exists()) {
      notify('Programma non trovato.', 'error');
      return;
    }
    const data = snap.data() || {};
    const steps = Array.isArray(data.steps) ? [...data.steps] : [];

    let sourceIndex = Number.isInteger(row.realIndex) ? row.realIndex : -1;
    if (
      sourceIndex < 0 ||
      sourceIndex >= steps.length ||
      stepKeyFromName(steps[sourceIndex]?.name) !== 'consulenza'
    ) {
      sourceIndex = steps.findIndex((s) =>
        stepKeyFromName(s?.name) === 'consulenza'
        && toComparableString(s?.plannedAt) === toComparableString(row.plannedAt)
        && (s?.consulenzaType || '') === (row.consulenzaType || '')
        && toComparableString(s?.doneAt) === toComparableString(row.doneAt)
      );
    }
    if (sourceIndex < 0 || sourceIndex >= steps.length) {
      notify('Consulenza non trovata.', 'error');
      return;
    }

    steps.splice(sourceIndex, 1);
    await updateDoc(percRef, { steps });
    updatePercorsoLocal({ id: row.percorsoId, ...data, steps });
    closeConsulenzaDetail();
    notify('Consulenza eliminata.', 'success');
  } catch (error) {
    console.error('deleteConsulenza error', error);
    notify('Errore nella cancellazione della consulenza.', 'error');
  } finally {
    setDeletingConsulenza(row.rowId, false);
  }
};

// === handler già esistente per lo status (manteniamo la tua firma)
const VALID_CONSULENZA = new Set(['Da fare', 'Contattata', 'Prenotata', 'Rifiutata', 'Fatta', 'Scalata']);
function normalizeConsulenzaStatus(val) {
  const s = String(val || '').trim().toLowerCase();
  if (s === 'contattata' || s === 'contattato') return 'Contattata';
  if (s === 'prenotata' || s === 'prenotato') return 'Prenotata';
  if (s === 'rifiutata' || s === 'rifiutato') return 'Rifiutata';
  if (s === 'fatta'     || s === 'fatto')     return 'Fatta';
  if (s === 'scalata' || s === 'scalato') return 'Scalata';
  return 'Da fare';
}
const onConsulenzaStatusChangeByKey = async (percorso, stepKey, newStatus, stepIndex) => {
  if ((stepKey || '') !== 'consulenza') return;
  const idx = Number.isInteger(stepIndex)
    ? Number(stepIndex)
    : (percorso?.steps || []).findIndex(s =>
        (s?.name || '').toLowerCase().includes('consulenza')
      );
  if (idx < 0) return;

  const status = normalizeConsulenzaStatus(newStatus);
  if (!VALID_CONSULENZA.has(status)) return;
  const nowIso = new Date().toISOString();

  const localUpdate = patchPercorsoStepLocal(percorso.id, idx, (prev) => {
    const isDone = isConsulenzaStatusDone(status);
    const nextScalataAt = status === 'Scalata'
      ? (prev.scalataAt || nowIso)
      : (prev.scalataAt || null);
    return {
      ...prev,
      consulenzaStatus: status,
      done: isDone,
      doneAt: status === 'Fatta' ? (prev.doneAt || nowIso) : null,
      scalataAt: nextScalataAt,
    };
  });
  if (!localUpdate) return;

  try {
    await updateDoc(doc(getFirestore(), 'percorsi', percorso.id), { steps: localUpdate.steps });
  } catch (error) {
    updatePercorsoLocal(localUpdate.previousPercorso);
    console.error('onConsulenzaStatusChangeByKey error:', error);
    notify('Errore nell\'aggiornamento dello status consulenza.', 'error');
  }
};


    const updatePercorsoLocal = (updatedPercorso) => {
      const normalized = normalizePercorsoRecord(updatedPercorso);
      percorsi.value = percorsi.value.map(p => (p.id === normalized.id ? normalized : p));
    };
    const patchPercorsoStepLocal = (percorsoId, stepIndex, buildNextStep) => {
      const currentPercorso = (percorsi.value || []).find((p) => p.id === percorsoId);
      if (!currentPercorso) return null;

      const currentSteps = Array.isArray(currentPercorso.steps) ? currentPercorso.steps : [];
      if (stepIndex < 0 || stepIndex >= currentSteps.length) return null;

      const steps = currentSteps.map((step) => (
        step && typeof step === 'object' ? { ...step } : step
      ));
      const prevStep = steps[stepIndex] || {};
      const nextStep = typeof buildNextStep === 'function'
        ? buildNextStep(prevStep)
        : { ...prevStep, ...(buildNextStep || {}) };

      steps[stepIndex] = nextStep;
      const nextPercorso = { ...currentPercorso, steps };
      updatePercorsoLocal(nextPercorso);
      return { previousPercorso: currentPercorso, nextPercorso, steps, prevStep, nextStep };
    };
    const updatePercorsiNotificationsLocal = (ids = [], enabled) => {
      if (!Array.isArray(ids) || ids.length === 0) return;
      const targetIds = new Set(ids.filter(Boolean));
      percorsi.value = percorsi.value.map((p) =>
        targetIds.has(p.id) ? { ...p, notificationsEnabled: enabled } : p
      );
    };

    const togglingGroupNotifications = ref({});
    const groupNotificationState = computed(() => {
      const state = {};
      for (const group of groupedPercorsi.value || []) {
        const list = group?.percorsi || [];
        if (!list.length) continue;
        let enabledCount = 0;
        let disabledCount = 0;
        list.forEach((p) => {
          if (areNotificationsEnabled(p)) enabledCount += 1;
          else disabledCount += 1;
        });
        state[group.id] = {
          enabled: enabledCount > 0 && disabledCount === 0,
          partial: enabledCount > 0 && disabledCount > 0,
        };
      }
      return state;
    });

    const areGroupNotificationsEnabled = (groupId) =>
      groupNotificationState.value[groupId]?.enabled === true;

    const isGroupNotificationsPartial = (groupId) =>
      groupNotificationState.value[groupId]?.partial === true;

    const blockOverdueRemindersAfterEnable = async (programs) => {
      const nowMs = Date.now();
      const nowIso = new Date().toISOString();
      const updates = [];

      for (const p of programs) {
        if (!p?.id) continue;
        const steps = Array.isArray(p.steps) ? [...p.steps] : [];
        let changed = false;

        steps.forEach((step, idx) => {
          if (stepKeyFromName(step?.name) !== 'consegna') return;
          if (!step?.done || !step?.doneAt) return;
          const doneDate = toDateSafe(step.doneAt);
          if (!doneDate) return;

          REMINDER_CONFIG.forEach(({ days, field }) => {
            if (!days || !field) return;
            const { isBlocked, sentAt, paused, resumeAt } = parseReminderField(step[field]);
            if (isBlocked || sentAt || paused || resumeAt) return;
            const dueMs = doneDate.getTime() + days * DAY_MS;
            if (!Number.isFinite(dueMs) || dueMs >= nowMs) return;
            const next = { ...step, [field]: { blocked: true, blockedAt: nowIso } };
            steps[idx] = next;
            step = next; // eslint-disable-line no-param-reassign
            changed = true;
          });
        });

        if (changed) {
          updates.push({ id: p.id, steps });
        }
      }

      if (!updates.length) return;

      const batch = writeBatch(db);
      updates.forEach(({ id, steps }) => {
        batch.update(doc(db, 'percorsi', id), { steps });
      });
      await batch.commit();

      percorsi.value = percorsi.value.map((p) => {
        const found = updates.find(u => u.id === p.id);
        return found ? { ...p, steps: found.steps } : p;
      });
    };

    const toggleNotificationsForGroup = async (group) => {
      if (!group?.id) return;
      const programs = (group.percorsi || []).filter(p => p?.id);
      if (!programs.length) return;

      const nextState = !areGroupNotificationsEnabled(group.id);
      togglingGroupNotifications.value = { ...togglingGroupNotifications.value, [group.id]: true };

      try {
        if (nextState) {
          await blockOverdueRemindersAfterEnable(programs);
        }

        const batch = writeBatch(db);
        programs.forEach((p) => {
          batch.update(doc(db, 'percorsi', p.id), { notificationsEnabled: nextState });
        });
        await batch.commit();

        updatePercorsiNotificationsLocal(programs.map(p => p.id), nextState);
        notify(
          nextState
            ? 'Notifiche abilitate per questo percorso.'
            : 'Notifiche disabilitate per questo percorso.',
          'success'
        );
      } catch (error) {
        console.error('toggleNotificationsForGroup error', error);
        notify('Impossibile aggiornare lo stato delle notifiche del percorso.', 'error');
      } finally {
        const next = { ...togglingGroupNotifications.value };
        delete next[group.id];
        togglingGroupNotifications.value = next;
      }
    };

    const ensureNotificationsAllowed = (percorso) => {
      if (areNotificationsEnabled(percorso)) return true;
      notify('Le notifiche sono disabilitate per questo percorso.', 'error');
      return false;
    };

    const setReactivatingPercorso = (id, active) => {
      const next = { ...reactivatingPercorso.value };
      if (active) {
        next[id] = true;
      } else {
        delete next[id];
      }
      reactivatingPercorso.value = next;
    };

    const setLockingPercorso = (id, active) => {
      const next = { ...lockingPercorso.value };
      if (active) {
        next[id] = true;
      } else {
        delete next[id];
      }
      lockingPercorso.value = next;
    };

    const setOverridingSequenceLock = (id, active) => {
      const next = { ...overridingSequenceLock.value };
      if (active) {
        next[id] = true;
      } else {
        delete next[id];
      }
      overridingSequenceLock.value = next;
    };

    const setSequenceUnlockOverride = async (percorso, forceUnlock) => {
      if (!percorso?.id) return;
      const { id } = percorso;
      if (overridingSequenceLock.value[id]) return;

      setOverridingSequenceLock(id, true);
      try {
        const payload = forceUnlock
          ? { sequenceUnlockOverride: true, sequenceUnlockOverrideAt: new Date().toISOString() }
          : { sequenceUnlockOverride: false, sequenceUnlockOverrideAt: null };
        await updateDoc(doc(db, 'percorsi', id), payload);
        updatePercorsoLocal({ ...percorso, ...payload });
        notify(forceUnlock ? 'Programma sbloccato manualmente.' : 'Blocco sequenza ripristinato.', 'success');
      } catch (err) {
        console.error('setSequenceUnlockOverride error', err);
        notify('Impossibile aggiornare lo stato di blocco.', 'error');
      } finally {
        setOverridingSequenceLock(id, false);
      }
    };

    const unlockSequenceManually = (percorso) => setSequenceUnlockOverride(percorso, true);
    const restoreSequenceLock = (percorso) => setSequenceUnlockOverride(percorso, false);

    const reactivatePercorso = async (percorso) => {
      if (!percorso || !percorso.id || !canReactivatePercorso(percorso)) return;
      const { id } = percorso;
      if (reactivatingPercorso.value[id]) return;

      setReactivatingPercorso(id, true);
      try {
        const reason = percorsoLockReason(percorso);
        const nowIso = new Date().toISOString();
        const payload = {
          historyLocked: false,
          historyLockedAt: null,
        };
        if (reason === 'completed') {
          payload.completedUnlockOverride = true;
          payload.completedUnlockOverrideAt = nowIso;
        }
        await updateDoc(doc(db, 'percorsi', id), payload);
        updatePercorsoLocal({ ...percorso, ...payload });
        notify('Programma riattivato. Ora puoi gestire gli step.', 'success');
      } catch (err) {
        console.error('reactivatePercorso error', err);
        notify('Errore durante la riattivazione del programma.', 'error');
      } finally {
        setReactivatingPercorso(id, false);
      }
    };

    const lockPercorso = async (percorso) => {
      if (!percorso || !percorso.id || isPercorsoLocked(percorso)) return;
      const { id } = percorso;
      if (lockingPercorso.value[id]) return;

      const confirmMessage = 'Bloccare questo programma come storico? Gli utenti non potranno più modificarne gli step.';
      if (typeof window !== 'undefined' && !window.confirm(confirmMessage)) {
        return;
      }

      setLockingPercorso(id, true);
      try {
        const nowIso = new Date().toISOString();
        await updateDoc(doc(db, 'percorsi', id), {
          historyLocked: true,
          historyLockedAt: nowIso,
        });
        updatePercorsoLocal({ ...percorso, historyLocked: true, historyLockedAt: nowIso });
        notify('Programma bloccato come storico.', 'success');
      } catch (err) {
        console.error('lockPercorso error', err);
        notify('Errore durante il blocco del programma.', 'error');
      } finally {
        setLockingPercorso(id, false);
      }
    };


    /* ===== delete percorso ===== */
    const deletePercorsoCascadeInternal = async (percorso) => {
      if (!percorso?.id) return false;
      const q = query(collection(db, QUESTIONARI_COLLECTION), where('percorsoId', '==', percorso.id));
      const snap = await getDocs(q);
      let batch = writeBatch(db);
      let opCount = 0;
      const flush = async () => {
        if (opCount > 0) {
          await batch.commit();
          batch = writeBatch(db);
          opCount = 0;
        }
      };
      for (const docSnap of snap.docs) {
        batch.delete(docSnap.ref);
        opCount += 1;
        if (opCount >= 450) {
          await flush();
        }
      }
      await flush();
      await deleteDoc(doc(db, 'percorsi', percorso.id));
      return true;
    };

    const deletePercorsoCascade = async (percorso) => {
      if (!confirm('Eliminare definitivamente questo programma e i questionari associati?')) return;
      try {
        await deletePercorsoCascadeInternal(percorso);
      } catch (e) {
        console.error('Errore cancellazione a cascata:', e);
        notify('Errore durante la cancellazione del programma o dei questionari collegati.', 'error');
      }
    };

    const setDeletingGroupPercorsi = (groupId, active) => {
      const next = { ...deletingGroupPercorsi.value };
      if (active) next[groupId] = true;
      else delete next[groupId];
      deletingGroupPercorsi.value = next;
    };

    const deletePercorsoGroup = async (group) => {
      if (!group?.id) return;
      const programs = (group.percorsi || []).filter(p => p?.id);
      if (!programs.length) return;
      const label = group.productLabel || 'Percorso';
      const confirmMessage = `Eliminare tutto il percorso "${label}" (${programs.length} programmi) e i questionari associati?`;
      if (typeof window !== 'undefined' && !window.confirm(confirmMessage)) return;
      if (deletingGroupPercorsi.value[group.id]) return;

      setDeletingGroupPercorsi(group.id, true);
      try {
        for (const percorso of programs) {
          await deletePercorsoCascadeInternal(percorso);
        }
        notify('Percorso eliminato.', 'success');
      } catch (e) {
        console.error('deletePercorsoGroup error:', e);
        notify('Errore durante la cancellazione del percorso.', 'error');
      } finally {
        setDeletingGroupPercorsi(group.id, false);
      }
    };

    /* ===== admin status ===== */
    const keyFor = (pid, stepKey) => `${pid}__${stepKey}`;
    const stepIndexKey = (pid, idx) => `${pid}__${idx}`;
    const mergeRealtimeAdminAndNotesIntoPercorso = (currentPercorso, incomingData = {}) => {
      if (!currentPercorso || !incomingData) return { changed: false, nextPercorso: currentPercorso };

      let changed = false;
      const nextPercorso = { ...currentPercorso };

      const currentSequenceNote = toComparableString(currentPercorso.sequenceNote || '');
      const nextSequenceNote = toComparableString(incomingData.sequenceNote || '');
      if (currentSequenceNote !== nextSequenceNote) {
        nextPercorso.sequenceNote = incomingData.sequenceNote || '';
        changed = true;
      }

      const currentSteps = Array.isArray(currentPercorso.steps) ? currentPercorso.steps : [];
      const incomingSteps = Array.isArray(incomingData.steps) ? incomingData.steps : [];
      if (!currentSteps.length) {
        return { changed, nextPercorso };
      }

      let stepsChanged = false;
      const nextSteps = currentSteps.map((currentStep, index) => {
        if (!currentStep || typeof currentStep !== 'object') return currentStep;
        const incomingStep = incomingSteps[index] || {};
        const mergedStep = { ...currentStep };
        let localStepChanged = false;

        for (const field of realtimeAdminStepFields) {
          const currentVal = Object.prototype.hasOwnProperty.call(currentStep, field)
            ? currentStep[field] ?? null
            : null;
          const incomingVal = Object.prototype.hasOwnProperty.call(incomingStep, field)
            ? incomingStep[field] ?? null
            : null;

          if (toComparableString(currentVal) === toComparableString(incomingVal)) continue;
          mergedStep[field] = incomingVal;
          localStepChanged = true;
        }

        if (!localStepChanged) return currentStep;

        const noteKey = stepIndexKey(currentPercorso.id, index);
        const currentStaff = toComparableString(currentStep?.staffNote || '');
        const localStaffDraft = toComparableString(staffNoteEdits.value[noteKey] ?? '');
        if (localStaffDraft === currentStaff) {
          staffNoteEdits.value[noteKey] = mergedStep?.staffNote || '';
        }

        const stepKey = stepKeyFromName(mergedStep?.name || currentStep?.name || '');
        if (stepKey) {
          const adminKey = keyFor(currentPercorso.id, stepKey);
          const currentAdmin = toComparableString(currentStep?.adminNote || '');
          const localAdminDraft = toComparableString(needsUpdateNotes.value[adminKey] ?? '');
          if (localAdminDraft === currentAdmin) {
            needsUpdateNotes.value[adminKey] = mergedStep?.adminNote || '';
          }
        }

        stepsChanged = true;
        return mergedStep;
      });

      if (stepsChanged) {
        nextPercorso.steps = nextSteps;
        changed = true;
      }

      return { changed, nextPercorso };
    };

    const startPercorsiRealtimeAdminNotes = (uid = props.userId) => {
      stopPercorsiRealtimeAdminNotes();
      if (!uid) return;

      const qPerc = query(collection(db, 'percorsi'), where('uid', '==', uid));
      percorsiRealtimeUnsub = onSnapshot(
        qPerc,
        (snapshot) => {
          if (!Array.isArray(percorsi.value) || !percorsi.value.length) return;
          const currentById = new Map((percorsi.value || []).map((item) => [item.id, item]));
          const updatesById = new Map();

          snapshot.docChanges().forEach((change) => {
            if (change.type === 'removed') return;
            const docId = change.doc.id;
            const current = currentById.get(docId);
            if (!current) return;

            const incomingData = change.doc.data() || {};
            const normalizedIncomingData = normalizePercorsoRecord(incomingData);
            const { changed, nextPercorso } = mergeRealtimeAdminAndNotesIntoPercorso(current, normalizedIncomingData);
            if (changed && nextPercorso) {
              updatesById.set(docId, nextPercorso);
            }
          });

          if (!updatesById.size) return;
          percorsi.value = percorsi.value.map((item) => updatesById.get(item.id) || item);
        },
        (error) => {
          console.error('Realtime admin/note percorsi error:', error);
        }
      );
    };

    const adminLabel = (step) => {
      const s = step?.adminStatus || 'none';
      if (s === 'approved') return 'Approvato';
      if (s === 'needs_update') return 'Richiesto aggiornamento';
      return '—';
    };
    const adminChipClass = (step) => {
      const s = step?.adminStatus || 'none';
      if (s === 'approved') return 'chip-green';
      if (s === 'needs_update') return 'chip-orange';
      return 'chip-neutral';
    };
    const renewalFlagKeys = ['daRinnovare', 'da_rinnovare', 'needsRenewal', 'toRenew', 'renew', 'renewal'];
    const readRenewalFlag = (source = {}) => {
      if (!source || typeof source !== 'object') return false;
      for (const key of renewalFlagKeys) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          const v = source[key];
          return v === true || v === 1 || v === '1' || v === 'true';
        }
      }
      return false;
    };
    const isStepRenewal = (step) => readRenewalFlag(step);
    const isStepStopped = (step) => !!(step?.stop === true || step?.isStopped === true);
    const toggleRenewalByKey = async (percorso, stepKey, explicitIndex = null) => {
      if (isPercorsoLocked(percorso)) return;
      const stepIndex = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (stepIndex < 0) {
        notify('Step non trovato per aggiornare il rinnovo.', 'error');
        return;
      }

      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (togglingRenewal.value[mapKey]) return;

      const previousStep = Array.isArray(percorso.steps) ? percorso.steps[stepIndex] || {} : {};
      const nextRenewal = !isStepRenewal(previousStep);
      const renewalAtIso = nextRenewal ? new Date().toISOString() : null;

      togglingRenewal.value = { ...togglingRenewal.value, [mapKey]: true };
      const localUpdate = patchPercorsoStepLocal(percorso.id, stepIndex, (prev) => ({
        ...prev,
        daRinnovare: nextRenewal,
        da_rinnovare: nextRenewal,
        daRinnovareAt: renewalAtIso,
        da_rinnovare_at: renewalAtIso,
        renewalAt: renewalAtIso,
        adminUpdatedAt: new Date().toISOString(),
      }));

      if (!localUpdate) {
        const next = { ...togglingRenewal.value };
        next[mapKey] = false;
        togglingRenewal.value = next;
        notify('Impossibile aggiornare localmente lo step.', 'error');
        return;
      }

      try {
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps: localUpdate.steps });
        notify(nextRenewal ? 'Step segnato da rinnovare.' : 'Rinnovo rimosso dallo step.', 'success');
      } catch (error) {
        updatePercorsoLocal(localUpdate.previousPercorso);
        console.error('toggleRenewalByKey error', error);
        notify("Errore durante l'aggiornamento dello stato di rinnovo.", 'error');
      } finally {
        const next = { ...togglingRenewal.value };
        next[mapKey] = false;
        togglingRenewal.value = next;
      }
    };
    const sendAdminNotification = async (percorso, stepKey, explicitIndex = null) => {
      if (isPercorsoLocked(percorso)) return;
      if (!ensureNotificationsAllowed(percorso)) return;
      if (!stepKey) {
        notify('Step non riconosciuto per la notifica.', 'error');
        return;
      }
      const stepIndex = resolveStepIndex(percorso, stepKey, explicitIndex);
      const steps = Array.isArray(percorso.steps) ? percorso.steps : [];
      const invalidConsultation = stepKey === 'consulenza' && (
        stepKeyFromName(steps[stepIndex]?.name) !== 'consulenza' ||
        (!Number.isInteger(explicitIndex) && steps.filter(item => stepKeyFromName(item?.name) === 'consulenza').length > 1)
      );
      if (stepIndex < 0 || stepIndex >= steps.length || invalidConsultation) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      if (stepKey === 'consulenza' && !normalizeConsultationType(steps[stepIndex])) {
        notify('Seleziona il tipo di consulenza (Tecnica o Nutrizionale) prima di inviare il promemoria.', 'error');
        return;
      }
      if (!props.userId) {
        notify('Utente non valido per la notifica.', 'error');
        return;
      }
      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (sendingNotification.value[mapKey]) return;

      sendingNotification.value = { ...sendingNotification.value, [mapKey]: true };
      try {
        const step = steps[stepIndex];
        const payload = await dispatchStepNotification({
          db,
          userUid: props.userId,
          programId: percorso.id,
          stepKey,
          step,
          stepIndex,
          programTitle: renderProgramTitle(percorso.title),
          productName: percorso.productName || null,
          sequenceIndex: getSequenceIndex(percorso),
          sequenceTotal: Number(percorso.sequenceTotal),
          plannedAt: step?.plannedAt || null,
          notifyUser: true,
          preserveOpenStatus: true,
          awaitNotification: false,
        });
        if (!payload) {
          notify('Non è stato possibile generare la notifica per questo step.', 'error');
          return;
        }
        notify(payload.toastMessage || 'Notifica inviata.', 'success');
      } catch (err) {
        console.error('sendAdminNotification error', err);
        notify("Errore nell'invio della notifica.", 'error');
      } finally {
        const next = { ...sendingNotification.value };
        next[mapKey] = false;
        sendingNotification.value = next;
      }
    };
    const toggleAdminApproved = async (percorso, stepIndex) => {
      if (isPercorsoLocked(percorso)) return;
      try {
        const steps = [...(percorso.steps || [])];
        const prev = steps[stepIndex] || {};
        const nextApproved = (prev?.adminStatus || 'none') !== 'approved';
        steps[stepIndex] = {
          ...prev,
          adminStatus: nextApproved ? 'approved' : 'none',
          adminNote: null,
          adminUpdatedAt: new Date().toISOString()
        };
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });
        notify('Stato admin aggiornato.', 'success');
      } catch (e) {
        console.error('toggleAdminApproved error', e);
        notify('Errore nel salvataggio dello stato admin.', 'error');
      }
    };
    const toggleAdminApprovedByKey = (percorso, stepKey, explicitIndex = null) => {
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;
      return toggleAdminApproved(percorso, idx);
    };
    const toggleNeedsUpdateUI = (percorso, stepIndex) => {
      if (isPercorsoLocked(percorso)) return;
      const stepName = (percorso.steps?.[stepIndex]?.name || '');
      const stepKey = stepKeyFromName(stepName);
      if (!stepKey) return;
      const k = keyFor(percorso.id, stepKey);
      needsUpdateOpen.value[k] = !needsUpdateOpen.value[k];
      if (needsUpdateOpen.value[k] && needsUpdateNotes.value[k] == null) {
        needsUpdateNotes.value[k] = (percorso.steps?.[stepIndex]?.adminNote || '');
      }
    };
    const toggleNeedsUpdateUIByKey = (percorso, stepKey, explicitIndex = null) => {
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;
      return toggleNeedsUpdateUI(percorso, idx);
    };
    const saveNeedsUpdate = async (percorso, stepIndex) => {
      if (isPercorsoLocked(percorso)) return;
      if (!ensureNotificationsAllowed(percorso)) return;
      const stepName = (percorso.steps?.[stepIndex]?.name || '');
      const stepKey = stepKeyFromName(stepName);
      if (!stepKey) return;
      const k = keyFor(percorso.id, stepKey);
      const note = (needsUpdateNotes.value[k] || '').trim();
      try {
        const steps = [...(percorso.steps || [])];
        const prev = steps[stepIndex] || {};
        const nextStep = { ...prev, adminStatus: 'needs_update', adminNote: note || null, adminUpdatedAt: new Date().toISOString() };
        steps[stepIndex] = nextStep;
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });
        if (props.userId) {
          try {
            await dispatchNeedsUpdateNotification({
              db,
              userUid: props.userId,
              programId: percorso.id,
              stepKey,
              step: nextStep,
              stepIndex,
              programTitle: renderProgramTitle(percorso.title),
              productName: percorso.productName || null,
              sequenceIndex: getSequenceIndex(percorso),
              sequenceTotal: Number(percorso.sequenceTotal),
              adminNote: note,
              notifyUser: true,
              preserveOpenStatus: true,
              awaitNotification: false,
            });
          } catch (notifyErr) {
            console.error('dispatchNeedsUpdateNotification error', notifyErr);
          }
        }
        needsUpdateOpen.value[k] = false;
        notify('Richiesta di aggiornamento salvata.', 'success');
      } catch (e) { console.error('saveNeedsUpdate error', e); notify('Errore nel salvataggio della richiesta di aggiornamento.', 'error'); }
    };
    const saveNeedsUpdateByKey = (percorso, stepKey, explicitIndex = null) => {
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;
      return saveNeedsUpdate(percorso, idx);
    };

const setAdminDailySent = async (percorso, stepIndex, mode = 'inviato') => {
  if (isPercorsoLocked(percorso)) return;
  const steps = Array.isArray(percorso.steps) ? [...percorso.steps] : [];
  const prev = steps[stepIndex] || {};
  const normalizedMode = normalizeAdminDailyState(mode, true) || 'inviato';
  const sentAt = new Date().toISOString();
  steps[stepIndex] = {
    ...prev,
    adminDailySent: true,
    adminDailySentAt: sentAt,
    adminDailyState: normalizedMode,
    adminDailyStateAt: sentAt,
    adminUpdatedAt: new Date().toISOString(),
  };
  await updateDoc(doc(getFirestore(), 'percorsi', percorso.id), { steps });
  updatePercorsoLocal({ ...percorso, steps });
};

const markDailySendByKey = async (percorso, stepKey, explicitIndex = null) => {
  if (isPercorsoLocked(percorso)) return;
  if (isFinalCheckDailyBlocked(percorso, stepKey, explicitIndex)) {
    notify('Invio non disponibile sul check finale dell’ultimo programma.', 'info');
    return;
  }
  const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
  if (idx < 0) return;
  const targetUserUid = resolveTargetUserUid(percorso);
  if (!targetUserUid) {
    notify('ID utente non valido per registrare l’invio di giornata.', 'error');
    return;
  }

  const sourceStep = Array.isArray(percorso?.steps) ? percorso.steps[idx] : null;
  const isResend = isStepDailySent(sourceStep);
  if (!isResend && !ensureNotificationsAllowed(percorso)) return;

  const confirmMessage = isResend
    ? 'Questo step è già stato inviato. Vuoi inviarlo di nuovo e aggiornare la data di invio?'
    : 'Sei sicuro di voler procedere all\'invio?';
  if (typeof window !== 'undefined' && !window.confirm(confirmMessage)) {
    return;
  }

  const k = keyFor(percorso.id, stepKey);
  try {
    savingDaily.value[k] = true;
    const deliveryTargetMode =
      stepKey === 'check_finale' && !sourceStep?.convertedFromQuestionario
        ? 'next'
        : 'current';
    const deliveryPercorso =
      deliveryTargetMode === 'next'
        ? (findNextPercorsoInSequence(percorso) || percorso)
        : percorso;
    await saveDailySend({
      userId: targetUserUid,
      percorsoId: deliveryPercorso?.id || null,
      percorsoTitle: renderProgramTitle(deliveryPercorso?.title || deliveryPercorso?.productName || ''),
      percorsoSequenceIndex: deliveryPercorso?.sequenceIndex ?? percorso?.sequenceIndex ?? null,
      percorsoSequenceTotal: deliveryPercorso?.sequenceTotal ?? percorso?.sequenceTotal ?? null,
      stepKey,
      stepIndex: idx,
      stepLabel: stepKey === 'check_finale' ? 'check' : stepKey,
      stepSequenceIndex: percorso?.sequenceIndex ?? null,
      stepSequenceTotal: percorso?.sequenceTotal ?? null,
      deliveryTargetMode,
    });
    await setAdminDailySent(percorso, idx, 'inviato');
    // Il promemoria consulenza viene gestito dal server dopo la consegna effettiva.
    notify('Invio di giornata salvato e registrato.', 'success');
  } catch (e) {
    console.error('markDailySendByKey error', e);
    notify('Errore nel salvataggio dell’invio di giornata.', 'error');
  } finally {
    savingDaily.value[k] = false;
  }
};

const markDailyFlagOnlyByKey = async (percorso, stepKey, explicitIndex = null) => {
  if (isPercorsoLocked(percorso)) return;
  if (!canMarkDailyManual.value) return;
  const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
  if (idx < 0) return;

  const k = keyFor(percorso.id, stepKey);
  try {
    savingDaily.value[k] = true;
    await setAdminDailySent(percorso, idx, 'nascosto');
    notify('Segnato come nascosto (senza invio).', 'success');
  } catch (e) {
    console.error('markDailyFlagOnlyByKey error', e);
    notify('Errore nel salvataggio dello stato nascosto.', 'error');
  } finally {
    savingDaily.value[k] = false;
  }
};



    /* ===== NOTE INTERNE — salva per step ===== */
    const saveStaffNoteByKey = async (percorso, stepKey, explicitIndex = null) => {
      if (isPercorsoLocked(percorso)) return;
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;
      const k = stepIndexKey(percorso.id, idx);
      const note = (staffNoteEdits.value[k] || '').trim();

      try {
        savingNote.value[k] = true;
        saveStatus.value[k] = undefined;

        const steps = Array.isArray(percorso.steps) ? [...percorso.steps] : [];
        const prev  = steps[idx] || {};
        steps[idx] = { ...prev, staffNote: note || null, adminUpdatedAt: new Date().toISOString() };

        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });

        saveStatus.value[k] = 'ok';
      } catch (e) {
        console.error('saveStaffNoteByKey error:', e);
        saveStatus.value[k] = 'err';
        notify('Errore nel salvataggio della nota.', 'error');
      } finally {
        savingNote.value[k] = false;
      }
    };

    const unlockingCheckFinale = ref({});
    const updatingConsegnaDone = ref({});

    const toggleCheckFinalWorked = async (percorso, stepIndex) => {
      if (isPercorsoLocked(percorso)) return;
      if (stepIndex < 0) return;
      const step = (percorso.steps || [])[stepIndex] || {};
      const stepKey = stepKeyFromName(step?.name || '');
      if (stepKey !== 'check_finale') return;
      const mapKey = keyFor(percorso.id, stepKey);
      if (togglingWorked.value[mapKey]) return;

      togglingWorked.value = { ...togglingWorked.value, [mapKey]: true };
      try {
        const steps = [...(percorso.steps || [])];
        const prev = steps[stepIndex] || {};
        const nextWorked = !prev.adminWorked;
        const nextStep = {
          ...prev,
          adminWorked: nextWorked,
          adminWorkedAt: nextWorked ? new Date().toISOString() : null,
        };
        steps[stepIndex] = nextStep;
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });
        updatePercorsoLocal({ ...percorso, steps });
        notify(
          nextWorked ? 'Check finale segnato come "Lavorato".' : 'Check finale riportato a "Da lavorare".',
          'success'
        );
      } catch (err) {
        console.error('toggleCheckFinalWorked error', err);
        notify("Errore durante l'aggiornamento dello stato lavorato.", 'error');
      } finally {
        const next = { ...togglingWorked.value };
        next[mapKey] = false;
        togglingWorked.value = next;
      }
    };

    const toggleCheckFinalWorkedByKey = (percorso, stepKey, explicitIndex = null) => {
      if (stepKey !== 'check_finale') return;
      const idx = resolveStepIndex(percorso, stepKey, explicitIndex);
      if (idx < 0) return;
      return toggleCheckFinalWorked(percorso, idx);
    };

    const unlockCheckFinale = async (percorso, row) => {
      if (!percorso || row?.key !== 'check_finale') return;
      if (!row.isLockedByConsegna || isPercorsoLocked(percorso)) return;
      const stepIndex = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (unlockingCheckFinale.value[mapKey]) return;

      unlockingCheckFinale.value = { ...unlockingCheckFinale.value, [mapKey]: true };
      try {
        const steps = [...(percorso.steps || [])];
        const prev = steps[stepIndex] || {};
        steps[stepIndex] = {
          ...prev,
          allowCheckOverride: true,
          allowCheckOverrideAt: new Date().toISOString(),
        };
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });
        updatePercorsoLocal({ ...percorso, steps });
        notify('Check finale sbloccato manualmente, ora puoi compilarlo.', 'success');
      } catch (err) {
        console.error('unlockCheckFinale error', err);
        notify('Impossibile sbloccare il check finale.', 'error');
      } finally {
        const next = { ...unlockingCheckFinale.value };
        delete next[mapKey];
        unlockingCheckFinale.value = next;
      }
    };

    const cleanupStepForTarget = (step, targetKey) => {
      const next = { ...(step || {}) };

      // Lo stato di invio appartiene al tipo di step: dopo una conversione
      // non deve essere ereditato dal precedente questionario/check finale.
      delete next.adminDailySent;
      delete next.adminDailySentAt;
      delete next.adminDailyState;
      delete next.adminDailyStateAt;

      if (targetKey === 'questionario') {
        delete next.adminWorked;
        delete next.adminWorkedAt;
        delete next.allowCheckOverride;
        delete next.allowCheckOverrideAt;
        delete next.convertedFromQuestionario;
      }
      return next;
    };

    const toggleQuestionarioCheck = async (percorso, row) => {
      if (!percorso || !row) return;
      if (isPercorsoLocked(percorso)) return;
      const currentKey = row.key;
      if (currentKey !== 'questionario' && currentKey !== 'check_finale') return;
      const stepIndex = resolveStepIndex(percorso, currentKey, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (switchingStepType.value[mapKey]) return;

      const targetKey = currentKey === 'questionario' ? 'check_finale' : 'questionario';
      const targetName = targetKey === 'check_finale' ? 'scadenza / check finale' : 'questionario';
      const successLabel = targetKey === 'check_finale' ? 'check finale' : 'questionario iniziale';

      switchingStepType.value = { ...switchingStepType.value, [mapKey]: true };
      try {
        const steps = [...(percorso.steps || [])];
        const prev = steps[stepIndex] || {};
        const nextStep = cleanupStepForTarget(prev, targetKey);
        const conversionExtras =
          targetKey === 'check_finale'
            ? { convertedFromQuestionario: true }
            : {};
        steps[stepIndex] = { ...nextStep, ...conversionExtras, name: targetName };
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps });
        updatePercorsoLocal({ ...percorso, steps });
        notify(`Step convertito in ${successLabel}.`, 'success');
      } catch (err) {
        console.error('toggleQuestionarioCheck error', err);
        notify('Impossibile aggiornare il tipo di step.', 'error');
      } finally {
        const next = { ...switchingStepType.value };
        delete next[mapKey];
        switchingStepType.value = next;
      }
    };

    const canConvertQuestionarioStep = (percorso, row) => {
      if (!percorso || !row) return false;
      if (row.key !== 'questionario' && row.key !== 'check_finale') return false;
      const idx = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (idx !== 0) return false;
      if (row.key === 'check_finale') {
        const step = Array.isArray(percorso.steps) ? percorso.steps[idx] : null;
        if (!step?.convertedFromQuestionario) return false;
      }
      return true;
    };

    const convertButtonTitle = (row) => {
      if (!row) return 'Converti';
      return row.key === 'check_finale' ? 'Converti in questionario iniziale' : 'Converti in check finale';
    };

    const requestToggleQuestionarioCheck = (percorso, row) => {
      if (!row || (row.key !== 'questionario' && row.key !== 'check_finale')) return;
      if (!canConvertQuestionarioStep(percorso, row)) {
        notify('Solo il questionario iniziale dello step 1 può essere convertito.', 'error');
        return;
      }
      const targetLabel = row.key === 'questionario' ? 'check finale' : 'questionario iniziale';
      const confirmed = confirm(
        `Convertire questo step in ${targetLabel}? Lo stato Inviato/Nascosto verrà azzerato. Gli invii storici non verranno eliminati o modificati.`
      );
      if (!confirmed) return;
      return toggleQuestionarioCheck(percorso, row);
    };

    /* ===== RENDER STEPS ===== */
    const normalizeConsulenzaType = (raw) => {
      const value = String(raw || '').toLowerCase();
      if (value.includes('nutriz')) return 'nutrizionale';
      if (value.includes('tecnic')) return 'tecnica';
      return '';
    };
    const isFirstProgramInSequence = (percorso) => {
      const idx = getSequenceIndex(percorso);
      const total = Number(percorso?.sequenceTotal);
      if (idx === 1) return true;
      if (idx == null && (!Number.isFinite(total) || total <= 1)) return true;
      return false;
    };
    const STEP_ORDER = {
      questionario: 3,
      consegna: 6,
      consulenza: 10,
      check_finale: 12
    };
    const stepOrderForPercorso = (percorso, key, consulenzaType, step) => {
      const normalizedType = normalizeConsulenzaType(consulenzaType);
      if (key === 'consulenza' && step?.consulenzaPlacement === 'after-consegna') {
        return isFirstProgramInSequence(percorso) ? 4 : STEP_ORDER.consulenza;
      }
      if (isFirstProgramInSequence(percorso)) {
        if (key === 'questionario') return 1;
        if (key === 'check_finale' && step?.convertedFromQuestionario) return 1;
        if (key === 'consulenza' && normalizedType === 'nutrizionale') return 2;
        if (key === 'consegna') return 3;
        if (key === 'consulenza' && normalizedType === 'tecnica') return 4;
        if (key === 'check_finale') return 5;
      }
      let order = STEP_ORDER[key] ?? 99;
      if (key === 'consulenza' && normalizedType === 'nutrizionale') {
        order = 2;
      }
      return order;
    };

    const stepsToRender = (percorso) => {
      const all = Array.isArray(percorso?.steps) ? percorso.steps : [];
      if (!all.length) return [];

      const normalized = all
        .map((step, idx) => {
          const key = stepKeyFromName(step?.name);
          const type = step?.consulenzaType;
          const plannedAt = step?.plannedAt || null;
          const isDone = isStepEffectivelyDone(step);
          const order = stepOrderForPercorso(percorso, key, type, step);
          const row = {
            key,
            realIndex: idx,
            step,
            isDone,
            order,
            plannedAt
          };
          if (key === 'questionario' || key === 'check_finale') {
            row.questionarioLocation = resolveQuestionarioLocation(percorso, row);
          }
          return row;
        })
        .filter(item => !!item.key);

      normalized.sort((a, b) => {
        if (a.order !== b.order) return a.order - b.order;
        return a.realIndex - b.realIndex;
      });

      let lastOrder = null;
      normalized.forEach((item, index) => {
        const currentOrder = item.order;
        item.sectionBreak = index > 0 && currentOrder !== lastOrder;
        lastOrder = currentOrder;
      });

      const consegnaRow = normalized.find((item) => item.key === 'consegna');
      const consegnaDone = consegnaRow ? consegnaRow.isDone : true;
      normalized.forEach((item) => {
        if (item.key === 'check_finale') {
          const checkAlreadyDone = item.isDone;
          const hasOverride = !!item.step?.allowCheckOverride;
          const converted = !!item.step?.convertedFromQuestionario;
          item.isLockedByConsegna = !converted && !checkAlreadyDone && !consegnaDone && !hasOverride;
        }
      });

      return normalized;
    };

    const fullStepName = (row) => {
      if (!row) return '';
      if (row.key === 'check_finale') return 'Check finale';
      if (row.key === 'questionario') return 'Questionario iniziale';
      return row.step?.name || '';
    };
    const stepInitialClass = (row) => {
      if (!row?.questionarioLocation) return '';
      if (row.questionarioLocation === 'questionari') return 'step-initial--questionari';
      if (row.questionarioLocation === 'scaduti') return 'step-initial--scaduti';
      return '';
    };
    const stepInitialTitle = (row) => {
      const base = fullStepName(row);
      const label = questionarioLocationLabel(row?.questionarioLocation);
      if (label) return `${base} · ${label}`;
      return base;
    };

    /* ===== Consulenze (doc separato) ===== */
    const formatInputDate = (iso) => {
      if (!iso) return '';
      const d = new Date(iso); if (isNaN(d)) return '';
      const yyyy = d.getUTCFullYear();
      const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(d.getUTCDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const onConsegnaDoneDateChange = async (percorso, row, value) => {
      if (isPercorsoLocked(percorso)) return;
      if (!row?.step?.done) return;
      const stepIndex = resolveStepIndex(percorso, 'consegna', row?.realIndex ?? null);
      if (stepIndex < 0) return;
      const mapKey = stepIndexKey(percorso.id, stepIndex);
      if (updatingConsegnaDone.value[mapKey]) return;
      const currentDoneDate = formatInputDate(row?.step?.doneAt);
      if (currentDoneDate && currentDoneDate === value) return;

      const iso = value ? `${value}T00:00:00.000Z` : null;
      if (!iso) return;

      try {
        updatingConsegnaDone.value = { ...updatingConsegnaDone.value, [mapKey]: true };
        await updateConsegnaDoneAt(percorso.id, stepIndex, iso);
        notify('Data consegna aggiornata.', 'success');
      } catch (err) {
        console.error('onConsegnaDoneDateChange error', err);
        notify('Impossibile aggiornare la data di consegna.', 'error');
      } finally {
        const next = { ...updatingConsegnaDone.value };
        delete next[mapKey];
        updatingConsegnaDone.value = next;
      }
    };

    


    /* ===== Posticipo (usa le utility) ===== */
    const openGroupPostponeModal = (groupId) => {
      if (!groupId) return;
      if (groupPostponeSelection.value[groupId] == null) {
        groupPostponeSelection.value[groupId] = 30;
      }
      groupPostponeModalOpen.value = { ...groupPostponeModalOpen.value, [groupId]: true };
    };
    const closeGroupPostponeModal = (groupId) => {
      if (!groupId) return;
      const next = { ...groupPostponeModalOpen.value };
      delete next[groupId];
      groupPostponeModalOpen.value = next;
    };
    const posticipaGruppo = async (group) => {
      if (!group?.id) return;
      const sel = Number(groupPostponeSelection.value[group.id] || 30) || 30;
      const targets = (group.percorsi || []).filter(
        (p) => !p.consulenzeOnly && !isPercorsoHistoryLocked(p) && !isPercorsoFullyCompleted(p)
      );
      if (!targets.length) {
        notify('Nessun programma attivo da posticipare in questo percorso.', 'error');
        return;
      }
      postponingGroup.value = { ...postponingGroup.value, [group.id]: true };
      try {
        await Promise.all(targets.map((p) => postponePercorso(p.id, sel)));
        notify(`Percorso posticipato di ${sel} giorni (${targets.length} programmi).`, 'success');
        closeGroupPostponeModal(group.id);
      } catch (e) {
        console.error('posticipaGruppo error', e);
        notify('Errore durante il posticipo del percorso.', 'error');
      } finally {
        const next = { ...postponingGroup.value };
        delete next[group.id];
        postponingGroup.value = next;
      }
    };
    const resetPosticipoGruppo = async (group) => {
      if (!group?.id) return;
      const targets = (group.percorsi || []).filter(
        (p) => !p.consulenzeOnly && !isPercorsoHistoryLocked(p)
      );
      if (!targets.length) return;
      resettingGroup.value = { ...resettingGroup.value, [group.id]: true };
      try {
        await Promise.all(targets.map((p) => resetPostpone(p.id)));
        notify(`Posticipo azzerato per ${targets.length} programmi.`, 'success');
        closeGroupPostponeModal(group.id);
      } catch (e) {
        console.error('resetPosticipoGruppo error', e);
        notify('Errore durante il reset del percorso.', 'error');
      } finally {
        const next = { ...resettingGroup.value };
        delete next[group.id];
        resettingGroup.value = next;
      }
    };

// KPI in testata
const consulenzeTotal = computed(() => consulenzeRows.value.length);
const consulenzeDone  = computed(() =>
  consulenzeRows.value.filter(r => isConsulenzaStatusDone(r?.consulenzaStatus) || !!r.doneAt).length
);

    /* ===== Documenti manuali ===== */
    const manualDocs = ref([]);
    const deletingManualDocs = ref({});
    let loadManualDocsRequestId = 0;

    const manualDocGroupKey = (docRow) => {
      if (!docRow) return '';
      const rawKey =
        docRow.questionarioKey ||
        docRow.questionarioUid ||
        docRow.questionarioDocId ||
        '';
      const rawStep = (docRow.stepKey || docRow.questionarioStepKey || '')
        .toString()
        .trim()
        .toLowerCase();
      const rawType = (docRow.type || '').toString().trim().toLowerCase();
      let stepKey = rawStep;
      if (!stepKey) {
        if (rawType.includes('check_finale')) stepKey = 'check_finale';
        else if (rawType.includes('feedback_programmi')) stepKey = 'feedback_programmi';
        else if (rawType.includes('questionario')) stepKey = 'questionario';
        else stepKey = rawType;
      }
      const uidKey = (docRow.uid || '').toString().trim();
      const fallbackKey = uidKey && stepKey ? `${uidKey}__${stepKey}` : '';

      const normalizedRaw = String(rawKey || '').trim();
      const normalizedId = String(docRow.id || '').trim();
      if (normalizedRaw && normalizedRaw !== normalizedId) {
        return stepKey ? `${stepKey}__${normalizedRaw}` : normalizedRaw;
      }
      if (fallbackKey) return fallbackKey;
      if (normalizedRaw) return stepKey ? `${stepKey}__${normalizedRaw}` : normalizedRaw;
      return docRow.id || '';
    };

    const dedupeManualDocs = (list = []) => {
      const map = new Map();
      list.forEach((docRow) => {
        const key = manualDocGroupKey(docRow);
        if (!key) return;
        const current = map.get(key);
        if (!current) {
          map.set(key, docRow);
          return;
        }
        const currentTime = toMillis(current?.updatedAt || current?.createdAt);
        const nextTime = toMillis(docRow?.updatedAt || docRow?.createdAt);
        if (Number.isNaN(currentTime) && Number.isNaN(nextTime)) return;
        if (Number.isNaN(currentTime) || nextTime >= currentTime) {
          map.set(key, docRow);
        }
      });
      return Array.from(map.values());
    };

    const manualDocsOrdered = computed(() => {
      const list = Array.isArray(manualDocs.value) ? [...manualDocs.value] : [];
      list.sort((a, b) => manualDocsSortByUpdated(a, b, toMillis));
      return list;
    });
    const hasManualDocsSection = computed(() => manualDocsOrdered.value.length > 0);
    const manualDocsByType = computed(() => {
      const map = {};
      manualDocsOrdered.value.forEach((doc) => {
        const key = resolveManualConfigByDoc(doc).stepKey;
        if (!map[key]) map[key] = [];
        map[key].push(doc);
      });
      return map;
    });
    const manualDocsForKey = (key) => manualDocsByType.value[key] || [];
    const hasManualDocsForKey = (key) => manualDocsForKey(key).length > 0;

    const resolveManualConfigByDoc = (docRow) => {
      if (!docRow) return MANUAL_FORM_TYPES.questionario;
      if (docRow.stepKey && MANUAL_FORM_TYPES[docRow.stepKey]) return MANUAL_FORM_TYPES[docRow.stepKey];
      if (docRow.type === MANUAL_FORM_TYPES.check_finale.type) return MANUAL_FORM_TYPES.check_finale;
      return MANUAL_FORM_TYPES.questionario;
    };

    const manualDocTypeLabel = (docRow) => {
      const config = resolveManualConfigByDoc(docRow);
      return config.label;
    };

    const labelForStepKey = (key) => (key === 'check_finale' ? 'check finale' : 'questionario');

    const isTruthyManualStandalone = (value) => {
      if (value === true) return true;
      if (value === 1) return true;
      if (value === '1') return true;
      if (typeof value === 'string') {
        const v = value.trim().toLowerCase();
        return v === 'true' || v === 'yes';
      }
      return false;
    };

    const isManualQuestionarioPayload = (payload) => {
      if (!payload || payload.percorsoId) return false;
      if (isTruthyManualStandalone(payload.manualStandalone)) return true;

      const stepKey = String(payload.stepKey || '').trim().toLowerCase();
      const allowedStepKeys = new Set(['questionario', 'check_finale', 'feedback_programmi']);
      const typeKey = String(payload.type || '').trim().toLowerCase();
      const allowedTypes = new Set([
        'user_programmi_questionario',
        'user_programmi_check_finale',
        'feedback_programmi',
      ]);
      const hasAllowedStepKey = !!stepKey && allowedStepKeys.has(stepKey);
      const hasAllowedType = !!typeKey && allowedTypes.has(typeKey);
      if (!hasAllowedStepKey && !hasAllowedType) return false;

      const isZeroOrNull = (value) => {
        if (value == null) return true;
        const num = Number(value);
        return !Number.isNaN(num) && num === 0;
      };

      return payload.sequenceGroupId == null
        && isZeroOrNull(payload.sequenceIndex)
        && isZeroOrNull(payload.sequenceTotal)
        && isZeroOrNull(payload.stepIndex);
    };

    const manualDocOptionLabel = (docRow) => {
      const label = docRow.stepName || manualDocTypeLabel(docRow);
      const updated = docRow.updatedAt || docRow.createdAt;
      const dateLabel = updated ? `${formatDateOnly(updated)}`.trim() : '';
      return dateLabel ? `${label} · ${dateLabel}` : label;
    };

    const openManualDocument = (docRow) => {
      if (!docRow?.id || !props.userId) return;
      const config = resolveManualConfigByDoc(docRow);
      router.push({
        name: config.routeName,
        params: { userId: props.userId },
        query: {
          questionarioDocId: docRow.id,
          stepKey: config.stepKey,
          manualStandalone: '1',
        },
      });
    };

    const deleteManualDocument = async (docRow) => {
      if (!docRow?.id) return;
      if (!confirm('Eliminare questo documento manuale?')) return;
      deletingManualDocs.value = { ...deletingManualDocs.value, [docRow.id]: true };
      try {
        await deleteDoc(doc(db, QUESTIONARI_COLLECTION, docRow.id));
        manualDocs.value = (manualDocs.value || []).filter((item) => item.id !== docRow.id);
        notify('Documento manuale eliminato.', 'success');
      } catch (error) {
        console.error('Errore eliminazione documento manuale', error);
        notify('Impossibile eliminare il documento manuale.', 'error');
      } finally {
        const next = { ...deletingManualDocs.value };
        delete next[docRow.id];
        deletingManualDocs.value = next;
      }
    };

    const loadManualDocs = async (uid = props.userId) => {
      const requestId = ++loadManualDocsRequestId;
      if (!uid) {
        manualDocs.value = [];
        return;
      }

      try {
        const qManual = query(
          collection(db, QUESTIONARI_COLLECTION),
          where('uid', '==', uid)
        );
        const qs = await getDocs(qManual);
        if (requestId !== loadManualDocsRequestId) return;
        const list = qs.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((docRow) => isManualQuestionarioPayload(docRow));
        manualDocs.value = dedupeManualDocs(list);
      } catch (error) {
        if (requestId !== loadManualDocsRequestId) return;
        console.error('Errore caricamento documenti manuali', error);
      }
    };

    const refreshProgramData = async (uid = props.userId) => {
      if (!uid) {
        percorsi.value = [];
        manualDocs.value = [];
        loading.value = false;
        error.value = '';
        return;
      }
      await Promise.all([
        fetchProducts(),
        fetchPercorsi(uid),
        loadManualDocs(uid),
      ]);
    };

    const copyManualModalOpen = ref(false);
    const copyManualContext = ref(null);
    const selectedManualDocId = ref('');
    const copyingManualDoc = ref(false);
    const copyManualStepKey = computed(() => copyManualContext.value?.stepKey || 'questionario');
    const copyManualStepName = computed(
      () => copyManualContext.value?.stepName || (copyManualStepKey.value === 'check_finale' ? 'Check finale' : 'Questionario iniziale')
    );
    const copyManualProgramTitle = computed(
      () => copyManualContext.value?.percorsoTitle || ''
    );
    const copyManualHeading = computed(() =>
      copyManualStepKey.value === 'check_finale' ? 'check finale' : 'questionario'
    );
    const copyManualOptions = computed(() => manualDocsForKey(copyManualStepKey.value));

    const questionarioDocIdFromRow = (row) => {
      const candidates = [
        row?.step?.questionnaire?.id,
        row?.step?.questionnaire?.questionarioUid,
        row?.step?.questionnaire?.questionarioDocId,
        row?.step?.questionnaire?.questionnaireDocId,
        row?.step?.questionnaireDocId,
        row?.step?.questionarioDocId,
      ];
      return (
        candidates
          .map((value) => {
            if (value === undefined || value === null) return '';
            return String(value).trim();
          })
          .find(Boolean) || ''
      );
    };

    const isQuestionarioOverdue = (row) => {
      if (!row || row.isDone) return false;
      const plannedAt = row.step?.plannedAt || row.plannedAt || null;
      const planned = toDateSafe(plannedAt);
      if (!planned) return false;
      return planned.getTime() <= Date.now();
    };

    const resolveQuestionarioLocation = (percorso, row) => {
      if (!row || (row.key !== 'questionario' && row.key !== 'check_finale')) return null;
      if (isQuestionarioOverdue(row)) return 'scaduti';
      const docId = questionarioDocIdFromRow(row);
      if (docId) return 'questionari';
      return null;
    };

    const questionarioLocationLabel = (key) =>
      QUESTIONARIO_LOCATION_META[key]?.label || '';

    const buildStepQuestionarioMetadata = (percorso, row, stepIndex) => {
      const meta = {
        percorsoId: percorso?.id || null,
        stepIndex: Number.isInteger(stepIndex) ? stepIndex : null,
        stepKey: row?.key || null,
        sequenceGroupId: percorso?.sequenceGroupId || percorso?.id || null,
        sequenceIndex: getSequenceIndex(percorso) || null,
        sequenceTotal: Number.isFinite(Number(percorso?.sequenceTotal))
          ? Number(percorso.sequenceTotal)
          : null,
        productId: percorso?.productId || null,
        productName: percorso?.productName || null,
        programTitle: percorso?.title || null,
        programLabel: renderProgramTitle(percorso?.title),
        plannedStartAt: percorso?.plannedStartAt || null,
        expireAt: percorso?.expireAt || null,
        stepName: row?.step?.name || null,
        orderRef: percorso?.orderRef ? String(percorso.orderRef) : null,
      };
      if (meta.percorsoId && Number.isInteger(meta.stepIndex)) {
        meta.questionarioKey = `${meta.percorsoId}__${meta.stepIndex}`;
      }
      return meta;
    };

    const openCopyManualDocModal = (percorso, row) => {
      if (!percorso || (row?.key !== 'questionario' && row?.key !== 'check_finale')) return;
      if (isRowActionDisabled(percorso, row)) return;
      if (!hasManualDocsForKey(row.key)) {
        const label = row.key === 'check_finale' ? 'check finali' : 'questionari';
        notify(`Non ci sono ${label} manuali disponibili.`, 'error');
        return;
      }
      const stepIndex = resolveStepIndex(percorso, row.key, row?.realIndex ?? null);
      if (stepIndex < 0) {
        notify('Step non trovato per questo programma.', 'error');
        return;
      }
      const metadata = buildStepQuestionarioMetadata(percorso, row, stepIndex);
      copyManualContext.value = {
        percorsoId: percorso.id,
        percorsoTitle: renderProgramTitle(percorso.title),
        stepIndex,
        stepKey: row.key,
        stepName: row.step?.name || (row.key === 'check_finale' ? 'Check finale' : 'Questionario iniziale'),
        questionarioDocId: questionarioDocIdFromRow(row) || null,
        metadata,
      };
      selectedManualDocId.value = manualDocsForKey(row.key)[0]?.id || '';
      copyManualModalOpen.value = true;
    };

    const closeCopyManualDocModal = () => {
      copyManualModalOpen.value = false;
      copyManualContext.value = null;
      selectedManualDocId.value = '';
      copyingManualDoc.value = false;
    };

    const updateStepQuestionnaireEntry = async (ctx, docId, templateInfo = {}) => {
      if (!ctx?.percorsoId || !Number.isInteger(ctx.stepIndex)) return;
      try {
        const percorsoRef = doc(db, 'percorsi', ctx.percorsoId);
        const snap = await getDoc(percorsoRef);
        if (!snap.exists()) return;
        const data = snap.data() || {};
        const steps = Array.isArray(data.steps) ? [...data.steps] : [];
        const prev = steps[ctx.stepIndex] || {};
        const prevQuestionnaire = prev.questionnaire || {};
        const mergedMeta = {
          ...prevQuestionnaire,
          ...ctx.metadata,
          ...templateInfo,
          questionarioDocId: docId,
          questionarioUid: docId,
          id: docId,
          updatedAt: new Date().toISOString(),
        };
        steps[ctx.stepIndex] = {
          ...prev,
          questionarioDocId: docId,
          questionnaireDocId: docId,
          questionnaire: mergedMeta,
        };
        await updateDoc(percorsoRef, { steps });
      } catch (error) {
        console.error('Errore aggiornando il passo questionario dopo la copia manuale', error);
      }
    };

    const confirmCopyManualDoc = async () => {
      const ctx = copyManualContext.value;
      const manualDocId = selectedManualDocId.value;
      if (!ctx || !manualDocId) {
        notify('Seleziona il documento manuale da cui copiare.', 'error');
        return;
      }
      try {
        copyingManualDoc.value = true;
        const manualRef = doc(db, QUESTIONARI_COLLECTION, manualDocId);
        const manualSnap = await getDoc(manualRef);
        if (!manualSnap.exists()) {
          notify('Documento manuale non trovato.', 'error');
          return;
        }
        const manualData = manualSnap.data() || {};

        let targetDocId = ctx.questionarioDocId;
        let targetDocRef;
        let existingTargetData = null;
        const shouldDetachManualDoc = targetDocId && manualDocId && targetDocId === manualDocId;
        if (!targetDocId || shouldDetachManualDoc) {
          // Never overwrite the manual document; generate (or regenerate) a dedicated doc for the step.
          targetDocRef = doc(collection(db, QUESTIONARI_COLLECTION));
          targetDocId = targetDocRef.id;
        } else {
          targetDocRef = doc(db, QUESTIONARI_COLLECTION, targetDocId);
          const existingSnap = await getDoc(targetDocRef);
          existingTargetData = existingSnap.exists() ? existingSnap.data() : null;
        }

        const templateInfo = {
          templateId: manualData.templateId || MANUAL_FORM_TYPES.questionario.templateId,
          templateKey: manualData.templateKey || MANUAL_FORM_TYPES.questionario.templateKey,
          templateLabel: manualData.templateLabel || MANUAL_FORM_TYPES.questionario.templateLabel,
          templateVersion:
            manualData.templateVersion ?? MANUAL_FORM_TYPES.questionario.templateVersion,
          type: manualData.type || MANUAL_FORM_TYPES.questionario.type,
        };

        const payload = {
          answers: manualData.answers || {},
          allowPartial: !!manualData.allowPartial,
          questionarioUid: targetDocId,
          uid: props.userId,
          manualStandalone: false,
          createdAt: existingTargetData?.createdAt || manualData.createdAt || serverTimestamp(),
          updatedAt: serverTimestamp(),
          ...templateInfo,
          ...ctx.metadata,
        };

        await setDoc(targetDocRef, payload, { merge: true });
        await updateStepQuestionnaireEntry(ctx, targetDocId, templateInfo);
        await fetchPercorsi(props.userId);
        notify(`${labelForStepKey(ctx.stepKey)} aggiornato dai dati manuali.`, 'success');
        closeCopyManualDocModal();
      } catch (error) {
        console.error('Errore durante la copia del questionario manuale', error);
        notify('Impossibile copiare il documento manuale.', 'error');
      } finally {
        copyingManualDoc.value = false;
      }
    };

    /* ===== Percorsi manuali: UI ===== */
    const showAddStep = ref(false);
    const addStepType = ref('questionario');
    const addingStep  = ref(false);
    const showConsulenzeModal = ref(false);
    const creatingConsulenze = ref(false);
    const consulenzeForm = ref({ type: 'Nutrizionale', quantity: 1 });

    function openAddStepModal() {
      addStepType.value = 'questionario';
      showAddStep.value = true;
    }
    function closeAddStep() {
      showAddStep.value = false;
      addingStep.value  = false;
    }

    const openConsulenzeModal = () => {
      consulenzeForm.value = { type: 'Nutrizionale', quantity: 1 };
      showConsulenzeModal.value = true;
    };
    const closeConsulenzeModal = () => {
      showConsulenzeModal.value = false;
      creatingConsulenze.value = false;
    };

    async function createStandaloneManualDocument() {
      if (addingStep.value) return;
      const config = MANUAL_FORM_TYPES[addStepType.value];
      if (!config) {
        notify('Seleziona un tipo di documento valido.', 'error');
        return;
      }
      if (!props.userId) {
        notify('Utente non valido per la creazione del documento.', 'error');
        return;
      }

      try {
        addingStep.value = true;
        const docRef = doc(collection(db, QUESTIONARI_COLLECTION));
        await setDoc(docRef, {
          uid: props.userId,
          type: config.type,
          templateId: config.templateId,
          templateKey: config.templateKey,
          templateLabel: config.templateLabel,
          templateVersion: config.templateVersion,
          stepKey: config.stepKey,
          stepName: config.stepName,
          stepIndex: null,
          sequenceGroupId: null,
          sequenceIndex: null,
          sequenceTotal: null,
          percorsoId: null,
          productId: null,
          productName: null,
          programTitle: null,
          programLabel: null,
          plannedStartAt: null,
          expireAt: null,
          answers: {},
          questionarioUid: docRef.id,
          manualStandalone: true,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });

        closeAddStep();
        notify(`${config.label} manuale creato.`, 'success');
        await router.push({
          name: config.routeName,
          params: { userId: props.userId },
          query: {
            questionarioDocId: docRef.id,
            stepKey: config.stepKey,
            manualStandalone: '1',
          },
        });
      } catch (e) {
        console.error('Errore creazione documento manuale', e);
        notify('Errore nella creazione del documento manuale.', 'error');
        addingStep.value = false;
      }
    }

    const createConsulenzeManuali = async () => {
      if (creatingConsulenze.value) return;
      const qty = Number(consulenzeForm.value.quantity);
      if (!Number.isFinite(qty) || qty <= 0) {
        notify('Inserisci una quantità valida di consulenze.', 'error');
        return;
      }
      if (!props.userId) {
        notify('Utente non valido per creare consulenze.', 'error');
        return;
      }
      const type = consulenzeForm.value.type === 'Tecnica' ? 'Tecnica' : 'Nutrizionale';
      try {
        creatingConsulenze.value = true;
        await createConsulenzeOnlyPercorso({
          uid: props.userId,
          titleBase: 'Consulenze manuali',
          productName: 'Consulenze manuali',
          consNutrizionali: type === 'Nutrizionale' ? qty : 0,
          consTecniche: type === 'Tecnica' ? qty : 0,
          nowIso: new Date().toISOString(),
        });
        await fetchPercorsi(props.userId);
        notify('Consulenze create. Le trovi nella tabella per assegnarle ai programmi.', 'success');
        consulenzeOpen.value = true;
        closeConsulenzeModal();
      } catch (error) {
        console.error('createConsulenzeManuali error', error);
        notify('Errore nella creazione delle consulenze.', 'error');
      } finally {
        creatingConsulenze.value = false;
      }
    };

    onBeforeUnmount(() => {
      if (authUnsub) {
        authUnsub();
        authUnsub = null;
      }
      stopPercorsiRealtimeAdminNotes();
      toastTimers.forEach(clearTimeout);
      toastTimers.clear();
    });

    /* ===== bootstrap ===== */
    watch(
      () => props.userId,
      async (uid) => {
        stopPercorsiRealtimeAdminNotes();
        await refreshProgramData(uid);
        startPercorsiRealtimeAdminNotes(uid);
      },
      { immediate: true }
    );
    fetchProducts();
    initAuthWatcher();

    return {
      // base
      showModal, creating, form, products,
      percorsi, percorsiVisibili,
      loading, error, openIds, openGroups,
      reactivatingPercorso, lockingPercorso, overridingSequenceLock,
      toasts, dismissToast,

      // actions
      closeModal, addPercorso, toggleOpen, toggleGroupOpen,
      reactivatePercorso, lockPercorso, unlockSequenceManually, restoreSequenceLock,
      onSelectChange, onSelectChangeByKey, openQuestionario, openCheckFinale,
      unlockCheckFinale, toggleQuestionarioCheck, requestToggleQuestionarioCheck,
      resetQuestionarioStep, blockOverdueRemindersAfterEnable,
      refreshProgramData,
      openCreatePercorsoModal, closeCreatePercorsoModal, createPercorsoFromModal,
      onConsegnaFlagToggle, onProgCustomFlagToggle, isConsegnaFlagSaving, isProgCustomFlagSaving,

      // utils
      formatDate,
      formatDateOnly,
      selectedProduct,
      selectedProductTotal,
      currentIndexOptions,
      createPercorsoForm,
      createPercorsoModalOpen,
      creatingPercorso,
      createSelectedProduct,
      createSelectedProductTotal,
      isPercorsoLocked,
      areNotificationsEnabled,
      areGroupNotificationsEnabled,
      isGroupNotificationsPartial,
      notificationChipLabel,
      togglingGroupNotifications,
      toggleNotificationsForGroup,
      groupNoteEdits,
      updatingGroupNote,
      getGroupNoteValue,
      onGroupNoteInput,
      saveGroupNote,
      lockChipLabel,
      lockBannerTitle,
      lockBannerSubtitle,
      canReactivatePercorso,
      canManuallyUnlockSequence,
      canViewPastCheck,
      isRowActionDisabled,
      isQuestionarioDisabled,
      canConvertQuestionarioStep,
      convertButtonTitle,
      upcomingReminders,
      visibleReminders,
      hasUpcomingReminders,
      upcomingRemindersOpen,
      pendingRemindersCount,
      reminderCountLabel,
      reminderEmptyLabel,
      showHistoricalReminders,
      groupedPercorsi,
      canAddProgram,
      canCreatePercorso,
      canDeleteConsulenza,
      addingProgramToGroup,
      durationMonthOptions,
      updatingGroupDuration,
      activeProgramByGroup,
      isActiveGroup,
      isActiveProgram,
      groupHasPreviousBlocked,
      isPercorsoCompleted,
      isPercorsoPast,
      isPercorsoBlockedByPreviousGroup,
      renderProgramTitle,
      progressLabel: (p) => {
        const steps = Array.isArray(p.steps) ? p.steps : [];
        const blockingTotal = countBlockingSteps(steps);
        const tot = blockingTotal || steps.length;
        const done = blockingTotal ? countBlockingDoneSteps(steps) : countEffectiveDoneSteps(steps);
        return `${done}/${tot} completati`;
      },
      progressClass: (p) => {
        const steps = Array.isArray(p.steps) ? p.steps : [];
        const blockingTotal = countBlockingSteps(steps);
        const tot = blockingTotal || steps.length;
        const done = blockingTotal ? countBlockingDoneSteps(steps) : countEffectiveDoneSteps(steps);
        if (done === 0) return 'neutral';
        if (done < tot) return 'progress';
        return 'done';
      },

      // admin status
      keyFor, stepIndexKey, needsUpdateOpen, needsUpdateNotes, sendingNotification, togglingWorked, togglingRenewal, switchingStepType,
      resettingStep,
      adminLabel, adminChipClass, isStepRenewal, isStepStopped, isStepDailyMarked, dailyStepChipClass, dailyStepChipLabel,
      sendAdminNotification, toggleAdminApprovedByKey, toggleNeedsUpdateUIByKey, saveNeedsUpdateByKey,
      toggleRenewalByKey, toggleCheckFinalWorkedByKey,

      // rendering steps
      stepsToRender,
      fullStepName,
      stepInitialClass,
      stepInitialTitle,
      deletePercorsoCascade,
      deletePercorsoGroup,
      deletingGroupPercorsi,
      toggleReminderBlock,
      scheduleReminderNextRun,
      suppressingReminder,
      reminderStatusLabel,
      reminderBadgeClass,
      reminderTimingLabel,

      // consulenze (doc separati)
      consulenzeOpen, toggleConsulenze,
      formatInputDate, onConsegnaDoneDateChange, updatingConsegnaDone,
      updatingConsegnaFlag, updatingProgCustomFlag,
      consulenzeDone, consulenzeTotal,
      groupPostponeSelection, posticipaGruppo, postponingGroup,
      resetPosticipoGruppo, resettingGroup,
      openGroupPostponeModal, closeGroupPostponeModal, groupPostponeModalOpen, groupedPostponeModal,
      addProgramToGroup, onGroupDurationChange,

      // NOTE INTERNE
      staffNoteEdits, savingNote, saveStatus, saveStaffNoteByKey,

      // gestione step manuali
      manualDocsOrdered, hasManualDocsSection, manualDocTypeLabel,
      manualDocOptionLabel, hasManualDocsForKey, manualDocsForKey,
      openManualDocument, deleteManualDocument, deletingManualDocs,
      showAddStep, addStepType, addingStep,
      openAddStepModal, closeAddStep, createStandaloneManualDocument,
      showConsulenzeModal, consulenzeForm, creatingConsulenze,
      openConsulenzeModal, closeConsulenzeModal, createConsulenzeManuali,
      copyManualModalOpen, copyManualContext,
      selectedManualDocId, copyingManualDoc,
      copyManualStepName, copyManualProgramTitle, copyManualHeading, copyManualOptions,
      openCopyManualDocModal, closeCopyManualDocModal, confirmCopyManualDoc,
      onConsulenzaStatusChangeByKey, updateConsulenzaField, updateConsulenzaDate, updateConsulenzaPlannedAt,
      moveConsulenza, deleteConsulenza, deletingConsulenza,
      consulenzeRows, consulenzaMoveOptions, consulenzaMoveTarget, movingConsulenza, isToday,
      activeConsulenzaRow, openConsulenzaDetail, closeConsulenzaDetail,
      normalizeConsulenzaStatus, consulenzaStatusClass, consulenzaTypeClass,
      hasDetachedConsulenze, detachedConsulenzeCount,
      savingDaily,
      unlockingCheckFinale,
      markDailySendByKey,
      markDailyFlagOnlyByKey,
      canShowDailySendForStep,
      isDailySendButtonDisabled,
      dailySendButtonTitle,
      canShowDailyHideForStep,
    };
  }
};
</script>


<style scoped>

.percorso-group {
  display: grid;
  gap: 16px;
  margin-bottom: 28px;
}

.reminders-table {
  width: 100%;
  border-collapse: collapse;
}
.reminders {
  background: #e0e8fb;
  border-radius: 14px;
  padding: 10px 12px 14px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.28);
}
.reminders-body {
  background: transparent;
}
.reminders .card-head {
  background: #fff;
  border-radius: 10px;
  padding: 12px 16px;
}
.reminders-inner {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
  box-shadow: 0 8px 24px rgba(15,23,42,0.12);
}
.reminders-table th,
.reminders-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
}
.reminders-table tr:last-child td { border-bottom: none; }
.reminders-table th {
  font-weight: 700;
  color: #0f172a;
}
.reminders-table td {
  color: #111827;
}
.reminder-type { color: #111; font-weight: 600; }
.reminder-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
}
.reminder-badge.badge-success {
  background: #dcfce7;
  color: #15803d;
}
.reminder-badge.badge-warning {
  background: #fef9c3;
  color: #a16207;
}
.reminder-badge.badge-danger {
  background: #fee2e2;
  color: #b91c1c;
}
.reminder-badge.badge-blocked {
  background: #ede9fe;
  color: #6b21a8;
}
.reminder-badge.badge-muted {
  background: #e2e8f0;
  color: #475569;
}
.reminder-badge.badge-sent {
  background: #e0f2fe;
  color: #0369a1;
}
.reminder-badge.badge-queued {
  background: #cffafe;
  color: #0ea5e9;
}
.reminder-tag-sent {
  display: inline-block;
  padding: 8px 12px;
  border-radius: 10px;
  background: #e0f2fe;
  color: #0f172a;
  font-weight: 600;
  border: 1px solid #bae6fd;
}
.reminder-btn {
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #fca5a5;
  background: #fff;
  color: #b91c1c;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s ease;
}
.reminder-btn.primary {
  border: 1px solid #0ea5e9;
  color: #0ea5e9;
}
.reminder-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.reminder-btn:not(:disabled):hover {
  background: #fff1f2;
  border-color: #ef4444;
}
.reminder-btn.primary:not(:disabled):hover {
  background: #ecfeff;
  border-color: #0284c7;
}
.reminder-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.percorso-group-summary {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  display: grid;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.percorso-group-summary__top {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.percorso-group-summary__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.percorso-group-summary__top-right {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
.group-duration-select {
  height: 34px;
  padding: 4px 8px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #d1d5db;
  font-size: 0.85rem;
  color: #0f172a;
}
.group-duration-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}
.percorso-group-notifications {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(15, 23, 42, 0.04);
}
.percorso-group-summary__chevron {
  margin-left: 4px;
  color: #334155;
}

.percorso-group--active .percorso-group-summary {
  border-color: #16a34a;
  background: linear-gradient(135deg, #ecfdf3 0%, #d1fae5 100%);
  box-shadow: 0 12px 28px rgba(22, 163, 74, 0.22);
}
.percorso-group--active .percorso-group-summary__label {
  color: #065f46;
}
.percorso-group-summary__chip--active {
  background: #22c55e;
  border: 1px solid #15803d;
  color: #064e3b;
}
.percorso-group--blocked-closed .percorso-group-summary {
  border-color: #ef4444;
  box-shadow: 0 10px 24px rgba(239, 68, 68, 0.18);
}
.percorso-group--blocked-closed .percorso-group-summary__label {
  color: #991b1b;
}

.percorso-group-summary__label {
  font-weight: 600;
  color: #0f172a;
  margin-right: 4px;
}

.percorso-group-summary__chip {
  background: #e2e8f0;
  color: #1e293b;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.85rem;
  line-height: 1.2;
}

.percorso-group-summary__dates {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 0.9rem;
  color: #334155;
  align-items: center;
  justify-content: flex-start;
}

.percorso-group-summary__dates strong {
  font-weight: 600;
  color: #0f172a;
}

.percorso-group-body {
  display: grid;
  gap: 10px;
}

.percorso-group-actions {
  display: flex;
  justify-content: flex-end;
  padding: 4px 0;
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
  padding: 0;
}

.icon-btn .material-icons {
  font-size: 20px;
}

.icon-btn.grey   { color:#374151; }
.icon-btn.green  { color:#065f46; border-color:#bbf7d0; background:#dcfce7; }
.icon-btn.orange { color:#9a3412; border-color:#fed7aa; background:#ffdfb9; }
.icon-btn.blue   { color:#1e3a8a; border-color:#93c5fd; background:#dbeafe; }
.icon-btn.red    { color:#991b1b; border-color:#fecaca; background:#fee2e2; }
.icon-btn.purple { color:#5b21b6; border-color:#ddd6fe; background:#ede9fe; }
.icon-btn.danger { color:#991b1b; border-color:#fecaca; background:#fee2e2; }

.manual-docs {
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.manual-docs__head {
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
}

.manual-docs__body {
  background: #f3f4f6;
  padding: 22px;
  border-radius: 0 0 20px 20px;
}

.manual-docs__empty {
  padding: 8px 0;
}

.manual-docs-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.manual-docs-table th,
.manual-docs-table td {
  text-align: left;
  padding: 12px 14px;
  border-bottom: 1px solid #e2e8f0;
}

.manual-docs-table tr:last-child td {
  border-bottom: none;
}

.manual-docs-table th {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
  background: #f1f5f9;
}

.manual-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.manual-btn {
  border: none;
  border-radius: 999px;
  padding: 7px 18px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  background: #22c55e;
  color: #fff;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.2s ease;
  box-shadow: 0 6px 16px rgba(34, 197, 94, 0.25);
}

.manual-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(34, 197, 94, 0.35);
}

.manual-btn--danger {
  background: #ef4444;
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.25);
}

.manual-btn--danger:hover:not(:disabled) {
  box-shadow: 0 10px 24px rgba(239, 68, 68, 0.35);
}

.manual-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
.icon-btn.purple.active { background:#c4b5fd; border-color:#a78bfa; color:#4c1d95; }

.icon-btn:disabled {
  opacity: .6;
  cursor: default;
}


/* Chip blu per "Invio di giornata" */
.chip-blue, .admin-chip.chip-blue {
  background: #dbeafe;
  color: #4169d7;
  border-color: #bfdbfe;
}
.admin-chip.chip-purple {
  background: #ede9fe;
  color: #5b21b6;
  border-color: #ddd6fe;
}
.admin-chip.chip-red {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

/* riga chip */
.chips-line { display:flex; gap:6px; align-items:center; flex-wrap:wrap; }

/* bottone blu */
.admin-col .buttons-container .blue {
  background:#8aadf7;
  color:#fff;
  border:1px solid #2563eb;
}
.admin-col .buttons-container .blue:disabled {
  opacity:.7;
  cursor: default;
}


/* ===== Consulenze: card / header ===== */
.consulenze-box {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;           /* niente overflow visibile */
  max-width: 100%;
  margin-top: 14px;
}

.consulenze-box .card-head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #f9fafb;
  padding: 12px 14px;
  border: 0;
  cursor: pointer;
}

.consulenze-box .head-left {
  display: flex;
  gap: 10px;
  align-items: baseline;
  min-width: 0;               /* evita forzature di larghezza */
}

.consulenze-box .title { font-weight: 600; color: #111; }
.consulenze-box .sub   { font-size: .9rem; color: #6b7280; }
.consulenze-box .material-icons { font-size: 20px; line-height: 20px; color: #6b7280; }

.consulenze-box .card-body {
  padding: 12px 14px 14px;
}

.consulenze-table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
}

.consulenze-table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.consulenze-table thead th {
  padding: 13px 14px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #475569;
  background: #f1f5f9;
  white-space: nowrap;
}

.consulenze-table th,
.consulenze-table td {
  border-bottom: 1px solid #e5e7eb;
  padding: 14px;
  text-align: left;
  vertical-align: middle;
}

.consulenze-table tbody tr:last-child td {
  border-bottom: none;
}

.consulenze-table tbody tr:nth-child(odd) td {
  background: #fcfcfd;
}

.consulenze-table th:nth-child(1),
.consulenze-table td:nth-child(1) {
  width: 42%;
}

.consulenze-table th:nth-child(2),
.consulenze-table td:nth-child(2) {
  width: 13%;
}

.consulenze-table th:nth-child(3),
.consulenze-table td:nth-child(3) {
  width: 18%;
}

.consulenze-table th:nth-child(4),
.consulenze-table td:nth-child(4) {
  width: 13%;
}

.consulenze-actions-col {
  width: 120px;
}

.consulenze-summary-cell {
  min-width: 0;
}

.consulenze-summary-cell--program .mono {
  font-size: 0.92rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.consulenze-summary-cell small {
  display: block;
  margin-top: 4px;
  color: #6b7280;
}

.consulenze-status-stack {
  display: grid;
  gap: 6px;
}

.consulenza-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
}

.consulenza-pill--neutral {
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #4b5563;
}

.consulenza-pill--technical {
  background: #dbeafe;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.consulenza-pill--nutritional {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #15803d;
}

.consulenza-pill--todo {
  background: #fef3c7;
  border-color: #fde68a;
  color: #b45309;
}

.consulenza-pill--scheduled {
  background: #e0e7ff;
  border-color: #c7d2fe;
  color: #4338ca;
}

.consulenza-pill--contacted {
  background: #ede9fe;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.consulenza-pill--escalated {
  background: #fce7f3;
  border-color: #fbcfe8;
  color: #9d174d;
}

.consulenza-pill--done {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #166534;
}

.consulenza-pill--rejected {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.date-edit {
  display: grid;
  gap: 8px;
}

.date-edit .link-btn {
  align-self: flex-start;
  white-space: nowrap;
}

.consulenze-detail-btn {
  min-width: 96px;
  justify-content: center;
}

.modal-content--consulenza-detail {
  width: min(860px, 92vw);
}

.consulenza-detail-subtitle {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.92rem;
}

.consulenza-detail-body {
  padding: 22px 28px;
  overflow-y: auto;
  display: grid;
  gap: 18px;
  background: #fff;
}

.consulenza-detail-top {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.consulenza-detail-summary-card {
  display: grid;
  gap: 4px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fafc;
}

.consulenza-detail-summary-card strong {
  color: #0f172a;
  font-size: 0.98rem;
}

.consulenza-detail-summary-card small {
  color: #64748b;
}

.consulenza-detail-summary-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.consulenza-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.q-field--wide {
  grid-column: 1 / -1;
}

.consulenza-detail-note {
  min-height: 110px;
  resize: vertical;
}

.consulenza-detail-grid input[type="text"],
.consulenza-detail-grid textarea {
  color: #111827;
  -webkit-text-fill-color: #111827;
}

.consulenza-detail-grid input[type="text"]::placeholder,
.consulenza-detail-grid textarea::placeholder {
  color: #9ca3af;
  -webkit-text-fill-color: #9ca3af;
}

.consulenza-detail-move {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}

.consulenza-detail-delete {
  background: #ef4444;
  border-color: #ef4444;
}

.consulenza-detail-delete:hover:not(:disabled) {
  background: #dc2626;
}

.consulenza-move .select,
.consulenza-detail-move .select {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #1f2937;
}

.consulenza-move .select:focus,
.consulenza-detail-move .select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
}

.move-btn {
  padding: 6px 12px;
  border: 1px solid #2563eb;
  background: #2563eb;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .consulenze-table {
    min-width: 700px;
  }

  .consulenze-table th,
  .consulenze-table td {
    padding: 12px 10px;
  }

  .consulenze-table thead th {
    font-size: 0.76rem;
  }
}

@media (max-width: 860px) {
  .consulenze-detail-top,
  .consulenza-detail-grid {
    grid-template-columns: 1fr;
  }

  .consulenza-detail-move {
    grid-template-columns: 1fr;
  }

  .consulenza-detail-move .btn {
    width: 100%;
  }

  .consulenze-box .head-left {
    flex-direction: column;
    align-items: flex-start;
  }
}
.badge-type{
  margin-left:6px;
  display:inline-block;
  padding:2px 6px;
  border-radius:999px;
  border:1px solid #e5e7eb;
  font-size:.72rem;
  background:#f9fafb;
  color:#374151;
}


.flex-gap { display:flex; gap:8px; align-items:center; }

.footer { display:flex; justify-content:space-between; align-items:center; gap:10px; margin-top:8px; }
.postpone-tools { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
.modal-postpone { max-width:540px; width:100%; background: #fff; border-radius:16px; padding:20px 20px 18px; box-shadow:0 10px 40px rgba(0,0,0,0.12); }
.modal-postpone__head { display:flex; align-items:center; justify-content:space-between; gap:8px; }
.modal-postpone__subtitle { margin:4px 0 16px; }
.modal-postpone__field { background:#f8fafc; border:1px solid #e6e9ef; border-radius:12px; padding:12px; }
.modal-postpone__label { display:block; font-weight:600; margin-bottom:8px; }
.modal-postpone__select { width:100%; }
.modal-postpone__actions { display:flex; flex-direction:column; gap:8px; margin-top:16px; }
.btn.wide { width:100%; justify-content:center; }
.btn.ghost { background:transparent; border:1px solid #d1d5db; color:#374151; }
.btn.btn-green { background:#1f9d55; color:#fff; }
.btn.btn-green:hover { background:#188249; }
.select { padding:8px 10px; border:1px solid #d1d5db; border-radius:10px; background:#fff; }

.card-head { width: 97%; display: flex; align-items: center; justify-content: space-between; background: #f9fafb; padding: 12px 14px; border: 0; cursor: pointer; }
.card-head .head-left { display:flex; gap:10px; align-items: baseline; }
.card-head .head-right { display:flex; align-items:center; gap:12px; }
.card-head .title { font-weight: 600; color:#111; }
.card-head .sub { font-size:.9rem; }
.card-body { padding: 12px 14px 14px; }
.card-head .material-icons { font-size: 20px; line-height: 20px; color: #6b7280; }
.reminders-toggle { display:flex; align-items:center; gap:8px; }
.reminders-toggle__label { font-size:.75rem; color:#475569; font-weight:600; white-space: nowrap; }


.doc-header td { font-weight: 600; background: #f9fafb; }
.doc-slots td { background: #fff; padding: 12px 8px; }

.slot-row { display: grid; grid-template-columns: 110px 150px 150px 160px 1fr; gap: 8px; align-items: center; padding: 6px 0; }
.slot-row > span { font-size: .9rem; color:#374151; }
.slot-row select, .slot-row input[type="date"], .slot-row input[type="text"] {
  width: 87%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 10px; background: #fff; color: #111; font-size: .9rem;
}

@media (max-width: 900px) {
  .slot-row { grid-template-columns: 1fr 1fr; grid-auto-rows: auto; }

}

.item.group-sep { margin-top: 16px; border-top: 2px dashed #e5e7eb; padding-top: 10px; }
.muted { color:#6b7280; }
.error { color:#b91c1c; }

.percorsi { display: grid; gap: 12px; margin-top: 14px; margin-bottom: 100px; }
.accordion { display: grid; gap: 10px; }
.item { border: 1px solid #e5e7eb; border-radius: 12px; background: #fff; overflow: hidden; }
.item-header-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.item-header-row .item-header {
  flex: 1;
}
.item--active {
  border-color: #16a34a;
  box-shadow: 0 14px 32px rgba(34, 197, 94, 0.26);
}
.item--active .item-header {
  background: #c7f8db;
  border-bottom: 1px solid #16a34a;
}
.item--active .title strong {
  color: #166534;
}
.item-header { width:100%; display:flex; align-items:center; justify-content:space-between; background:#f9fafb; padding:12px 14px; border:none; cursor:pointer; }
.item-header .title { display:flex; gap:8px; align-items:baseline; }
.item-header .meta { display:flex; gap:10px; align-items:center; }
.chevron { transition: transform .18s ease; }
.chevron.open { transform: rotate(180deg); }

.item-body { padding: 12px 14px 14px; display: grid; gap: 12px; }

.percorso-locked-banner {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px;
  color: #334155;
}
.percorso-locked-banner__text {
  display: grid;
  gap: 4px;
  max-width: 70%;
}
.percorso-locked-banner__text strong {
  font-size: 0.95rem;
}
.percorso-locked-banner__text span {
  font-size: 0.84rem;
}
.percorso-locked-banner__actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.percorso-locked-banner__btn {
  border: 1px solid #cbd5e1;
  background: #e2e8f0;
  color: #0f172a;
  border-radius: 10px;
  padding: 8px 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.percorso-locked-banner__btn:hover:not(:disabled) {
  background: #cbd5e1;
  border-color: #94a3b8;
  transform: translateY(-1px);
}
.percorso-locked-banner__btn:disabled {
  opacity: 0.7;
  cursor: default;
}

.percorso-unlocked-banner {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  background: #f9fafb;
  border-radius: 12px;
  color: #334155;
}
.percorso-unlocked-banner__text {
  display: grid;
  gap: 4px;
  max-width: 70%;
}
.percorso-unlocked-banner__text strong {
  font-size: 0.95rem;
}
.percorso-unlocked-banner__text span {
  font-size: 0.84rem;
}
.percorso-unlocked-banner__actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.manual-unlock-note {
  color: #4b5563;
  font-size: 0.82rem;
}
.percorso-unlocked-banner__btn {
  border: 1px solid #cbd5e1;
  background: #e2e8f0;
  color: #0f172a;
  border-radius: 10px;
  padding: 8px 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.percorso-unlocked-banner__btn:hover:not(:disabled) {
  background: #cbd5e1;
  border-color: #94a3b8;
  transform: translateY(-1px);
}
.percorso-unlocked-banner__btn--ghost {
  background: #f9fafb;
  color: #334155;
  border-color: #cbd5e1;
}
.percorso-unlocked-banner__btn--ghost:hover:not(:disabled) {
  background: #e2e8f0;
}
.percorso-unlocked-banner__btn:disabled {
  opacity: 0.7;
  cursor: default;
}

.item-header-notifications {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 6px;
  border: none;
  border-radius: 0;
  background: inherit;
}
.notification-switch {
  display: flex;
  align-items: center;
  gap: 6px;
}
.percorso-group-note {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(15, 23, 42, 0.04);
}
.percorso-group-note--accordion {
  align-self: center;
}
.percorso-group-note__label {
  font-weight: 600;
  color: #0f172a;
  font-size: 0.72rem;
}
.percorso-group-note__textarea {
  height: 30px;
  min-height: 30px;
  width: 89%;
  padding: 8px 8px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  font-size: 0.8rem;
  color: #0f172a;
  line-height: 1.2;
  resize: vertical;
  overflow: auto;
  margin-top: 0px!important;
}
.percorso-group-note__textarea:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  outline: none;
}
.percorso-group-note__textarea:disabled {
  background: #f1f5f9;
  color: #94a3b8;
}
.notification-switch--stacked {
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.notification-switch__label {
  font-weight: 600;
  color: #0f172a;
  font-size: 0.72rem;
}
.notification-switch__controls {
  display: flex;
  align-items: center;
  gap: 6px;
}
.notification-switch__state {
  font-weight: 700;
  color: #15803d;
  font-size: 0.72rem;
}
.notification-switch__state.off {
  color: #991b1b;
}
.notification-switch__state.partial {
  color: #b45309;
}
.toggle-switch {
  position: relative;
  width: 46px;
  height: 26px;
  display: inline-block;
}
.toggle-switch--small {
  width: 40px;
  height: 22px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #e2e8f0;
  border-radius: 26px;
  transition: background 0.2s ease;
  border: 1px solid #cbd5e1;
}
.toggle-switch--small .toggle-slider {
  width: 40px;
  height: 22px;
  border-radius: 22px;
}
.toggle-slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  top: 2px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.16);
  transition: transform 0.2s ease;
}
.toggle-switch--small .toggle-slider:before {
  width: 16px;
  height: 16px;
  left: 3px;
  top: 3px;
}
.toggle-switch input:checked + .toggle-slider {
  background: #22c55e;
  border-color: #16a34a;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(18px);
}
.toggle-switch--small input:checked + .toggle-slider:before {
  transform: translateX(18px);
}
.toggle-switch input:disabled + .toggle-slider {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .item-header-row {
    flex-direction: column;
  }
  .item-header-notifications {
    width: 100%;
    padding: 6px 2px 0;
    background: inherit;
  }
}

.steps-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 1px 8px; /* spazio orizzontale per evitare sovrapposizioni */
  font-size: 0.92rem;
  table-layout: fixed;
}
.steps-table thead th {
  padding: 10px 12px;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.75rem;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
}
.steps-table thead th,
.steps-table tbody td {
  white-space: normal;
  overflow-wrap: anywhere;
}
.steps-table tbody tr {
  --row-bg: #ffffff;
  --row-height: 80px;
  transition: background 0.2s ease;
  height: var(--row-height);
}
.steps-table tbody tr:nth-child(even) {
  --row-bg: #ffffff;
}
.steps-table tbody tr:hover {
  --row-bg: #e9eefc;
}
.steps-table tbody td {
  padding: 14px 16px;
  min-height: var(--row-height);
  vertical-align: middle;
  border: none;
  background: var(--row-bg);
  background-clip: padding-box;
}
.steps-table th:nth-child(3),
.steps-table td:nth-child(3),
.steps-table th:nth-child(4),
.steps-table td:nth-child(4) {
  width: 120px;
  max-width: 140px;
  white-space: nowrap;
}
.steps-table th:nth-child(1),
.steps-table td:nth-child(1) {
  min-width: 137px;
  padding-right: 18px;
}
.steps-table th:nth-child(2),
.steps-table td:nth-child(2) {
  min-width: 140px;
  padding-left: 6px;
}
.steps-table th:not(:first-child),
.steps-table td:not(:first-child) {
  text-align: center;
}
.steps-table td select {
  min-width: 120px;
}
.steps-table tbody td.step-name {

  overflow-wrap: normal;
  word-break: normal;
  white-space: normal;
  text-align: left;
}
.steps-table tbody tr.row-divider td {
  padding-top: 22px;
}
.steps-table tbody tr td:first-child {
  border-top-left-radius: 14px;
  border-bottom-left-radius: 14px;
}
.steps-table tbody tr td:last-child {
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
}
.step-name {
  align-items: center;
  gap: 10px;
}
.step-name-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.step-name-header {
  display: flex;
  align-items: center;
  gap: 6px;
}
.bullet { width:10px; height:10px; border-radius:999px; background:#d1d5db; display:inline-block; margin-top:4px; }
.bullet.done { background:#10b981; }
.step-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-align: left;
  color: #111827;
  font-weight: 600;
  line-height: 1.05;
}
.step-link__label {
  display: inline-block;
  max-width: 240px;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
}
.step-text-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.step-link span.done { text-decoration: line-through; color:#6b7280; }
.step-link small {
  font-size: 0.78rem;
  color: #94a3b8;
}
.step-initial {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e5edff 0%, #f3f4ff 100%);
  border: 1px solid #c7d2fe;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.2rem;
  color: #1e1b4b;
  letter-spacing: -0.02em;
}
.step-initial--questionari {
  background: #dcfce7;
  border-color: #86efac;
  box-shadow: 0 4px 10px rgba(22, 163, 74, 0.18);
  color: #166534;
}
.step-initial--scaduti {
  background: #ffedd5;
  border-color: #fdba74;
  box-shadow: 0 4px 10px rgba(234, 88, 12, 0.18);
  color: #9a3412;
}
.step-initial.done { opacity: 0.6; text-decoration: line-through; }
.step-subtype {
  display: block;
  margin-top: 2px;
  margin-left: 2px;
  color: #94a3b8;
}
.step-link:hover span { text-decoration: underline; }
.icon-btn--small {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}
.icon-btn--small .material-icons {
  font-size: 18px;
}
.date-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}
.date-cell__date {
  font-weight: 600;
  color: #111827;
}
.note-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.note-input {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #ffffff;
  color: #111827;
  box-sizing: border-box;
}
.note-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.note-message {
  font-size: 0.75rem;
  color: #6b7280;
}
.qi-tag {
  font-size: 0.76rem;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.qi-tag-btn {
  border: none;
  background: transparent;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}
.qi-tag-btn:hover {
  text-decoration: underline;
}
.link-btn {
  border: none;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
}
.link-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.qi-hint {
  font-size: 0.74rem;
  color: #64748b;
}

.admin-col { min-width: 260px; max-width: 100%; }
.admin-row { display: grid; gap: 6px; }
.admin-chip { display:inline-block; padding: 3px 8px; border-radius: 10px; border: 1px solid #e5e7eb; font-size: .78rem; line-height: 1.25rem; background: #f3f4f6; color:#374151; }
.chip-neutral { background:#f3f4f6; }
.chip-green   { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.chip-orange  { background:#fff7ed; color:#9a3412; border-color:#fed7aa; }

.admin-col .buttons-container { display:flex; gap:6px; align-items:center; flex-wrap:wrap; }
.admin-col .buttons-container > * { padding: 6px 10px; border-radius: 10px; font-size: .85rem; line-height: 1rem; }

.needs-box { margin-top: 8px; border: 1px solid #e5e7eb; background: #f9fafb; border-radius: 10px; padding: 10px; display: grid; gap: 8px; }
.needs-box .user-input { width: 82%; padding: 10px 12px; border-radius: 10px; border: 1px solid #d1d5db; background:#fff; color:#111; }
.needs-box .buttons-container { display:flex; gap:8px; justify-content:flex-end; align-items:center; }
.needs-box .create-user-button, .needs-box .action-button2 { padding: 8px 12px; border-radius: 10px; font-size: .9rem; }

.notification-control {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 8px;
}

.notification-chip {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  background: #dcfce7;
  color: #166534;
  font-weight: 600;
  text-transform: uppercase;
}

.notification-chip--off {
  background: #fee2e2;
  color: #991b1b;
}

.notification-toggle-btn {
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  background: #00a732;
  font-weight: 600;
  cursor: pointer;
}
.notification-toggle-btn--compact {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #e2e8f0;
  color: #0f172a;
  font-size: 0.84rem;
  font-weight: 600;
}
.notification-toggle-btn--compact:hover:not(:disabled) {
  background: #d7dde4;
  border-color: #94a3b8;
}

.notification-toggle-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.footer { display:flex; justify-content:flex-end; margin-top: 29px; }
.btn { border:1px solid #d1d5db; padding:8px 12px; border-radius:10px; background:#fff; cursor:pointer; }
.btn.danger { background:#ef4444; color:#fff; border-color:#ef4444; }
.btn.outline { background:transparent; color:#ef4444; }
.btn:disabled { opacity: .6; cursor: not-allowed; }
.btn.move-btn {
  background: #16a34a;
  border-color: #16a34a;
  color: #fff;
}

.toast-stack {
  position: fixed;
  top: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1400;
}
.toast {
  min-width: 240px;
  max-width: 320px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #f8fafc;
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.24);
  background: #1e293b;
}
.toast--success { background: #15803d; }
.toast--error { background: #b91c1c; }
.toast--info { background: #2563eb; }
.toast-message { flex: 1; font-size: 0.9rem; }
.toast-close {
  border: none;
  background: transparent;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.toast-enter-active, .toast-leave-active { transition: all 0.2s ease; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(-8px); }

@media (max-width: 640px) {
  .toast-stack {
    left: 16px;
    right: 16px;
    top: 16px;
  }
  .toast {
    max-width: none;
    width: 100%;
  }
  .percorso-locked-banner {
    flex-direction: column;
    align-items: flex-start;
  }
  .percorso-locked-banner__actions,
  .percorso-unlocked-banner__actions {
    width: 100%;
    justify-content: flex-start;
  }
  .percorso-locked-banner__text {
    max-width: 100%;
  }
  .percorso-locked-banner__btn {
    width: 100%;
    text-align: center;
  }
  .percorso-unlocked-banner {
    flex-direction: column;
    align-items: flex-start;
  }
  .percorso-unlocked-banner__text {
    max-width: 100%;
  }
  .percorso-unlocked-banner__btn {
    width: 100%;
    text-align: center;
  }
}

.chip { font-size:0.78rem; padding:4px 8px; border-radius:999px; border:1px solid #e5e7eb; background:#fff; }
.chip.neutral { background:#f3f4f6; }
.chip.progress { background:#fee2e2; }
.chip.done { background:#dcfce7; }
.chip-locked { background:#fee2e2; border-color:#fca5a5; color:#b91c1c; }
.chip-locked-previous { background:#fecdd3; border-color:#f43f5e; color:#7f1d1d; }
.chip-unlocked { background:#d1fae5; border-color:#22c55e; color:#065f46; }
.chip-active { background:#bbf7d0; border-color:#16a34a; color:#065f46; }

.percorso-locked .item-header {
  background: #fee2e2;
  border-left: 4px solid #f43f5e;
}
.percorso-locked .item-body {
  background: #fff1f2;
}
.percorso-locked .item-header-notifications {
  background: transparent;
  border-color: transparent;
}
.percorso-locked .notification-switch--stacked {
  align-items: flex-end;
}
.percorso-locked .toggle-slider {
  background: #e5e7eb;
  border-color: #cbd5e1;
}
.percorso-locked-previous .item-header {
  background: #fff1f2;
  border-left: 4px solid #f43f5e;
  border-color: #fecdd3;
}
.percorso-locked-previous .item-body {
  background: #fff7f8;
}
.percorso-locked-previous .item-header-notifications {
  background: transparent;
  border-color: transparent;
}
.percorso-locked-previous .notification-switch--stacked {
  align-items: flex-end;
}
.percorso-locked-previous .toggle-slider {
  background: #ffe4e8;
  border-color: #fda4af;
}
.percorso-past .item-header {
  background: #e5e7eb;
  border-left: 4px solid #1f2937;
}
.percorso-past .item-body {
  background: #f1f5f9;
}
.percorso-past .item-header-notifications {
  background: transparent;
}
.percorso-past .toggle-slider {
  background: #e5e7eb;
  border-color: #cbd5e1;
}
.percorso-completed .item-header {
  background: #fff4e5;
  border-left: 4px solid #f97316;
}
.percorso-completed .item-body {
  background: #fff7ed;
}
.percorso-completed .item-header-notifications {
  background: transparent;
}
.percorso-completed .toggle-slider {
  background: #ffe8d3;
  border-color: #fdba74;
}
.step-row--locked td {
  background: #f4f4f5 !important;
  color: #6b7280;
}
.step-row--locked .step-link span {
  color: #6b7280;
}
.percorso-locked .note-input {
  background: #f9fafb;
}
.consulenze-row--locked td {
  background: #f4f4f5 !important;
  color: #6b7280;
}
.consulenze-row--locked input,
.consulenze-row--locked select {
  background: #f9fafb;
  color: #6b7280;
}
.move-btn:hover:not(:disabled) { background:#15803d; border-color:#15803d; }
.move-btn:disabled { opacity:.7; cursor: not-allowed; }

.qi-options-grid {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}
.qi-option-alt {
  background: #eef2ff;
  color: #1f2937;
}
.qi-option-alt:hover:not(:disabled) {
  background: #e0e7ff;
}
.qi-recover-body {
  display: grid;
  gap: 12px;
  margin-bottom: 16px;
}
.qi-recover-summary {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
}
.qi-recover-summary li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
}
.qi-recover-summary li span {
  color: #64748b;
  font-weight: 600;
}

.modal {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  z-index: 1000;
}
.modal-content {
  width: min(960px, 92vw);
  max-height: calc(100vh - 48px);
  background: #ffffff;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 32px 68px rgba(15, 23, 42, 0.22);
  overflow: hidden;
  position: relative;
}
.modal-content--simple {
  padding: 26px 28px;
  gap: 18px;
}
.modal-content--simple h2 {
  margin: 0;
  font-size: 1.32rem;
  font-weight: 700;
  color: #0f172a;
}
.modal-content--simple .close {
  position: absolute;
  top: 18px;
  right: 22px;
  font-size: 24px;
  color: #475569;
  cursor: pointer;
}
.modal-content--simple form,
.modal-content--simple .button-container,
.modal-content--simple label {
  display: grid;
  gap: 12px;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 28px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.modal-title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
}
.modal-title-area {
  display: grid;
  gap: 4px;
}
.modal-header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.toolbar-btn {
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: #ffffff;
  color: #1f2937;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.toolbar-btn:hover:not(:disabled) {
  background: #eef2ff;
  border-color: #6366f1;
  color: #3730a3;
  transform: translateY(-1px);
}
.toolbar-btn--muted {
  background: #f1f5f9;
  border-color: transparent;
  color: #475569;
}
.toolbar-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.q-form {
  flex: 1;
  padding: 26px 28px;
  overflow-y: auto;
  display: grid;
  gap: 18px;
  background: #ffffff;
}
.q-field {
  display: grid;
  gap: 10px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.q-field:hover {
  border-color: #cbd5f5;
  box-shadow: 0 12px 28px rgba(148, 163, 184, 0.18);
}
.q-field--title,
.q-field--heading,
.q-field--divider {
  border: none;
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.q-heading-title {
  font-size: 1.2rem;
  font-weight: 800;
  margin: 6px 0;
  color: #0f172a;
}
.q-heading-section {
  font-size: 0.94rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 20px 0 8px;
  color: #2563eb;
}
.q-heading-description {
  font-size: 0.92rem;
  color: #475569;
  margin: 4px 0 0;
}
.q-divider {
  border: 0;
  border-top: 1px dashed rgba(148, 163, 184, 0.55);
  margin: 18px 0;
}
.q-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #0f172a;
}
.q-field input,
.q-field textarea,
.q-field select {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  color: #0f172a;
  font-size: 0.95rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.q-field textarea {
  min-height: 110px;
  resize: vertical;
}
.q-field input:focus,
.q-field textarea:focus,
.q-field select:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  outline: none;
}
.q-field .q-file {
  display: grid;
  gap: 8px;
}
.q-field .q-file .btn {
  align-self: start;
}
.q-field .up-list {
  display: grid;
  gap: 6px;
}
.q-field .up-row {
  display: grid;
  grid-template-columns: 1fr minmax(0, 140px) auto;
  gap: 8px;
  align-items: center;
  font-size: 0.82rem;
  color: #475569;
}
.q-field .up-bar {
  background: #e2e8f0;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
}
.q-field .up-prog {
  height: 100%;
  background: linear-gradient(120deg, #6366f1, #2563eb);
}
.q-field .files-grid {
  display: grid;
  gap: 12px;
}
.q-field select {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #1e293b 60%), linear-gradient(135deg, #1e293b 40%, transparent 50%);
  background-position: calc(100% - 16px) calc(50% + 1px), calc(100% - 11px) calc(50% + 1px);
  background-size: 6px 6px, 6px 6px;
  background-repeat: no-repeat;
}
.detached-consulenze-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 1px solid #fdba74;
  background: #fff7ed;
  color: #9a3412;
  border-radius: 14px;
  padding: 14px 18px;
  margin-top: 14px;
  margin-right: 13px;
}
.detached-consulenze-alert .material-icons {
  font-size: 22px;
  flex-shrink: 0;
}
.q-field input[type="checkbox"] {
  width: auto;
  margin-right: 8px;
}
.req {
  color: #ef4444;
  font-size: 0.9rem;
}
.modal-footer {
  padding: 20px 28px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.modal-footer .create-user-button,
.modal-footer .action-button2 {
  min-width: 240px;
  min-height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  box-sizing: border-box;
}
.modal-footer .consulenza-detail-footer-btn {
  flex: 0 0 240px;
  width: 240px;
  height: 56px;
  min-height: 56px;
  padding: 0 22px !important;
  line-height: 1;
  white-space: nowrap;
}
.modal-footer .action-button2 {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #1e293b;
}
.modal-footer .action-button2:hover {
  border-color: #6366f1;
  color: #3730a3;
}
.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.78rem;
}
.status-flags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.status-flag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 12px;
  color: #1f2937;
  background: #ffffff;
}
.status-flag input[type="checkbox"] {
  margin: 0;
}
.status-flag.is-active {
  border-color: #16a34a;
  background: #ecfdf3;
  color: #166534;
}
.status-flag.is-disabled {
  opacity: 0.6;
}

@media (max-width: 768px) {
  .modal {
    padding: 16px;
  }
  .modal-header {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
  }
  .modal-header-actions {
    width: 100%;
  }
  .toolbar-btn {
    width: 100%;
    text-align: center;
  }
  .modal-footer {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 8px;
  }
  .modal-footer button {
    width: 100%;
  }
}

@media (max-width: 900px) {
  .admin-col { min-width: 100%; }
  .steps-table th:nth-child(3),
  .steps-table td:nth-child(3),
  .steps-table th:nth-child(4),
  .steps-table td:nth-child(4) { white-space: nowrap; }
}
</style>
